import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'
import authFunction from '../../../authFunction'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
//import StepProgress from 'vue-step-progress';
import JQuery from 'jquery'
import { AES, enc } from 'crypto-js';
// Import Leaflet
//#rto_dto_verification
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// Import geolib
import * as geolib from 'geolib';//#rto_dto_verification
// Fix default marker icons for webpack / Vue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
//#rto_dto_verification
let $ = JQuery

import {
  BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect'

// Import component871083
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import DoughnutChart from '../../charts/DoughnutChart';
import validator from "vee-validate";
import trackingemailtracking from '../emailr/trackingemailtracking'

Vue.use(validator);

import VueAudio from 'vue-audio';

      SrProgressionBlock:null,  //#gated_pickup_enforce_7881

Vue.filter('formatDatesingle', function (value) {
  if (value) {
    // return moment((value)).format('YYYY-MM-DD HH:mm:ss')
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
  }
});

export default {
  name: 'trackshipment',
  components: {
    VueAudio,
    DoughnutChart,
    BasicSelect,
    Multiselect,
    Paginate,
    Loading,
    DatePicker,
    trackingemailtracking
  },
  data: function () {
    return {
      constantVariable,                        // #govt_proof_access
      // #alernateproof
      lastPayload: null,
      proofstatus:'',
      Verified_NPR:constantVariable.Verified_NPR,
      ndr_validation: constantVariable.ndr_validation,  
      verified_ndr :constantVariable.verified_ndr,  
      NPR_Validation: constantVariable.NPR_Validation,
      RTO_DTO_Validation: constantVariable.RTO_DTO_Validation,
      Verified_RTO_DTO_Reason: constantVariable.Verified_RTO_DTO_Reason,
      displayImageInBox: '',
      previewImageModel: false,
      // #alternateprro
      userRole: '',
      NDRCategory:'',
      oldReAttemptDate: '',
      arrayofobj: [],
      counter: 0,
      categoryCatalogue: [],
      alternateContactNo: '',
      newAlternateContactNo: '',
      IsWebLink:'',
      pageno: 0,
      pagecount: 0,
      isCallFromIVR:null,
      SrProgressionBlock:null,  //#gated_pickup_enforce_7881
      // perpage: 10,
      // Pagelist:[],
      isLoadingCurrentStatusDiv: false,
      isLoadingPagination: false,
      fullPage: false,
      filter: '',
      page: 'trackshipment',
      ticketLabel: 'Raise Ticket',
      userTypeForTicket: '',
      ARRANGED_ASSIGN_OPS_TEAM: 11,
      ADDRESS_CHANGE: 9,
      ADDRESS_UPDATED: 8,
      ASSIGNED_CS_TEAM: 14,
      ASSIGNED_OPS_TEAM: 12,
      STATUS_CHANGED: 15,
      PAYMENT_DETAILS_CHANGE_REQUESTED: 45,
      UPDATE_CONTACT_DETAILS: 17,
      UPDATE_EMAIL_ADDRESS: 97,
      UPDATE_ALTERNATE_CONTACT_NO: 98,
      GENERATE_OTP: 292,  //  #rto_dto_varification
      SEND_OTP: 378,      //  #rto_dto_varification
      CONTACT_DETAILS_UPDATED: 19,
      FAKE_NDR: 133,
      REFUSED_DOORSTEP_DELIVERY: 136,
      DELAY_IN_PICKUP_SUB_REASON: 131,
      FAKE_NPR: 119,
      FAKE_PICKUP: 120,
      DENIED_PICKUP: 121,
      CHANGE_REATTEMPT_DATE: 80,
      REATTEMPT_DATE_CHANGED: 40,
      ADDDESS_CHANGE_REQUESTED: 42,
      REQUEST_FOR_RTO_NOTIFICATION: 43,
      CHANGE_DELIVERY_PINCODE: 149,
      CHANGE_RTO_PINCODE: 150,
      CHANGE_DTO_PINCODE: 151,
      CHANGE_PICKUP_PINCODE: 152,
      fakeNdrStatus: 0,
      escalation: 0,
      ticketTaggingDisplay: true,
      ticket: {
        disabled: false
      },
      subDepartmentList: [],
      catelegoryFilteredOptions: [],
      categoryOptionObj: {
        value: '',
        text: '',
        Status: '',
        ShipmentStatus: ''
      },
      //#7419
      searchOptionsNDRList: [], //  to store combined list for dropdown
      // === NDR Valaiadtion === // - Added list , object to stores sub reason and show reattempt date picker
      subReasonNDRList: [], //  to store subreason list for dropdown
      childSubReasonList:[], // to store child subreason list for dropdown
      subNdrId: ""     ,        
      selectedNDRSubReasonObj: {  
        value: '',        
        text: ''      
      },
      ndrReattemptDateflag: false, 
      processCode:'', 
      // === End NDR Validation === // 
      searchId: '',
      //#7419
      selectedNDRReasonObj: {
        value: '',
        text: '',
        id: '',
        AssociatedNDR: '',
        AssociatedNDRTitle: ''
      },
      TYPE_ADDRESS_SPECIFIC:"AS",
      TYPE_PERSON_SPECIFIC:"PS",
      ndrId:'',
      ndrReasonListMasters: [],
      LMAllowedCodes: [], 
      arrDisplaySubTypes: [{
        'name': 'forward',
        'subtypes': [{
          'id': constantVariable.FUTURE_DELIVERY,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.SELF_COLLECT,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.URGENT_DELIVERY,
          'types': [{
            'id': constantVariable.ARRANGE_DELIVERY
          },
          {
            'id': constantVariable.CANCELLATION_REQUEST
          },
          {
            'id': constantVariable.HOLD_REASON
          }
          ]
        },
        {
          'id': constantVariable.CSAW_RTO_REATTEMPT,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          },
          {
            'id': constantVariable.HOLD_REASON
          },
          {
            'id': constantVariable.ARRANGE_DELIVERY
          }
          ]
        },
        {
          'id': constantVariable.HOLD_SUB_REASON,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.LATE_DELIVERY,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.PRICE_ISSUE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.PRODUCT_ISSUE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.DUPLICATE_ORDER,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.FAKE_ORDER,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.ODA_LOCATION,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.PURCHASED_FROM_OTHER_SOURCE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.MIND_CHANGE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.CUSTOMER_OUT_OF_STATION,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.CUSTOMER_WANT_OPEN_DELIVERY,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.DUE_TO_FAKE_UPDATE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.NEVER_ORDERED,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.COD_NOT_AVAILABLE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.SR_DEMAND_FOR_EXTRA_AMOUNT,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.ORDERED_BY_MISTAKE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.NO_SUCH_REASON,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.NOT_INTERESTED_TO_TAKE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.SR_MISBEHAVIOUR,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.INCORRECT_PINCODE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.CUSTOMER_SHIFTED,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.SOMEONE_ELSE_ORDERED,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.FORGOT_TO_APPLY_PROMOCODE,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.REFUND_PENDING_OF_PREVIOUS_ORDER,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.DEMISE_IN_FAMILY,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        }
        ]
      },
      {
        'name': 'reverse',
        'subtypes': [{
          'id': constantVariable.FUTURE_PICKUP,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.PICKUP_WITHOUT_QC,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.EXCEPTIONAL_PICKUP,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.URGENT_PICKUP,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.CSAW_DTO_REATTEMPT,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          },
          {
            'id': constantVariable.HOLD_REASON
          },
          {
            'id': constantVariable.ARRANGE_PICKUP
          }
          ]
        },
        {
          'id': constantVariable.HOLD_SUB_REASON,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_DELIVERY
          }]
        },
        {
          'id': constantVariable.QC_FAILED,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.AS_PER_CLIENT,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.PRODUCT_USED,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.PRODUCT_HANDEDOVER,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.OUT_SERVICE_AREA,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.DUPLICATE_REQUEST,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        },
        {
          'id': constantVariable.RETURN_REASON_MISMATCH,
          'types': [{
            'id': constantVariable.CANCELLATION_REQUEST
          }, {
            'id': constantVariable.HOLD_REASON
          }, {
            'id': constantVariable.ARRANGE_PICKUP
          }]
        }
        ]
      }
      ],
      category: {
        'Forward': [{
          'Status': 'Delivered',
          'ShipmentStatus': 'Delivered',
          'name': 'Delivered'
        },

        {
          'Status': 'Pending',
          'ShipmentStatus': 'ReinitiatedPickups',
          'name': 'Pending'
        },

        {
          'Status': 'Dispute',
          'ShipmentStatus': 'Inscan',
          'name': 'Dispute'
        },
        {
          'Status': 'ForwardDispute',
          'ShipmentStatus': 'Inscan',
          'name': 'Dispute'
        },
        {
          'Status': 'Dispute',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'ForwardDispute',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'Lost',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'RTODispute',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'RTOShortage',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'Shortage',
          'ShipmentStatus': 'Investigate',
          'name': 'Investigation'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': '',
          'name': 'STD'
        },
        {
          'Status': 'Lost',
          'ShipmentStatus': 'BagIn',
          'name': 'Lost'
        },
        {
          'Status': 'Lost',
          'ShipmentStatus': 'InScan',
          'name': 'Lost'
        },
        {
          'Status': 'Lost',
          'ShipmentStatus': 'Lost',
          'name': 'Lost'
        },
        {
          'Status': 'Lost',
          'ShipmentStatus': 'Overage',
          'name': 'Lost'
        },
        {
          'Status': 'NTS',
          'ShipmentStatus': 'NTS',
          'name': 'NTS'
        },
        {
          'Status': 'NTS',
          'ShipmentStatus': 'Overage',
          'name': 'NTS'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'BagIn',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'Handover',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'HVTExp',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'InScan',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'Overage',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'SAInscanPending',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'SVCInscanPending',
          'name': 'RTO Undelivered'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'BagIn',
          'name': 'Shipped'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupDone',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'Handover',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'HVTExp',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'InScan',
          'name': 'Shipped'
},
        //  b2c mark shipment invalid 
          {
            'Status': 'Invalid',
            'ShipmentStatus': 'Invalid',
            'name': 'Invalid'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'Overage',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'SAInscanPending',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'SVCInscanPending',
          'name': 'Shipped'
        },
        {
          'Status': 'Shortage',
          'ShipmentStatus': 'SAInscanPending',
          'name': 'Shipped'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'BagIn',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'InScan',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'Overage',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'STD',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'Investigate',
          'name': 'Shipped'
        },
        {
          'Status': 'RTO',
          'ShipmentStatus': 'WHHandOver',
          'name': 'WH Handover'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'Pending',
          'name': 'Pending'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'OutForPickup',
          'name': 'Not Picked'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupNotDone',
          'name': 'Not Picked'
        },
        ],
        'Reverse': [{
          'Status': 'DTO',
          'ShipmentStatus': 'WHHandOver',
          'name': 'DTO WHHandover'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'BagIn',
          'name': 'STD'
},
         // b2c mark shipment invalid 
          {
            'Status': 'Invalid',
            'ShipmentStatus': 'Invalid',
            'name': 'Invalid'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'InScan',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'Overage',
          'name': 'STD'
        },
        {
          'Status': 'STD',
          'ShipmentStatus': 'STD',
          'name': 'STD'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'Pending',
          'name': 'Not Picked'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupAssinged',
          'name': 'Not Picked'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'OutForPickup',
          'name': 'Not Picked'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupDone',
          'name': 'Pick Done'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupNotDone',
          'name': 'Not Picked'
        },
        {
          'Status': 'RPCancel',
          'ShipmentStatus': 'RPCancel',
          'name': 'Cancelled'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'PickupDoneBySR',
          'name': 'Pick Done'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'ReinitiatedPickups',
          'name': 'Not Picked'
        },
        {
          'Status': 'Pending',
          'ShipmentStatus': 'Handover',
          'name': 'Not Picked'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'Inscan',
          'name': 'DTO Undelivered'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'BagIn',
          'name': 'DTO Undelivered'
        },
        {
          'Status': 'SPCancel',
          'ShipmentStatus': 'SPCancel',
          'name': ''
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'Handover',
          'name': 'Shipped'
        },
        {
          'Status': 'Shipped',
          'ShipmentStatus': 'SVCInScanPending',
          'name': 'Shipped'
        },
        {
          'Status': 'RVPCancelledQCFail',
          'ShipmentStatus': 'RVPCancelledQCFail',
          'name': 'QC fail - Terminal'
        }
        ]
      },
      // Data for ALL category
      categoryAll: {
        'Forward': [{
            'Status': 'Delivered',
            'ShipmentStatus': 'Delivered',
            'name': 'All'
          },

          {
            'Status': 'Pending',
            'ShipmentStatus': 'ReinitiatedPickups',
            'name': 'All'
          },

          {
            'Status': 'Dispute',
            'ShipmentStatus': 'Inscan',
            'name': 'All'
          },
          {
            'Status': 'ForwardDispute',
            'ShipmentStatus': 'Inscan',
            'name': 'All'
          },
          {
            'Status': 'Dispute',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'ForwardDispute',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'RTODispute',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'RTOShortage',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'Shortage',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': '',
            'name': 'All'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'BagIn',
            'name': 'All'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'InScan',
            'name': 'All'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Lost',
            'name': 'All'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Overage',
            'name': 'All'
          },
          {
            'Status': 'NTS',
            'ShipmentStatus': 'NTS',
            'name': 'All'
          },
          {
            'Status': 'NTS',
            'ShipmentStatus': 'Overage',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'BagIn',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Handover',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'HVTExp',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'InScan',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Overage',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'SVCInscanPending',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'BagIn',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDone',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Handover',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'HVTExp',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'InScan',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Overage',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SVCInscanPending',
            'name': 'All'
          },
          {
            'Status': 'Shortage',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'BagIn',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'InScan',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'Overage',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'STD',
            'name': 'All'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'WHHandOver',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Pending',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'OutForPickup',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupNotDone',
            'name': 'All'
          },
        ],
        'Reverse': [
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupNotDone',
            'name': 'All'
          },
        ],
        'Reverse': [
          {
            'Status': 'STD',
            'ShipmentStatus': 'Investigate',
            'name': 'All'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'WHHandOver',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Pending',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'OutForPickup',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupNotDone',
            'name': 'All'
          },
        ],
        'Reverse': [
          {
            'Status': 'STD',
            'ShipmentStatus': 'STD',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Pending',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupAssinged',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'OutForPickup',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDone',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupNotDone',
            'name': 'All'
          },
          {
            'Status': 'RPCancel',
            'ShipmentStatus': 'RPCancel',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDoneBySR',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'ReinitiatedPickups',
            'name': 'All'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Handover',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Inscan',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'BagIn',
            'name': 'All'
          },
          {
            'Status': 'SPCancel',
            'ShipmentStatus': 'SPCancel',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Handover',
            'name': 'All'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SVCInScanPending',
            'name': 'All'
          },
          {
            'Status': 'RVPCancelledQCFail',
            'ShipmentStatus': 'RVPCancelledQCFail',
            'name': 'All'
          }
        ]
      },
      ticketResultMsg: '',
      ticketResultModal: false,
      Callpatching: {
        CallPatchingModal: false,
        Name: '',
        ShippingID: '',
        optNumberType: '1',
        addressType: '',
        mobileNumber: '',
        altMobileNumber: ''
      },
      submitted: false,
      checkAllSelected: true,
      OtherShipments: {
        isLoading: false,
        showChart: false,
        chartData: {
          // labels: ["Delivered", "RTO", "Undelivered"],
          labels: [],
          datasets: [{
            //   backgroundColor: ["green", "red", "yellow"],
            backgroundColor: [],
            data: []
          }]
        },
        DeliveredCnt: 0,
        DTOCnt: 0,
        NotPickedCnt: 0,
        PickDoneCnt: 0,
        CancelledCnt: 0,
        DTOUndeliveredCnt: 0,
      },
      PageTitle: 'trackshipmentsummary',
      ShipmentLogModal: false,
      isLoading: false,
      isModelLoading: false,
      ticketIDLoader: false,
      fullPage: true,
      glyphprogress: true,
      short_short_connecting_line: false,
      short_short_glyphprogress: false,
      short_glyphprogress: false,
      connecting_line: true,
      short_connecting_line: false,
      ShippingIDTypeMainDiv: false,
      MobileNumberTypeMainDiv: false,
      BagNumberTypeMainDiv: false,
      OTPDetails: {
        OTP: '',
        DelivereyOTP: '',
        OTPDiv: false,
        DeliveryOTPDiv: false,
        ShowOTPNo: false,
        showDeliveryOTPNo: false,
      },
      CustomerDetails: {
        CustomerName: '',
        EmailID: '',
        //PhoneNo: 'aed75a1fa8eb09af6210',
        PhoneNo: '',
        PhoneNoDisplay: '',
        Pincode: '',
        Address: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: '',
        AddressStr: ''
      },
      RTOAttemptCount: '',
      DTOAttemptCount: '',
      PrexoType: '',
      IsManualDelivery: false,  //#manual_delivery_4856
      EscalationType:'',  //#escalation_tag
      ShipmentType:'', // #escalation_tag
      PrexoShipment: '',
      TotalMPSCollectibleAmount:0,
      CustomerAlternateAddress: {
        CustomerName: '',
        EmailID: '',
        Pincode: '',
        Address: '',
        AddressStr: ''
      },
      RTODetails: {
        CustomerName: '',
        EmailID: '',
        PhoneNo: '',
        PhoneNoDisplay: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: '',
        AddressStr: '',
        Address: '',
        Pincode: ''
      },
      SalesDemo: {
        SenderName: '',
        ShippingID: '',
        Status: '',
        BusinessAccountName: '',
        ServiceType: '',
        ShipmentStatus: '',
        EDD: '',
        PDD: '',
        BusinessFlow: '',
        DelayedDateStr: '',
        DeliveryDateTime: '',
        ClientName: '',
        IsLatestOFD: false,
        IsCSAW: 'No',
      },
      ShipmentTransactionLogSummary: {
        ManifestDate: null,
        OriginHubID: '',
        CurrentHubID: '',
        FinalDestinationID: '',
        DataReceived: '',
        OriginHubData: '',
        BusinessFlow: '',
        currentHubData: '',
        currentHubDataLiShow: true,
        currentHubDataDivShow: true,
        currentHubDataMainDivShow: true,
        DestinationHubData: '',
        DestinationHubDataLiShow: true,
        OriginHubDataLiShow: true,
        ClientID: '',
        IsLatestManifestDataReceived: false,
        IsLatestOriginHubInScan: false,
        IsLatestCurrentHubInscanDate: false,
        IsLatestDestinationHubInscanDate: false,
        IsLatestOFD: false,
        IsLatestDeliveryDateTime: false
      },
      ShipmentLog: {
        ShipmentLogCnt: '',
        ShipmentLogDiv: '',
        ShipmentLogElement: {
          CurrentHubID: '',
          HubName: '',
          UserProcess: '',
          Comments: '',
          UserName: '',
          ProcessLocation: '',
          CreatedDate: ''
        },
        ShipmentLogBarArr: []
      },
      OrderDetails: {
        OrderNo: '',
        Quantity: '',
        OrderType: '',
        ReattemptDate: '',
        CollectibleAmount: '',
        NotificationStatus: '',
        TotalAttemptCount: '',
        LastNDR: '',
        LastCSAW: '',
        OutForDeliveryStr: true,
        EmailServiceCenter: '', // Current Hub EmailID
        InvoiceTotal: '',
        googleInitialiseData: [{
          latitude: '',
          longitude: ''
        }],
        srUserData: {
          FirstName: '',
          LastName: '',
          MobileNumber: '',
        },
        srLocationDetails: {
          srid: '',
        },
        deliveryUserID: '',
      },
      MultipleProductInfo: {
        MultipleProductInfoModal: false,
        MultipleProductInfoArr: [],
      },
      IVRCallRecording: {
        IVRCallRecordingUrlModal: false,
        AudioUrl: '',
        IVRCallRecordingBtn: false,
        IVRCallRecordingModal: false,
        IVRCallRecordingArr: [],
        IVRCallPatchingBtn: false,
      },
      map: [],
      locationMapModal: false,
      displayCurrentLocation: '',
      OtherShipmentLogArr: [],
      poIdShipmentArr: [],
      POIDTypeMainDiv: false,
      AllShipmentLogArrData: [],
      AllShipmentLogArrData1: [],
      UnCategorizedArrData: [],
      OtherShipmentLogCnt: '',
      RaiseTicketDiv: false,
      OtherShipmentShippingIDCheckedArr: [],
      allSelected: false,
      Role: {
        roleid: '',
        rolename: ''
      },
      SelectTypeOptionArr: [{
          value: 'ShippingID',
          text: 'Shipping ID'
        },
        //#ip_track MobileNumber disable search
        // {
        //   value: 'MobileNumber',
        //   text: 'Mobile Number'
        // },
        // {
        //   value: 'FlyerBarcode',
        //   text: 'Flyer Barcode'
        // },
        // {
        //   value: 'BagNumber',
        //   text: 'Bag Number'
        // },
        {
          value: 'TicketID',
          text: 'Ticket ID'
        },
        // rollback #track_security_7627
        // {
        //   value: 'ClientOrderID',                           //track_security_7627
        //   text: 'Client Order ID'
        // },
        // {
        //   value: 'POID',
        //   text: 'Client Order ID'
        // },
      ],
      //track_security_7627
       SelectReasonOptionArr: constantVariable.SELECT_REASON_OPTIONS,
      SelectTypeOptionObj: {
        value: 'ShippingID',
        text: 'Shipping ID'
      },
      //track_security_7627 start
      SelectReasonOptionObj: {
        value: 'CustomerTicket',
        text: 'Customer Ticket'
      },
      SearchPurpose: '',
      ClientOrderIDArr: [],
      ClientOrderIDObj: {
        value: '',
        text: ''
      },
      clientData: [],
      ClientOrderIDAWBModal: false,
      SearchedOrderID: '',
      OrderIDAWBArr: [],
      SelectedAWBObj: {
        value: '',
        text: ''
      },
      search: {
        client: ''
      },
      //track_security_7627 End
      BagNoObj: { //
        BagDetails: {},
        AuditLogArr: [],
        TransitStatusArr: [],
        TransitStatusModal: false,
        BagShipmentDetailsModal: false,
        BagInShipmentCount: 0,
        BagShipmentDetailsArr: [],
      },

      ShippingID: '',
      Ticketmodal: false,
      tableShipment: false,
      ticketShipmentData: [],
      ticketExistedData: [],
      ticketIDS: [],
      shipmentTickets: [],
      ticket: {},
      username: '',
      mobileNumber: '',
      ticketId: '',
      source: [],
      sourceId: '',
      selectedSourceObj: {
        value: '',
        text: ''
      },
      ticketType: [],
      ticketTypeId: '',
      selectedTicketObj: {
        value: '',
        text: ''
      },
      reason: [],
      reasonId: '',
      selectedReasonObj: {
        value: '',
        text: ''
      },
      subReason: [],
      subReasonId: '',
      selectedSubReasonObj: {
        value: '',
        text: ''
      },
      action: [],
      actionId: '',
      selectedActionObj: {
        value: '',
        text: ''
      },
      ticketStatus: [],
      ticketStatusId: '',
      selectedTicketStatusObj: {},
      searchOptions: [],
      shippingIdDetails: [],
      searchId: '',
      selectedSearchObj: {
        value: '',
        text: ''
      },
      reAttemptDate: '',
      mobileNo: '',
      startDate: new Date(),
      endDate: new Date(),
      validated: false,
      shortcuts: [{
        text: 'Today',
        startDate: new Date()
      }],
      format: 'YYYY-MM-DD',
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      address: '',
      location: '',
      pincode: '',
      orderType: [{
        value: 'cod/prepaid',
        text: 'COD <> Prepaid'
      }],
      orderTypeId: '',
      selectedOrderTypeObj: {
        value: '',
        text: ''
      },
      netPayment: '',
      comments: '',
      email: '',
      userid: '',
      DepartmentID: '',
      DepartmentName: '',
      SummaryOptionObj: [],
      SummarySelectOptionObj: {
        value: '',
        text: ''
      },
      SendSMS: {
        submitted: false,
        SendSMSModal: false,
        ActualSMSCode: "",
        SendSMSArr: [],
        Message: "",
        SelectedSendSMSObj: {
          value: '',
          text: ''
        },
        SMSData: [],
        SendSMSKey: "xbsndvT",
        ReasonArr: [],
        Reason: "",
        SelectedReasonObj: {
          value: '',
          text: ''
        }
      },
      CallTypeOptionObj: [],
      CallType: '',
      resultTicket: [],
      TicketLogModal: false,
      listExisitngTicketModal: false,
      updateExistingBulkTicket: false,
      showBulkTicketDiv: false,
      ticketIDLog: '',
      selectAllRecord: false,
      newReAttemptDate: '',
      newAddress: '',
      newPincode: '',
      newEmailAddress: '',
      payMethods: [{
        text: 'COD',
        value: 1
      },
      {
        text: 'Prepaid',
        value: 2
        }
      ],
      selectedMethodObj: {
        value: '',
        text: ''
      },
      methodId: '',
      disPayment: false,
      disPaymentMethod: false,
      emailTrackingModal: false,
      isModalLoading: false,
      emailCasesArray: [],
      emailCasesArrayForUpdate: [],
      totalCount: 0,
      totalcount0Div: false,
      SRIDs : [],
      SRIDsId : '',
      selectedSRIDnObj : {},
      SRNames : [],
      SRNameId : '',
      selectedSRNamenObj : {},
      shouldShowLabel: false,
      srid : '',
      srname : '',
      primaryContactNo: '',            //  #rto_dto_varification
    //#rto_dto_verification
    shouldShowSRLabel: false,
    showBICModal: false,
    //#rto_dto_verification
    UAPayload : {
      RTODTOFeature: 'N', // Y/N (OFD and subdepartment - 285)
      vendorId: '', // SellerId
      eventType: '',
      vendorGroupNo: '',
      srId: '', // deliveryUserID
      sellerMobileNumber: '', // from GetShipmentSummary / UA payload
      shipmentType: '',
      podSubmitPayload: {},
      distanceToSeller : '',
      TotalDeliveredCount: 0,
      TotalUndeliveredCount: 0,
      isRetry: false,
      vendorGroupIds: [] // for multiple vendor group support
    },
    showHandoverModal:false,
    shipmentDetails:[],
    aggregateTotal:0,
    batchCount:0,
    credibilityData: {},
    geofenceMap: null,
    // modal toggle for SR geofence view
    showMapModal: false,
    geofenceData: {
      sellerLocation: { lat: null, lng: null },
      srLocation: { lat: null, lng: null },
      geofenceRadius: 0,
      distance: 0,
      isOutsideGeofence: false,
      isInsideGeoFence: false,
      lastGeoPing: '',
      sellerGeoConfidence: '',
      batchID: 0
    },
    //#rto_dto_verification
    }
  },
  created: function () {
    if (this.$route.params.type && this.$route.params.type === "M") {
      this.SelectTypeOptionObj.value = "MobileNumber";
      this.SelectTypeOptionObj.text = "Mobile Number";
    } else if (this.$route.params.type && this.$route.params.type === "B") {
      this.SelectTypeOptionObj.value = "BagNumber";
      this.SelectTypeOptionObj.text = "Bag Number";
    } else {
      // empty else
    }
    if (this.$route.params.id) {
      this.ShippingID = this.$route.params.id;
      this.$router.push({
        path: '/trackshipmentsummary',
      })
      this.getTrackShipmentSummeryDetails();
      this.resetForm();
    }
  },
  computed: {
    // track_security_7627 tooltip text for search reason dropdown
    remarksTooltipText() {
      const tooltipMap = {
        'CustomerTicket': 'Review existing ticket / Create new ticket.',
        'CustomerEmail': 'Required for customer communication !',
        'ClientTrackingRequest': 'Shipment status check',
        'ClientChangeRequest': 'Changes requested: email subject',
        'Others': 'Please provide specific details about your search reason.'
      };
      return tooltipMap[this.SelectReasonOptionObj.value] || 'Please provide specific details about your search reason.';
    },
  // #rto_dto_varification  start -------
    // Handle auto-populate and manual edit for Primary Contact Number
    primaryContactNoComputed: {
      get() {
        // Return user-entered value if available
        if (this.primaryContactNo !== '') {
          return this.primaryContactNo;
        }

        // If user cleared the field after editing, keep it blank
        if (this.primaryContactNo === '' && this.isPrimaryEdited) {
          return '';
        }

        // Auto-populate from UA payload on initial load
        return (this.UAPayload && this.UAPayload.sellerMobileNumber) || '';
      },

      set(value) {
        // Update value and mark field as edited
        this.primaryContactNo = value;
        this.isPrimaryEdited = true;
      }
    }
    // #rto_dto_varification  end -------
  },

  mounted() {
    [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
    this.accessRestrictor();
    this.Role.roleid = this.userdetail[0].roles[0].roleid;
    this.userRole = this.Role.rolename = this.userdetail[0].roles[0].rolename;

    this.OrderDetails.googleInitialiseData[0].latitude = 18.545885;
    this.OrderDetails.googleInitialiseData[0].longitude = 73.908419;
    this.displayCurrentLocation = '';
    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].email;
    this.email = this.userdetail[0].email;
    this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
    this.firstname = this.userdetail[0].FirstName;
    this.lastname = this.userdetail[0].LastName;
    this.mobileNumber = this.userdetail[0].MobileNumber;
    //  this.getDepartmentNameFromId(); // not in use
		this.getClientList();
    this.getAccessToIVRCallRecording();

    // Disable right-click context menu for this component only
    this.$nextTick(() => {
      this.disableRightClick = (e) => {
        e.preventDefault();
        return false;
      };
      document.addEventListener('contextmenu', this.disableRightClick);
      
      // track_security_7627 Disable keyboard shortcuts for inspect element and view source
      this.disableKeyboardShortcuts = (e) => {
        // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
        if (e.keyCode === 123 || 
            (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || 
            (e.ctrlKey && e.keyCode === 85)) {
          e.preventDefault();
          return false;
        }
      };
      document.addEventListener('keydown', this.disableKeyboardShortcuts);
    });


  },
  beforeDestroy() {
    // track_security_7627 Remove right-click event listener
    if (this.disableRightClick) {
      document.removeEventListener('contextmenu', this.disableRightClick);
    }
    // track_security_7627 Remove keyboard shortcuts event listener
    if (this.disableKeyboardShortcuts) {
      document.removeEventListener('keydown', this.disableKeyboardShortcuts);
    }
    //#rto_dto_verification Remove geofence map event listeners and instance
    // Clean up geofence map
    if (this.geofenceMap) {
      google.maps.event.clearInstanceListeners(this.geofenceMap);
      this.geofenceMap = null;
    }
  },
  methods: {


    //#rto_dto_verification

    setUApayloadFlag() {

      if (
        constantVariable.RTO_DTO_Verfication === this.DepartmentID &&
        this.SalesDemo.UserProcess.toLowerCase() === 'out for delivery'
      ) {
        this.UAPayload.RTODTOFeature = 'Y';
        this.getUAPayload() 
      } else {
        this.UAPayload.RTODTOFeature = 'N';
      }
    
    },
   
  prepareGeofenceData() {
    if (!this.UAPayload || !this.UAPayload.podSubmitPayload) {
      // console.log("UA Payload not available for geofence");
      return;
    }

    const payload = this.UAPayload.podSubmitPayload;

    this.geofenceData = {
      sellerLocation: {
        lat: parseFloat(payload.vendorLatitude) || 0,
        lng: parseFloat(payload.vendorLongitude) || 0
      },
      srLocation: {
        lat: parseFloat(payload.srLatitude) || 0,
        lng: parseFloat(payload.srLongitude) || 0
      },
      geofenceRadius: parseInt(payload.geoRadiusRtoDto) || '',
      sellerGeoConfidence: payload.vendorGeoConfidence || "NA",
      isInsideGeoFence: payload.podSubmitPayload.isInsideGeoFence, // true if outside
      lastGeoPing: ""
    };
    
    const distance = this.calculateSellerSRDistance();
    this.geofenceData.distance = distance;
    this.UAPayload.distanceToSeller = distance;

    // console.log("Geofence Data Prepared:", this.geofenceData);
  },



calculateSellerSRDistance() {
  const { sellerLocation, srLocation } = this.geofenceData;

  const sellerLat = Number(sellerLocation.lat);
  const sellerLng = Number(sellerLocation.lng);
  const srLat = Number(srLocation.lat);
  const srLng = Number(srLocation.lng);

  const distance = geolib.getPreciseDistance(
    { latitude: sellerLat, longitude: sellerLng },
    { latitude: srLat, longitude: srLng }
  );

  // Match APAP rounding (2 decimal places)
  // console.log(`Calculated distance: ${distance} meters (Seller: ${sellerLat}, ${sellerLng} | SR: ${srLat}, ${srLng})`);
  return distance;
},
  async loadGeofenceMap() {
    try {
  
      const { sellerLocation, srLocation, geofenceRadius } = this.geofenceData;
      const last5SellerHandoverLocatons = (this.credibilityData.last5SellerHandoverLocatons || []);
  
      // Convert to numbers
      const sellerLat = parseFloat(sellerLocation.lat);
      const sellerLng = parseFloat(sellerLocation.lng);
      const srLat = parseFloat(srLocation.lat);
      const srLng = parseFloat(srLocation.lng);
  
      // console.log("Seller:", sellerLat, sellerLng);
      // console.log("SR:", srLat, srLng);
      // console.log("Handover raw:", last5SellerHandoverLocatons);
  
      // Validate coordinates
      if (
        isNaN(sellerLat) || isNaN(sellerLng) ||
        isNaN(srLat) || isNaN(srLng)
      ) {
        this.$alertify.error("Invalid location data");
        this.closeGeofenceMap();
        return;
      }
  
      const mapElement = document.getElementById("geofenceMap");
      if (!mapElement) return;
  
      // Remove previous map
      if (this.geofenceMap) {
        this.geofenceMap.remove();
        this.geofenceMap = null;
      }
  
      // Initialize map
      const map = L.map(mapElement).setView([sellerLat, sellerLng], 15);
      this.geofenceMap = map;
  
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(map);
  
      // Icons
      const sellerIcon = L.icon({
        iconUrl: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      });
  
      const srIcon = L.icon({
        iconUrl: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      });
  
      // Seller marker
      L.marker([sellerLat, sellerLng], { icon: sellerIcon })
        .addTo(map)
        .bindPopup("Seller Location");
  
      // SR marker
      L.marker([srLat, srLng], { icon: srIcon })
        .addTo(map)
        .bindPopup("SR Current Location");
  
      //  Safe handover points
      const validHandoverPoints = [];
  
      last5SellerHandoverLocatons.forEach(loc => {
        const lat = parseFloat(loc.lat);
        const lng = parseFloat(loc.long);
  
        if (
          !isNaN(lat) &&
          !isNaN(lng) &&
          lat >= -90 && lat <= 90 &&
          lng >= -180 && lng <= 180
        ) {
          try {
            L.circle([lat, lng], {
              color: "green",
              fillColor: "green",
              fillOpacity: 0.6,
              radius: 3,
              weight: 1
            }).addTo(map);
  
            validHandoverPoints.push([lat, lng]);
          } catch (e) {
            console.warn("Invalid handover skipped:", lat, lng);
          }
        }
      });
  
      // console.log("Valid handover:", validHandoverPoints);

      //  Distance (Seller → SR)
      const actualDistance = map.distance(
        [sellerLat, sellerLng],
        [srLat, srLng]
      );
  
      const isInside = actualDistance <= geofenceRadius;
  
      //  Geofence circle
      if (geofenceRadius > 0) {
        L.circle([sellerLat, sellerLng], {
          radius: geofenceRadius,
          color: "#4285F4",
          fillColor: "#4285F4",
          fillOpacity: 0.1,
          weight: 2
        }).addTo(map);
      }
  
      //  Dotted line (Seller → SR)
      L.polyline(
        [
          [sellerLat, sellerLng],
          [srLat, srLng]
        ],
        {
          color: isInside ? "green" : "red",
          weight: 2,
          dashArray: "5,10"
        }
      ).addTo(map);
  
      //  Distance label (center of seller & SR)
      const boundsForCenter = L.latLngBounds([
        [sellerLat, sellerLng],
        [srLat, srLng]
      ]);
  
      const center = boundsForCenter.getCenter();
  
      if (!isNaN(center.lat) && !isNaN(center.lng)) {
        L.marker([center.lat, center.lng], {
          icon: L.divIcon({
            className: "distance-label",
            html: `<div style="
              white-space: nowrap;
              padding: 2px 6px;
              font-size: 14px;
              font-weight: bold;
              color: black;
              text-align: center;">
              ${Math.round(this.geofenceData.distance)} meters
            </div>`,
            iconSize: [100, 30],
            iconAnchor: [50, 15]
          })
        }).addTo(map);
      }
  
      //  FINAL ZOOM (SAFE - no flyTo)
      const allPoints = [
        [sellerLat, sellerLng],
        [srLat, srLng],
        ...validHandoverPoints
      ];
  
      const bounds = L.latLngBounds(allPoints);
  
      map.fitBounds(bounds, {
        padding: [100, 100],
        maxZoom: 18
      });
  
      //  Update reactive data
      // this.geofenceData.distance = actualDistance;
      this.geofenceData.isInsideGeoFence = isInside;
      this.geofenceData.isOutsideGeofence = !isInside;
      this.geofenceData.lastGeoPing = new Date().toLocaleTimeString();
  
    } catch (err) {
      // console.error("MAP ERROR:", err);
      this.$alertify.error("Failed to load map");
      this.closeGeofenceMap();
    }
  },
  closeGeofenceMap() {
    // Remove the Leaflet map if it exists
    if (this.geofenceMap) {
      this.geofenceMap.remove();
      this.geofenceMap = null;
    }
  
    // Hide the modal
    this.showMapModal = false;
  },
    openSRGeofenceMap() {
      try {
        // Check if user's department is rto_dto_verification (285)
        if (this.DepartmentID !== constantVariable.rto_dto_verification) {
          this.$alertify.error(constantVariable.UNAUTORISED_USER_MSG);
          return;
        }
        // display the SR geofence modal and load latest details
        this.showMapModal = true;
        // once the DOM is updated execute the map load routine
        this.$nextTick(() => {
          this.loadGeofenceMap();
        });
      } catch (error) {
        this.showMapModal = false;
        let msg = error + " - openSRGeofenceMap";
        this.$alertify.error(msg);
      }
    },
    getUAPayload() {
      // console.log(this.ShippingID, "this.ShippingID============");
    
      if (!this.ShippingID) {
        console.log("ShippingID not available");
        return;
      }
    
      const payload = { shippingid: this.ShippingID };
    
      axios({
        method: "POST",
        url: apiUrl.api_url + "getUAPayload",
        data: payload,
        headers: commonFunction.getusertoken(),
      })
      .then(result => {
    
        // console.log(result, "getUAPayload result");
    
        const response = result.data.data;
    
        // Handle no record case
        if (!response.status) {
          this.$alertify.error(response.msg); 
          return;
        }
    
        const uaData = response.data;
    
        // console.log(uaData.PODSubmitPayload.podSubmitPayload.DeliveryUserID, "uaData");
          //#rto_dto_verification vendor id format changes 
        const vendorId = String(uaData.vendorId).includes("UA") ? String(uaData.vendorId).split("UA")[0] : uaData.vendorId;

        this.UAPayload = Object.assign({}, this.UAPayload, {
          vendorId: vendorId ,  //#rto_dto_verification 
          eventType: uaData.eventType || '',
          vendorGroupNo: uaData.vendorGroupNo ? uaData.vendorGroupNo : '',
          srId: uaData.PODSubmitPayload ? uaData.PODSubmitPayload.podSubmitPayload.DeliveryUserID : '',
          sellerMobileNumber: this.RTODetails? this.RTODetails.PhoneNo : '',
          shipmentType: uaData.shipment_type || '',
          podSubmitPayload: uaData.PODSubmitPayload || {},
          TotalDeliveredCount: uaData.PODSubmitPayload.podSubmitPayload? Number(uaData.PODSubmitPayload.podSubmitPayload.TotalDeliveredCount) : 0,
          TotalUndeliveredCount:uaData.PODSubmitPayload.podSubmitPayload? Number(uaData.PODSubmitPayload.podSubmitPayload.TotalUndeliveredCount ): 0,
        });

        this.prepareGeofenceData();

        this.getLocationMapAndSrPerformance();
    
        // console.log("UA Payload:", this.UAPayload);
    
      })
      .catch(error => {
        console.error("Error in getUAPayload:", error);
        this.$alertify.error("Failed to fetch Seller UA Payload");
      });
    },
// Fetch SR performance and last 5 handover locations from Last Mile (LM) API
getLocationMapAndSrPerformance() {

  // Check if ShippingID is available before calling API
  if (!this.ShippingID) {
    console.log("ShippingID not available");
    return;
  }

  var payload = {
    sellerId: this.UAPayload.vendorId,
    deliveryUserID: this.UAPayload.podSubmitPayload.podSubmitPayload.DeliveryUserID
  };

  axios({
    method: "POST",
    url: apiUrl.api_url + "getLocationMapFromLM",
    data: payload,
    headers: commonFunction.getusertoken()
  })
  .then((result) => {

    // Validate API response
    if (!result.data || !result.data.data || !result.data.data.data || !result.data.data.data.data) {
      this.$alertify.error("Location validation data not available");
      return;
    }

    // Extract actual LM response payload
    var srAnalyticsData = result.data.data.data.data;

    var currentSRSpecific = parseFloat(srAnalyticsData.srSellerHandoverRate || 0);
    var currentSRAll = parseFloat(srAnalyticsData.srAllSellerHandoverRate || 0);
    var sellerBenchmark = parseFloat(srAnalyticsData.sellerAcceptanceP90 || 0);

    // Calculate the highest SR performance between seller-specific and overall
    var maxSRScore = Math.max(currentSRSpecific, currentSRAll);

    var credibilityGap = sellerBenchmark - maxSRScore;
    credibilityGap = credibilityGap.toFixed(2);
    var riskLabel = "";
    if (credibilityGap > 15) {
      riskLabel = "HIGH RISK";
    } else if (credibilityGap < 0) {
      riskLabel = "LOW RISK";
    }

    // Tooltip explanation shown in UI
    var tooltipText =
      "• Gap > 15% (High risk): SR is materially below expected performance. High probability of fake NDR / non-compliance.\n" +
      "• Gap < 0% (Low risk): SR is overperforming the benchmark. Seller is likely rejecting intentionally.";

    // Convert last 5 handover locations to proper numeric lat/lng format
    var last5Locations = this.convertHandoverLocations(srAnalyticsData.last5HandoverGeo);

    this.credibilityData = {
      sellerBenchmark: sellerBenchmark,
      maxSRScore: maxSRScore,
      credibilityGap: credibilityGap,
      riskLabel: riskLabel,
      tooltip: tooltipText,
      last5SellerHandoverLocatons: last5Locations
    };

  })
  .catch((error) => {

    // Handle API errors gracefully
    console.error("Error in getLocationMapAndSrPerformance:", error);

    if (error.response && error.response.data) {
      this.$alertify.error(error.response.data.message || "Failed to fetch Location Validation data");
    } else {
      this.$alertify.error("Location Validation service is currently unavailable");
    }

  });
},

// Convert LM location response into usable map coordinates
convertHandoverLocations(locations) {

  //hardcoded locations for testing when LM API doesn't return valid data or during development
  if (!locations || !locations.length) {
    return [];
  }

  return locations.map(function(loc) {
    return {
      VendorGroupNo: loc.VendorGroupNo,
      ShippingID: loc.ShippingID,
      lat: Number(loc.Latitude),
      long: Number(loc.Longitude)
    };
  });

},
    openHandoverSession(){

      if(!this.UAPayload.podSubmitPayload.podSubmitPayload.shipmentDetails){
        this.$alertify.error("No Handover Data Available")
        return
      }
    
      const details = this.UAPayload.podSubmitPayload.podSubmitPayload.shipmentDetails
    
      this.shipmentDetails = []
   
      this.aggregateTotal = 0
    
      details.forEach(item => {
    
        const total = item.awbs ? item.awbs.length : 0
    
        this.shipmentDetails.push({
          vendorGroupNo: item.vendorGroupNo,
          total: total
        })
    
        this.aggregateTotal += total
    
      })
    
      this.batchCount = this.shipmentDetails.length
    
      this.showHandoverModal = true
    },
    closehandover(){

      this.showHandoverModal = false
   },
    //#rto_dto_verification

// Seller Escalation 7449 -- start
getEscalatedShipmentStatus(shippingId) {
  const payload = { shippingid: shippingId };

  axios({
    method: "POST",
    url: apiUrl.api_url + "getEscalatedShipmentStatus",
    data: payload,
    headers: commonFunction.getusertoken(),
  })
    .then(result => {
      this.isLoading = false;

      const dataLayer = result && result.data && result.data.data;
      const responseData = dataLayer && dataLayer.data ? dataLayer.data : null;
      let pickupEscalation = "";

      if (responseData && responseData.PickupEscalation) {
        pickupEscalation = responseData.PickupEscalation;
      }

      if (pickupEscalation === "Y") {
        this.EscalationType = "Pickup Escalation";
      } else {
        this.EscalationType = "";
      }
    })
    .catch(error => {
      this.isLoading = false;
      this.EscalationType = "";
      console.error("Error in getEscalatedShipmentStatus:", error);
      this.$alertify.error("Something went wrong while fetching escalation details.");
    });
},
// Seller Escalation 7449 -- End
    getEmailCasesForUpdate: function (ShippingId) {
      // console.log( 'getEmailCasesForUpdate' );
      let getObj = {
        shippingid: ShippingId
      }
      Object.keys(getObj).forEach((key) => {
        if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
          delete getObj[key]
        }
      })
      this.isModalLoading = true
      return axios({
        'method': 'POST',
        'url': apiUrl.api_url + 'getallemailcasebyshippingid',
        headers: commonFunction.getusertoken(),
        'data': getObj
      }).then((result) => {

        this.isModalLoading = false
        this.emailCasesArrayForUpdate = []

        if (result.data.rows && result.data.rows.length) {

          // this.getTotalPages(Number(result.data.count))
          //let finalResult = stores.user.setStatusWiseCSS(result.rows)
          let finalResult = result.data.rows;
          this.emailCasesArrayForUpdate = finalResult;

        }


      }).catch((httpException) => {
        this.isModalLoading = false
        return this.$alertify.error(httpException.message)
      })
    },

    getEmailCasesByShipmentId: function (ShippingId) {
      // console.log( 'getEmailCasesByShipmentId' );
      this.totalcount0Div = false;
      let getObj = {
        shippingid: ShippingId
      }
      Object.keys(getObj).forEach((key) => {
        if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
          delete getObj[key]
        }
      })
      this.isModalLoading = true
      this.selectedRows = [];
      return axios({
        'method': 'POST',
        'url': apiUrl.api_url + 'getallemailcasebyshippingid',
        headers: commonFunction.getusertoken(),
        'data': getObj
      }).then((result) => {

        this.isModalLoading = false
        this.emailCasesArray = []
        this.totalCount = 0

        if (result.data.rows && result.data.rows.length) {

          this.totalCount = Number(result.data.count)
          // this.getTotalPages(Number(result.data.count))
          //let finalResult = stores.user.setStatusWiseCSS(result.rows)
          let finalResult = result.data.rows;
          this.emailCasesArray = finalResult;

        }

        if (Number(result.data.count) == 0) {
          this.totalcount0Div = true;
        }

      }).catch((httpException) => {
        this.isModalLoading = false
        return this.$alertify.error(httpException.message)
      })
    },

    trigger: function () {
      this.OnFilterClick();
    },

    resetUpdateTicketModal() {
      this.selectAllRecord = false;
      this.ticketIDS = [];
      this.ticketExistedData = [];
    },

    openUpdateTicketModal() {

      if (this.ticketIDS.length == 0) {
        this.$alertify.error('Please select ticket.');
        return false;
      }
      this.ticketLabel = '';
      this.updateExistingBulkTicket = false;
      this.showBulkTicketDiv = true;
      this.source = [];
      this.ticketType = [];
      this.reason = [];
      this.subReason = [];


      if (this.ticketExistedData.length == 1) {
        this.newReAttemptDate = this.reAttemptDate ? this.reAttemptDate : this.ticketExistedData[0].shippingData.reattemptdate;
        this.newAddress = this.ticketExistedData[0].shippingData.address;
        this.newPincode = this.ticketExistedData[0].shippingData.pincode;
        this.orderTypeId = this.ticketExistedData[0].shippingData.ordertype;
        this.netPayment = this.ticketExistedData[0].shippingData.netpayment;
        this.newAlternateContactNo = this.ticketExistedData[0].shippingData.alternatecontactnumber;
        this.newEmailAddress = this.ticketExistedData[0].shippingData.emailaddress;
      } else {
        let intTicketDataLength = this.ticketExistedData.length;
        let boolIsMultipleSource = false;
        if (intTicketDataLength > 1) {

          for (let i = 0; i < intTicketDataLength; i++) {

            if (this.ticketExistedData[0].shippingData.sourceid != this.ticketExistedData[i].shippingData.sourceid) {
              boolIsMultipleSource = true;
              break;
            }
          }

          if (true == boolIsMultipleSource) {
            this.selectedSourceObj.text = "Multiple";
            this.selectedSourceObj.value = "Multiple";
          }
        }
      }
      this.selectedTicketStatusObj = {
        text: '',
        value: ''
      };
      this.ticketStatus = [];
      this.ticketStatusId = '';
      this.action = [];
      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      if (this.subReasonId == 44) {
        var method = {
          value: '',
          text: ''
        };
        if (this.ticketExistedData[0].shippingData.ordertype == 'PrePaid') {
          method = {
            value: 2,
            text: 'Prepaid'
          };
          this.selectedMethod(method);
        } else {
          method = {
            value: 1,
            text: 'COD'
          };
          this.selectedMethod(method);
        }
      }
      this.disPayment = true;
      this.disPaymentMethod = true;

      this.getTicketAction(this.subReasonId, 'Edit');


    },

    selectTicket(selectedObj, index, event) {
      this.allSelected = false;
      if (event.target.checked) {
        this.ticketExistedData.push({
          'index': index, // 'shippingData': selectedObj
          'shippingData': {
            'shippingid': selectedObj.shippingid,
            'ticketid': selectedObj.ticketid,
            'sourceid': selectedObj.sourceid,
            'tickettypeid': selectedObj.tickettypeid,
            'reasonid': selectedObj.reasonid,
            'subreasonid': selectedObj.subreasonid,
            'ticketstatus': selectedObj.ticketstatus,
            'hub': selectedObj.hub,
            'attempts': selectedObj.attempts,
            'comments': selectedObj.comments,
            'businessflow': selectedObj.businessflow
          }
        });

        let intPosition = this.ticketExistedData.findIndex(o => o.index == index);

        if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
          (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
          (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in connection') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

          this.ticketExistedData[intPosition].shippingData.reattemptdate = selectedObj.reattemptdate;
        }

        if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
          this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
          this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

          this.ticketExistedData[intPosition].shippingData.name = selectedObj.name;
          this.ticketExistedData[intPosition].shippingData.address = selectedObj.address;
          this.ticketExistedData[intPosition].shippingData.pincode = selectedObj.pincode;
        }

        if (this.selectedSubReasonObj.text == 'Change payment mode / amount' || this.selectedSubReasonObj.text=='Change reverse amount') {

          this.ticketExistedData[intPosition].shippingData.ordertype = selectedObj.ordertype;
          this.ticketExistedData[intPosition].shippingData.netpayment = selectedObj.netpayment;
          
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

          this.ticketExistedData[intPosition].shippingData.alternatecontactnumber = selectedObj.alternatecontactnumber;
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

          this.ticketExistedData[intPosition].shippingData.emailaddress = selectedObj.emailaddress;
        }

      } else {
        this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == index), 1);
      }

    },

    selectAllCheckbox() {
      //this.rackIds = [];
      if (this.selectAllRecord) {
        var i = 0;

        for (let indexId in this.ticket) {

          if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) == -1) {
            this.ticketIDS.push(this.ticket[indexId].ticketid);

            this.ticketExistedData.push({
              'index': i, // 'shippingData': this.shipmentTickets[indexId],
              'shippingData': {
                'shippingid': this.ticket[indexId].shippingid,
                'hub': this.ticket[indexId].hub,
                'attempts': this.ticket[indexId].attempts,
                'comments': this.ticket[indexId].comments,
                'businessflow': this.ticket[indexId].businessflow
              }

            });

            if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
              (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in connection') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

              this.ticketExistedData[indexId].shippingData.reattemptdate = this.ticket[indexId].reattemptdate;
            }

            if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
              this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
              this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

              this.ticketExistedData[indexId].shippingData.name = this.ticket[indexId].name;
              this.ticketExistedData[indexId].shippingData.address = this.ticket[indexId].address;
              this.ticketExistedData[indexId].shippingData.pincode = this.ticket[indexId].pincode;
            }

            if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

              this.ticketExistedData[indexId].shippingData.ordertype = this.ticket[indexId].ordertype;
              this.ticketExistedData[indexId].shippingData.netpayment = this.ticket[indexId].netpayment;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

              this.ticketExistedData[indexId].shippingData.alternatecontactnumber = this.ticket[indexId].alternatecontactnumber;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

              this.ticketExistedData[indexId].shippingData.emailaddress = this.ticket[indexId].emailaddress;
            }
          }
          i++;
        }
      } else {
        for (let indexId in this.ticket) {
          if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) >= 0) {

            this.ticketIDS.splice(this.ticketIDS.indexOf(this.ticket[indexId].ticketid), 1);
            this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == this.ticket[indexId].indexId), 1);
          }
        }
      }

    },
    /* Start IVRCallRecording functionality*/

    getAccessToIVRCallRecording() {
      var permissiondataEncrypt = window.localStorage.getItem('permissiondata');
      var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var permissiondata = JSON.parse(plaintext);
      let trackshipmentArr = permissiondata.filter(function (val) {
        return val.url == "/trackshipmentsummary";
      });
      let childrenArr = trackshipmentArr[0].children;

      if (childrenArr.some(rowObj => rowObj.url == "/IVRCallRecording")) {
        this.IVRCallRecording.IVRCallRecordingBtn = true;
      } else {
        this.IVRCallRecording.IVRCallRecordingBtn = false;
        // console.log("No access to IVR Call Recording - Object not found." + JSON.stringify(childrenArr));
      }

      // IVRCallPatching Access
      if (childrenArr.some(rowObj => rowObj.url == "/SIP Trunk") || childrenArr.some(rowObj => rowObj.url == "/GSM Gateway")) {
        this.IVRCallRecording.IVRCallPatchingBtn = true;
      } else {
        this.IVRCallRecording.IVRCallPatchingBtn = false;
        // console.log("Component Base access trackshipmentsummary" + JSON.stringify(childrenArr));
      }
      // {"id":"427","name":"SIP Trunk","url":"/SIP Trunk","icons":"SIP Trunk","sequence":1,"ismenu":false,"parentid":174,"children":[]},{"id":"428","name":"GSM Gateway","url":"/GSM Gateway","icons":"GSM Gateway","sequence":2,"ismenu":false,"parentid":174,"children":[]},{"id":"648","name":"IVR Call Recording","url":"/IVRCallRecording","icons":"IVRCallRecording","sequence":3,"ismenu":true,"parentid":174,"children":[]}]

    },

    showIVRCallRecordingModal() {
      try {
        this.IVRCallRecording.IVRCallRecordingArr = [];
        //  let ShippingID = this.ShippingID;
        let ShippingID = 11120514030;
        this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'GET',
            url: apiUrl.crmivr_url + 'DownloadRecordings.php?ShippingID=' + ShippingID,
            // data: "fromDate=" + date + "&toDate=" + date,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let resultData = resultDataCrm.result;
              this.IVRCallRecording.IVRCallRecordingArr = resultData;
              this.IVRCallRecording.IVRCallRecordingModal = true;

            } else {
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - showIVRCallRecordingModal";
        this.$alertify.error(msg);
      }
    },

    // Start Modal Logic end
    getIVRCallRecordingUrlModal(id) {
      try {
        this.IVRCallRecording.AudioUrl = null;
        // Modal Logic
        this.IVRCallRecording.IVRCallRecordingModal = false;
        // console.log("getIVRCallRecordingUrl id " + id);

        this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'POST',
            url: apiUrl.crmivr_url + 'GetRecordingURL.php?uniqueid=' + id,
            //   data: "fromDate=" + date + "&toDate=" + date,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let AudioUrl = resultDataCrm.result;

              // Modal Logic
              if (AudioUrl) {
                this.IVRCallRecording.AudioUrl = AudioUrl;
                this.IVRCallRecording.IVRCallRecordingUrlModal = true;

              } else {
                this.IVRCallRecording.AudioUrl = null;
                this.isLoadingCurrentStatusDiv = false;
                let msg = "Url is not provided.";
                this.$alertify.error(msg);

              }
              // Modal Logic end

            } else {
              this.isLoadingCurrentStatusDiv = false;
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingUrl";
        this.$alertify.error(msg);
      }
    },


    // New window logic
    getIVRCallRecordingUrl(id) {
      try {
        this.IVRCallRecording.AudioUrl = null;
        // console.log("getIVRCallRecordingUrl id " + id);

        axios({
            method: 'POST',
            url: apiUrl.crmivr_url + 'GetRecordingURL.php?uniqueid=' + id,
            //   data: "fromDate=" + date + "&toDate=" + date,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let AudioUrl = resultDataCrm.result;

              // new window Logic
              if (AudioUrl) {
                window.open(AudioUrl, "_blank");
              } else {
                this.isLoadingCurrentStatusDiv = false;
                let msg = "Url is not provided.";
                this.$alertify.error(msg);
              }

            } else {
              this.isLoadingCurrentStatusDiv = false;
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingUrl";
        this.$alertify.error(msg);
      }
    },

    closeIVRCallRecordingUrlModal() {
      this.IVRCallRecording.IVRCallRecordingUrlModal = false;
      this.IVRCallRecording.IVRCallRecordingModal = true;
    },

    sorArrtByDate: function (arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function (a, b) {

        var date = a.CreatedDate;
        var parts = date.split("-");
        var convertedDate = `${parts[1]}-${parts[0]}-${parts[2]}`
        var convertedDatetimeA = new Date(convertedDate);

        var dateB = b.CreatedDate;
        var partsB = dateB.split("-");
        var convertedDateB = `${partsB[1]}-${partsB[0]}-${partsB[2]}`;
        var convertedDatetimeB = new Date(convertedDateB);
        return convertedDatetimeB - convertedDatetimeA;

        //  return new Date(moment(String(b.CreatedDate)).format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(String(a.CreatedDate)).format('YYYY-MM-DD hh:mm:ss'));
      });
    },

    async getIVRCallRecordingData() {
      try {

        //  let ShippingID = this.ShippingID;
        let ShippingID = 1367020713537; //1367020713537;
        // this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'GET',
            url: apiUrl.crmivr_url + 'DownloadRecordings.php?ShippingID=' + ShippingID,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            //   this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let resultData = resultDataCrm.result;

              let i = 0;
              let resultDataCnt = resultData.length;
              for (i = 0; i < resultDataCnt; i++) {
                // let CreatedDate = moment((resultData[i].calldate)).format('YYYY-MM-DD HH:mm:ss');
                let CreatedDate = moment(String(resultData[i].calldate)).format('DD-MM-YYYY hh:mm:ss');
                let resultDataObj = {
                  "Status": "",
                  "ShipmentStatus:": "",
                  "ClientID": 0,
                  "ProcessCode": resultData[i].uniqueid,
                  "Comments": "Call Duration : " + resultData[i].duration,
                  "CurrentHubName": null,
                  "UserProcess": resultData[i].UserProcess,
                  "ProcessLocation": null,
                  "CreatedDate": CreatedDate,
                  "UserName": "Call Recording",
                  "ClientBusinessAccountId": 0
                };

                this.ShipmentLog.ShipmentLogBarArr.push(resultDataObj);

              }
            } else {
              let msg = resultDataCrm.ReturnMessage;
              //  this.$alertify.error(msg);
            }
          }, error => {
            //   this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        // this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingData";
        this.$alertify.error(msg);
      }
    },

    /* End IVRCallRecording functionality*/


    showMultipleProductInfoModal() {
      this.MultipleProductInfo.MultipleProductInfoModal = true;
    },


    resetTrackshipmentsummary() {
      this.ShippingID = "";
      // Hide all main Div
      this.BagNumberTypeMainDiv = false;
      this.ShippingIDTypeMainDiv = false;
      this.MobileNumberTypeMainDiv = false;
      this.ClientOrderIDAWBModal = false;
      this.RaiseTicketDiv = false;
      let dataObj = {
        "value": "ShippingID",
        "text": "Shipping ID"
      };
      this.selectTypeOption(dataObj);
      
      //track_security_7627 Reset to default Customer Ticket
      let reasonObj = {
        "value": "CustomerTicket",
        "text": "Customer Ticket"
      };
      this.selectReasonOption(reasonObj);
      
      // track_security_7627 Reset other fields
      this.SearchPurpose = '';
      this.ClientOrderIDArr = [];
      this.ClientOrderIDObj = {
        value: '',
        text: ''
      };
      this.clientData = [];
    },


    resetShippingDetails() {
      this.ShippingID = "";
      this.$refs.RefShippingID.focus();
    },

    // Start c EDD PDD From Old Sytem
    // getEDDPDD() {

    // try {
    // this.isLoading = true;
    // this.input = ({
    // "ShippingID": this.ShippingID,
    // })
    // axios({
    // method: 'POST',
    // 'url': apiUrl.api_url + 'getEDDPDD',
    // 'data': this.input
    // })
    // .then(result => {
    // this.isLoading = false;
    // let resultDataCrm = result.data.data;
    // if (resultDataCrm.status) {
    // let resultData = result.data.data.data;
    
    // if (resultData.ReturnCode == 100) {
    // this.SalesDemo.EDD = (resultData.listShipmentEDDPDD[0].EDD != "null" && resultData.listShipmentEDDPDD[0].EDD != "") ? resultData.listShipmentEDDPDD[0].EDD : null;
    // this.SalesDemo.PDD = (resultData.listShipmentEDDPDD[0].PDD != "null" && resultData.listShipmentEDDPDD[0].PDD != "") ? resultData.listShipmentEDDPDD[0].PDD : null;
    // } else {
    // let msg = resultData.EDDPDDReturnMessage;
    // //  this.$alertify.error(msg);
    // }
    //         } else {
    // let msg = resultDataCrm.msg;
    //     // this.$alertify.error(msg);
    // }
    //       }, error => {
    //         this.isLoading = false;
    //         let msg = error;
    //         this.$alertify.error(msg);
    //       })
    // } catch (error) {
    // this.isLoading = false;
    // let msg = error + " - getEDDPDD";
    // this.$alertify.error(msg);
    // }
    // },

    //Start SendSMS functionality
    getSMSReason() {

      this.SendSMS.ReasonArr = [];
      if (this.SalesDemo.BusinessFlow === 'Forward') {
        this.SendSMS.ReasonArr.push({
          'value': 'NORESPONSE_CUSTOMER_INTIMATION',
          'text': 'No Response'
        });
        this.SendSMS.ReasonArr.push({
          'value': 'XB_COLLECT_ORDER',
          'text': 'Self Collect'
        });
      } else if (this.SalesDemo.BusinessFlow === 'Reverse') {
        this.SendSMS.ReasonArr.push({
          'value': 'NORESPONSE_CUSTOMER_INTIMATION',
          'text': 'No Response'
        });
      }

    },

    selectedSMSReason(SelectedData) {
      try {
        this.SendSMS.SelectedReasonObj.text = SelectedData.text;
        this.SendSMS.SelectedReasonObj.value = SelectedData.value;
        this.SendSMS.Reason = SelectedData.value;
        this.SendSMS.ActualSMSCode = SelectedData.value;
        this.getSMSTextByActualSMSCode();
      } catch (error) {
        let msg = error + " - selectedSMSReason";
        this.$alertify.error(msg);
      }
    },

    sendSMSToNumber() {
      try {
        this.SendSMS.SMSData = [];
        this.isLoading = true;
        let Message = this.SendSMS.Message;
        let ActualSMSCode = this.SendSMS.ActualSMSCode;

        if (ActualSMSCode === "XB_COLLECT_ORDER") {
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push(null);
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push(null);
        } else if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
          this.SendSMS.SMSData.push(this.SalesDemo.ClientName);
          this.SendSMS.SMSData.push("test");
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push("test");
        }

        this.input = ({
          "MobileNumber": this.CustomerDetails.PhoneNo,
          "SMSID": this.SendSMS.ActualSMSCode,
          "SMSData": this.SendSMS.SMSData,
          "SendSMSKey": this.SendSMS.SendSMSKey,
          //   "ClientID": this.ShipmentTransactionLogSummary.ClientID,
          "ClientID": this.ShippingID,

        });

        let token = "";
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'sendSMSToNumber',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.code === 200) {
              this.closeBModalCommonFunction('SendSMSModal');
              // let msg = resultData.message;
              let msg = this.CustomerDetails.PhoneNoDisplay + " - Message sent successfully";
              this.$alertify.success(msg);
            } else {
              let msg = resultData.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - sendSMSToNumber";
        this.$alertify.error(msg);
      }
    },

    handleSubmitForSendSMS(e) {
      try {
        this.SendSMS.submitted = true;
        this.$validator.validate().then(valid => {
          if (valid) {
            if (this.SalesDemo.ShipmentStatus !== "InScan" && this.SalesDemo.Status !== "Shipped") {
              let msg = "Shipment is not in desired status to send SMS.";
              this.$alertify.error(msg);
              return false;
            } else if (this.SendSMS.Reason === "") {
              let msg = "Please select Reason.";
              this.$alertify.error(msg);
              return false;
            } else if (this.SendSMS.Message === "") {
              let msg = "Please select message.";
              this.$alertify.error(msg);
              return false;
            }
            this.sendSMSToNumber();
          } else {
            let msg = "Validation Error - handleSubmitForSendSMS";
            this.$alertify.error(msg);
            return false;
          }
        });
      } catch (error) {
        let msg = error + " - handleSubmitForSendSMS";
        this.$alertify.error(msg);
      }
    },

    getSMSTextByActualSMSCode() {
      this.isLoading = true;
      let ActualSMSCode = this.SendSMS.ActualSMSCode;
      this.SendSMS.SendSMSArr = [];
      this.SendSMS.SelectedSendSMSObj = {
        value: '',
        text: ''
      };

      this.input = ({
        'actualsmscode': ActualSMSCode,
      });
      let token = "";
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSMSTextByActualSMSCode',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        let resultDataCrm = result.data.data;
        if (resultDataCrm.status) {
          let resultData = result.data.data.data;
          if (resultData.code === 200) {
            if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
              let SendSMSArrData = resultData.data
              this.SendSMS.SendSMSArr.push({
                'value': SendSMSArrData,
                'text': SendSMSArrData
              });

              this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
              this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
            } else {
              let SendSMSArr = resultData.data;
              let ArrCnt = SendSMSArr.length;
              if (ArrCnt > 0) {
                for (let i = 0; i < ArrCnt; i++) {
                  this.SendSMS.SendSMSArr.push({
                    'value': SendSMSArr[i].smstext,
                    'text': SendSMSArr[i].smstext
                  });
                  MultipleProductInfoModal
                }
                this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
                this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
              }
            }
          } else {
            this.isLoading = false;
            let msg = resultData.message;
            this.$alertify.error(msg);
          }
        } else {
          this.isLoading = false;
          let msg = resultDataCrm.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        let msg = error;
        this.$alertify.error(msg);
      })
    },


    openSendSMSModal() {
      try {
        this.resetSendSMSModalData();
        //  this.getSMSTextByActualSMSCode();
        this.getSMSReason();
        this.SendSMS.SendSMSModal = true;
      } catch (error) {
        this.SendSMS.SendSMSModal = false;
        let msg = error + " - openSendSMSModal";
        this.$alertify.error(msg);
      }
    },

    resetSendSMSModalData() {
      this.SendSMS.SendSMSArr = [];
      this.SendSMS.SelectedSendSMSObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Message = "";
      this.SendSMS.ReasonArr = [];
      this.SendSMS.SelectedReasonObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Reason = "";
      this.SendSMS.ActualSMSCode = ""; // Reason = ActualSMSCode
    },
    //End SendSMS functionality

    OpenCallPatchingModel(mobileNumber, altMobileNumber, customerName, addressType) {
      try {
        this.CallTypeOptionObj = [];
        var permissiondataEncrypt = window.localStorage.getItem('permissiondata')
        var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var permissiondata = JSON.parse(plaintext);

        let trackshipmentsummaryArr = permissiondata.filter(function (val) {
          return val.url == "/trackshipmentsummary";
        });

        //GSM Gateway SIP Trunk
        let SIPTrunk = trackshipmentsummaryArr[0].children.filter(function (val) {
          return val.name == "SIP Trunk";
        });

        if (SIPTrunk.length != 0) {
          this.CallTypeOptionObj.push("SIP Trunk");
          this.CallType = "SIP Trunk";
        }

        let GSMGateway = trackshipmentsummaryArr[0].children.filter(function (val) {
          return val.name == "GSM Gateway";
        });
        //#ip_track hide GSM gateway from option 
        // if (GSMGateway.length != 0) {
        //   this.CallTypeOptionObj.push("GSM Gateway");
        // }

        this.Callpatching.Name = customerName;
        this.Callpatching.optNumberType = 1;
        this.Callpatching.addressType = addressType;
        this.Callpatching.mobileNumber = mobileNumber;
        this.Callpatching.altMobileNumber = altMobileNumber;
        this.Callpatching.CallPatchingModal = true;
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - OpenCallPatchingModel";
        this.$alertify.error(msg);
      }

    },

    //#ip_track old method to direct ivr call
    async MakeCallOld() {
      try {
        if (this.ShippingID === '') {
          this.$alertify.error('Shipping id not found');
          return false;
        }
        if (!this.mobileNumber || this.mobileNumber === '') {
          this.$alertify.error('Agent mobile number not found.');
          return false;
        }
        var customerMobile = '';
        if (this.Callpatching.optNumberType == '1') {
          if (!this.Callpatching.mobileNumber) {
            this.$alertify.error('Primary mobile number not found.');
            return false;
          } else {
            customerMobile = this.Callpatching.mobileNumber;
          }
        } else if (this.Callpatching.optNumberType == '2') {
          if (!this.Callpatching.altMobileNumber) {
            this.$alertify.error('Alternate mobile number not found.');
            return false;
          } else {
            customerMobile = this.Callpatching.altMobileNumber;
          }
        } else {
          this.$alertify.error('Please select mobile number type.');
          return false;
        }
        //#ip_track function to get key of exactly 16 bytes (AES-128 requires this).
        function getKey(rawKey) {
          const padded = rawKey.padEnd(16, "\0"); // pad with nulls
          return CryptoJS.enc.Utf8.parse(padded);
        }
        
        const key = getKey(constantVariable.enckey_call_patching);
        
        const encrypted = CryptoJS.AES.encrypt(
          customerMobile,
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        
        const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase(); 
        this.isLoading = true;
        this.input = ({
          'customernumber': encryptedHex,   //#ip_track Pass encrypted customer number
          'agentnumber': this.mobileNumber,  
          'email': this.email,
          'shippingid': this.ShippingID,
          'clientid': this.ShipmentTransactionLogSummary.ClientID,
          'businessType': 'B2C'
        });

        if (this.CallType == "GSM Gateway") {
          await axios({
              method: 'POST',
              url: apiUrl.crmivr_url + 'CRM_Call_Bridge.php?customernumber=' + this.input.customernumber + '&agentnumber=' + this.input.agentnumber,
              datatype: 'json',
              headers: commonFunction.getusertoken(),
            })
            .then(result => {
              if (result.data.ReturnCode == 100) {
                // console.log(result.data);
                this.$alertify.success("Call is in processing", 20);
              } else {
                // console.log(result.data);
                let msg = result.data.ReturnMessage;
                this.$alertify.error(msg);
              }
              this.isLoading = false;
            }, error => {
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
              this.isLoading = false;
            });
        } else if (this.CallType == "SIP Trunk") {
          await axios({
              method: 'POST',
              url: apiUrl.crmivr_url + 'crmivr_live/Servicecontroller/callMePaytm_v1_CLTCRM',
              data: "customernumber=" + this.input.customernumber + "&agentnumber=" + this.input.agentnumber + "&email=" + this.input.email + "&shippingid=" + this.input.shippingid + "&clientid=" + this.input.clientid,
              datatype: 'json',
              // headers: commonFunction.getusertoken(),
            })
            .then(result => {
              let resultDataCrm = result.data;
              // console.log(resultDataCrm.status);
              if (resultDataCrm.status === "false") {
                // console.log(resultDataCrm);
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              } else {
                // console.log(resultDataCrm);
                this.$alertify.success("Call is in processing", 20);
              }
              this.isLoading = false;
            }, error => {
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
              this.isLoading = false;
            });
        } else {
          this.$alertify.error("Call type not available!");
          this.isLoading = false;
        }
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - MakeCall";
        this.$alertify.error(msg);
        this.isLoading = false;
      }

    },
    
    //#ip_track new method to ivr call from backend 
    async MakeCall() {
      try {
        if (this.ShippingID === '') {
          this.$alertify.error('Shipping id not found');
          return false;
        }
        if (!this.mobileNumber || this.mobileNumber === '') {
          this.$alertify.error('Agent mobile number not found.');
          return false;
        }
        //#ip_track fetch mobile number directly
        // var customerMobile = '';
        // if (this.Callpatching.optNumberType == '1') {
        //   if (!this.Callpatching.mobileNumber) {
        //     this.$alertify.error('Primary mobile number not found.');
        //     return false;
        //   } else {
        //     customerMobile = this.Callpatching.mobileNumber;
        //   }
        // } else if (this.Callpatching.optNumberType == '2') {
        //   if (!this.Callpatching.altMobileNumber) {
        //     this.$alertify.error('Alternate mobile number not found.');
        //     return false;
        //   } else {
        //     customerMobile = this.Callpatching.altMobileNumber;
        //   }
        // } else {
        //   this.$alertify.error('Please select mobile number type.');
        //   return false;
        // }
        // //#ip_track function to get key of exactly 16 bytes (AES-128 requires this).
        // function getKey(rawKey) {
        //   const padded = rawKey.padEnd(16, "\0"); // pad with nulls
        //   return CryptoJS.enc.Utf8.parse(padded);
        // }
        
        // const key = getKey(constantVariable.enckey_call_patching);
        
        // const encrypted = CryptoJS.AES.encrypt(
        //   customerMobile,
        //   key,
        //   {
        //     mode: CryptoJS.mode.ECB,
        //     padding: CryptoJS.pad.Pkcs7
        //   }
        // );
        
        // const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase(); 
        this.isLoading = true;
        this.input = ({
          'customernumber': this.UAPayload.sellerMobileNumber || '',   //#ip_track Pass encrypted customer number       // seller callpaching 
          'agentnumber': this.mobileNumber,  
          'email': this.email,
          'shippingid': this.ShippingID,
          'clientid': this.ShipmentTransactionLogSummary.ClientID,
          'hubid': this.ShipmentTransactionLogSummary.CurrentHubID,         //#self_service
          'AdminID': this.userid ,
          'SellerID':this.UAPayload.vendorId || '',                            // seller callpaching 
        });
        
    
// console.log(encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase()),"======encyr";
      //  this.input = ({
      //     'customernumber':encryptedHex,
      //     'agentnumber': this.mobileNumber,
      //     'email': 'mrudula.more1@xpressbees.com',
      //     'shippingid': '12555806671679',
      //     'clientid': '27'
      //   });


        if (this.CallType == "GSM Gateway") {
          await axios({
              method: 'POST',
              url: apiUrl.crmivr_url + 'CRM_Call_Bridge.php?customernumber=' + '8830501491' + '&agentnumber=' + this.input.agentnumber,
              datatype: 'json',
              headers: commonFunction.getusertoken(),
            })
            .then(result => {
              if (result.data.ReturnCode == 100) {
                // console.log(result.data);
                this.$alertify.success("Call is in processing", 20);
              } else {
                // console.log(result.data);
                let msg = result.data.ReturnMessage;
                this.$alertify.error(msg);
              }
              this.isLoading = false;
            }, error => {
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
              this.isLoading = false;
            });
        } else if (this.CallType == "SIP Trunk") {
          await axios({
            method: "POST",
            url: apiUrl.api_url + "makecall",
            data: this.input,
            headers: commonFunction.getusertoken(),
          }).then(result => {
              let resultDataCrm = result.data;
              // console.log(resultDataCrm.status);
              if (resultDataCrm.status === "false") {
                // console.log(resultDataCrm);
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              } else {
                // console.log(resultDataCrm);
                this.$alertify.success("Call is in processing", 20);
              }
              this.isLoading = false;
            }, error => {
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
              this.isLoading = false;
            });
        } else {
          this.$alertify.error("Call type not available!");
          this.isLoading = false;
        }
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - MakeCall";
        this.$alertify.error(msg);
        this.isLoading = false;
      }

    },

    async MakeCallBkForValidateAgent() {
      try {
        if (this.ShippingID === '') {
          this.$alertify.error('Shipping id not found');
          return false;
        }
        if (!this.mobileNumber || this.mobileNumber === '') {
          this.$alertify.error('Agent mobile number not found.');
          return false;
        }
        var customerMobile = '';
        if (this.Callpatching.optNumberType == '1') {
          if (!this.Callpatching.mobileNumber) {
            this.$alertify.error('Primary mobile number not found.');
            return false;
          } else {
            customerMobile = this.Callpatching.mobileNumber;
          }
        } else if (this.Callpatching.optNumberType == '2') {
          if (!this.Callpatching.altMobileNumber) {
            this.$alertify.error('Alternate mobile number not found.');
            return false;
          } else {
            customerMobile = this.Callpatching.altMobileNumber;
          }
        } else {
          this.$alertify.error('Please select mobile number type.');
          return false;
        }

        this.isLoading = true;
        this.input = ({
          'customernumber': customerMobile,
          'agentnumber': this.mobileNumber,
          'email': this.email,
          'shippingid': this.ShippingID,
          'clientid': this.ShipmentTransactionLogSummary.ClientID
        });

        /*  this.input = ({
           'customernumber': '9921858997',
           'agentnumber': '9921858997',
           'email': 'abhijeet.patil@xpressbees.com',
           'shippingid': '127607234211',
           'clientid': '27'
         }); */

        await axios({
            method: 'GET',
            url: apiUrl.crmivr_url + 'ValidateAgentNumber.php?AgentNumber=' + this.input.agentnumber,
            data: this.input,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(async result => {
              this.isLoading = false;
              let resultDataCrm = result.data;
              if (resultDataCrm.code === 100) {

                if (this.CallType == "GSM Gateway") {
                  await axios({
                      method: 'POST',
                      url: apiUrl.crmivr_url + 'CRM_Call_Bridge.php?customernumber=' + this.input.customernumber + '&agentnumber=' + this.input.agentnumber,
                      datatype: 'json',
                      headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                      if (result.data.ReturnCode == 100) {
                        // console.log(result.data);
                        this.$alertify.success("Call is in processing", 20);
                      } else {
                        // console.log(result.data);
                        let msg = result.data.ReturnMessage;
                        this.$alertify.error(msg);
                      }
                    }, error => {
                      console.log(error);
                      let msg = JSON.stringify(error);
                      this.$alertify.error(msg);
                    });
                } else if (this.CallType == "SIP Trunk") {
                  await axios({
                      method: 'POST',
                      url: apiUrl.crmivr_url + 'crmivr_live/Servicecontroller/callMePaytm_v1_CLTCRM',
                      data: "customernumber=" + this.input.customernumber + "&agentnumber=" + this.input.agentnumber + "&email=" + this.input.email + "&shippingid=" + this.input.shippingid + "&clientid=" + this.input.clientid,
                      datatype: 'json',
                      // headers: commonFunction.getusertoken(),
                    })
                    .then(result => {
                      let resultDataCrm = result.data;
                      // console.log(resultDataCrm.status);
                      if (resultDataCrm.status === "false") {
                        // console.log(resultDataCrm);
                        let msg = resultDataCrm.msg;
                        this.$alertify.error(msg);
                      } else {
                        // console.log(resultDataCrm);
                        this.$alertify.success("Call is in processing", 20);
                      }
                    }, error => {
                      console.log(error);
                      let msg = JSON.stringify(error);
                      this.$alertify.error(msg);
                    });
                } else {
                  this.$alertify.error("Call type not available!");
                }
              } else {
                this.$alertify.error("Agent mobile number is not registered!");
              }
            },
            error => {
              this.isLoading = false;
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
            });
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - MakeCall";
        this.$alertify.error(msg);
      }

    },

    handleSubmitForSearch(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // Validate Client Name is required when Search Type is ClientOrderID
          if (this.SelectTypeOptionObj.value === 'ClientOrderID') {
            if (!this.search.client || !this.search.client.value) {
              this.$alertify.error('Client Name is required when Search Type is Client Order ID.');
              return;
            }
          }
          // track_security_7627 Validate Search Purpose for Others
          if (this.SelectReasonOptionObj.value === 'Others' && !this.SearchPurpose.trim()) {
            this.$alertify.error('Remark is required when Others is selected.');
            return;
          }
          
          this.getTrackShipmentSummeryDetails();
          this.resetForm();
        }
      });
    },

    trackShipmentDetails(ShippingID) {
      this.ShippingID = ShippingID;
      this.getTrackShipmentSummeryDetails();
      this.resetForm();
      window.scrollTo(0, 0);
    },

    // track_security_7627 Handle AWB click from Client Order ID search results
    // Logs user activity when clicking on shipping ID links in the AWB modal
    trackAWBClick(shippingId) {
      // Store source Client Order ID for correlation tracking
      if (this.SearchedOrderID) {
        localStorage.setItem('sourceClientOrderID', this.SearchedOrderID);
      }
      // Log AWB click activity for audit trail
      if (constantVariable.IP_Tracking_Enabled === 'Y') {
        let userTrackerObj = {
          shippingIds: shippingId,
          userid: this.userid,
          username: this.username,
          olduserid: this.OldDeliveryUserOrUserId,
          projectname: apiUrl.project_name,
          trackurl: this.$route.path,
          eventTrack: 'Track Activity - Shipping ID',
          searchReason: this.SelectReasonOptionObj.value || 'CustomerTicket',
          searchType: 'ShippingID',
          searchPurpose: this.SearchPurpose || '',
          sourceClientOrderID: this.SearchedOrderID
        };
        authFunction.userTrackerSearchActivity(userTrackerObj);
      }
    },

    myPopupFunction() {
      var popup = document.getElementById("myPopup");
      popup.classList.toggle("show");
    },

    openmap() {
      try {
        let srid = (this.OrderDetails.srLocationDetails.srid) ? this.OrderDetails.srLocationDetails.srid : 0;
        if (!srid) {
          this.$alertify.error('Trip is not started Or already closed by user');
          return false;
        }
        this.OrderDetails.googleInitialiseData = {
          latitude: 18.545885,
          longitude: 73.908419
        }
        this.locationMapModal = true;
        google.maps.event.addDomListener(window, "load", this.initialize());
      } catch (error) {
        this.locationMapModal = false;
        let msg = error + " - openmap";
        this.$alertify.error(msg);
      }
    },

    initialize() {
      var directionsService = new google.maps.DirectionsService;
      var directionsDisplay = new google.maps.DirectionsRenderer({
        //    suppressMarkers: true
      });
      var loc = [];
      var markerstore = {};

      var centerltlng = {
        lat: parseFloat(this.OrderDetails.googleInitialiseData.latitude),
        lng: parseFloat(this.OrderDetails.googleInitialiseData.longitude)
      }

      this.map[this.ShippingID] = new google.maps.Map(document.getElementById('map' + this.ShippingID), {
        zoom: 12,
        center: centerltlng
      });
      directionsDisplay.setOptions({
        polylineOptions: {
          strokeColor: 'black'
        }
      });
      directionsDisplay.setMap(this.map[this.ShippingID]);
      //console.log(this.OrderDetails.srLocationDetails);
      this.setmarkers(markerstore, directionsService, directionsDisplay, this.OrderDetails.srLocationDetails, this.map);
    },

    setmarkers(markerstore, directionsService, directionsDisplay, data, map) {
      var locationall = [];
      locationall.push(data);

      var infowindow = new google.maps.InfoWindow();
      var markers = locationall.map(function (location, i) {
        var symbol = {
          path: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
          scale: .7,
          strokeColor: 'white',
          strokeWeight: .10,
          fillOpacity: 1,
          fillColor: '#800000',
          offset: '5%',
          rotation: 90,
          anchor: new google.maps.Point(10, 25)
        }
        if (data.vehicletype == "bike")
          symbol = {
            url: '../../static/img/scooter.svg',
            anchor: new google.maps.Point(10, 25),
            size: new google.maps.Size(50, 50)
          };
        var markerone = new google.maps.Marker({
          position: new google.maps.LatLng(data.latitude, data.longitude),
          icon: symbol,
          optimized: false
        });

        google.maps.event.addListener(markerone, 'click', function (evt) {
          infowindow.setContent(data.location);
          infowindow.open(map[this.ShippingID], markerone);
        });
        markerstore[location.uid] = markerone;
        return markerone;
      });

      var markerCluster = new MarkerClusterer(map[this.ShippingID], markers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      });
      //this.showroute(data, directionsService, directionsDisplay);
    },
    //  closeBagShipmentDetailsModal

    //  showBagShipmentDetailsModal
    showBagShipmentDetailsModal() {
      try {
        this.BagNoObj.BagShipmentDetailsModal = false;
        this.BagNoObj.BagShipmentDetailsArr = [];
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Bag Number.');
          return false;
        }
        this.isLoading = true;
        this.input = ({
          ShippingID: this.ShippingID
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'fetchBagShipmentDetailsByBagNumber',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ResultCode === 100) {
                this.BagNoObj.BagShipmentDetailsArr = resultData.ResponseData;
                let BagInShipmentArr = resultData.ResponseData.filter(function (val) {
                  return val.status == "BagIn";
                });
                this.BagNoObj.BagInShipmentCount = BagInShipmentArr.length;
                this.BagNoObj.BagShipmentDetailsModal = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - showBagShipmentDetailsModal";
        this.$alertify.error(msg);
      }
    },

    // fetchBagTransitDetailsBySelectType
    fetchBagTransitDetailsBySelectType() {
      //  this.BagNoObj.TransitStatusModal = false;
      try {
        //undefinedFunction();
        this.BagNoObj.TransitStatusArr = [];
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Bag Number.');
          return false;
        }
        this.isLoading = true;
        this.isLoadingCurrentStatusDiv = true;
        this.input = ({
          ShippingID: this.ShippingID,
          SelectType: this.SelectTypeOptionObj.value
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'fetchBagTransitDetailsBySelectType',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ResultCode === 100) {
                this.BagNoObj.TransitStatusArr = resultData.ResponseData;
                this.BagNoObj.TransitStatusModal = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoading = false;
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - fetchBagTransitDetailsBySelectType";
        this.$alertify.error(msg);
      }
    },
    // showTransitStatusModal
    showTransitStatusModal() {
      this.fetchBagTransitDetailsBySelectType();
    },

    selectTypeOption(dataObj) {

      this.SelectTypeOptionObj = dataObj;
      
      // Load client data only when ClientOrderID is selected and not already loaded
      if (dataObj.value === 'ClientOrderID' && this.clientData.length === 0) {
        this.getClientList();
      }
    },
    //track_security_7627 -----------Start-------------
    selectReasonOption(dataObj) {
      this.$nextTick(() => {
        this.SelectReasonOptionObj = { value: dataObj.value, text: dataObj.text };
      });
      if (dataObj.value !== 'Others') {
        this.SearchPurpose = '';
      }
      if (dataObj.value === 'ClientTrackingRequest' || dataObj.value === 'ClientChangeRequest') {
        this.getClientOrderIDs();
      }
    },

    selectClientOrderID(dataObj) {
      this.ClientOrderIDObj = dataObj;
      this.search.client = dataObj.value;
    },
    
    // API to get shipment details by Order ID
    getAllShipmentsByClientOrderID(pageIndex = 1) {
      if (this.ShippingID === '') {
        this.$alertify.error('Please enter Client Order ID.');
        return false;
      }
      
      // Reset stored count when starting new search (page 1)
      if (pageIndex === 1) {
        this.storedTotalRowCount = 0;
      }
      
      this.isLoading = true;
      
      const payload = {
        ClientBusinessAccountID: this.search.client.value,
        OrderID: this.ShippingID.trim(),
        PageIndex: pageIndex,
        PageSize: 10
      };
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getAllShipmentsByClientOrderID',
        data: payload,
        headers: commonFunction.getusertoken(),
      })
      .then(result => {
          this.isLoading = false;
          if (result.data.data.status) {
            const shipmentData = result.data.data.data;

            if (
              shipmentData.ReturnCode === 100 &&
              Array.isArray(shipmentData.Response) &&
              shipmentData.Response.length > 0
            ) {
              this.SearchedOrderID = this.ShippingID;

              this.OrderIDAWBArr = shipmentData.Response.map(shipment => ({
                value: shipment.ShippingID,
                text: `${shipment.ShippingID} (${shipment.CreatedDate})`,
                createdDate: shipment.CreatedDate,
                status: shipment.Status,
                businessFlow: shipment.BusinessFlow,
                clientName: shipment.ClientName,
                currentStatus: shipment.CurrentStatus,
                attempts: shipment.TotalAttemptCount
              }));

              // Store total count from first call, reuse for subsequent calls
              if (shipmentData.TotalRowCount !== undefined) {
                this.storedTotalRowCount = shipmentData.TotalRowCount;
              }
              const totalCount = this.storedTotalRowCount || 0;

              this.OrderIDPagination = {
                currentPage: pageIndex,
                totalPages: Math.ceil(totalCount / 10),
                totalRecords: totalCount,
                pageSize: 10
              };

              this.SelectedAWBObj = this.OrderIDAWBArr[0];
              this.ClientOrderIDAWBModal = true;
            } else {
              // Check if it's a Client Order ID search with no results
              if (this.SelectTypeOptionObj && this.SelectTypeOptionObj.value === 'ClientOrderID') {
                this.$alertify.error('Client Order ID not found');
              } else {
                this.$alertify.error(
                  shipmentData.ReturnMessage || 'No shipments found for this Order ID'
                );
              }
            }
          } else {
            this.$alertify.error(result.data.msg || 'Failed to fetch shipment details');
          }
          })
          .catch(error => {
            this.isLoading = false;
            console.error('Error fetching shipment by Order ID:', error);
            this.$alertify.error('Error occurred while searching by Order ID');
          });
    },
    
    // Pagination methods for Order ID results
    goToOrderIDPage(page) {
      if (page >= 1 && page <= this.OrderIDPagination.totalPages) {
        this.getAllShipmentsByClientOrderID(page);
      }
    },

    getClientList() {
      // if (this.clientData.length > 0) return; // Skip if already loaded
      
      try {
        var userToken = window.localStorage.getItem('userToken');
        var myStr = userToken.replace(/"/g, '');

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientListCSAW',
          'data': {
            BusinessFlow: "Forward",
            BusinessService: "Delivery"
          },
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          let data = result.data;
          this.clientData = data;
        }, error => {
          console.error(error);
        });
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getClientList";
        this.$alertify.error(msg);
      }
    },

    getClientOrderIDs() {
      // API call to fetch client order IDs based on ClientBusinessAccountID
      this.isLoading = true;
      const payload = {
        ClientBusinessAccountId: this.ShipmentTransactionLogSummary.ClientID
      };
      
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getClientOrderIDs',
        data: payload,
        headers: commonFunction.getusertoken(),
      })
      .then(result => {
        this.isLoading = false;
        const resultData = result.data.data;
        if (resultData.status) {
          const orders = resultData.data.data || [];
          this.ClientOrderIDArr = orders.map(order => ({
            value: order.ClientOrderID,
            text: order.ClientOrderID,
            ClientBusinessAccountId: order.ClientBusinessAccountId
          }));
        } else {
          this.ClientOrderIDArr = [];
          this.$alertify.error(resultData.msg || 'Failed to load client order IDs');
        }
      })
      .catch(error => {
        this.isLoading = false;
        this.ClientOrderIDArr = [];
        console.error('Error fetching client order IDs:', error);
      });
    },
    //track_security_7627 -----------End-------------

    selectAll: function (e) {
      this.OtherShipmentShippingIDCheckedArr = [];
      let ShippingIDEle;
      if (this.allSelected) {
        var i = 0;
        for (ShippingIDEle in this.AllShipmentLogArrData) {
          this.OtherShipmentShippingIDCheckedArr.push(this.AllShipmentLogArrData[ShippingIDEle].ShippingID.toString());

          if (-1 == this.ticketShipmentData.findIndex(o => o.index == ShippingIDEle)) {
            this.ticketShipmentData.push({
              'index': i,
              'shippingData': {
                'ShippingID': this.AllShipmentLogArrData[ShippingIDEle].ShippingID,
                'CurrentHubID': this.AllShipmentLogArrData[ShippingIDEle].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[ShippingIDEle].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[ShippingIDEle].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[ShippingIDEle].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[ShippingIDEle].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[ShippingIDEle].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[ShippingIDEle].BusinessFlow,
                "Status": this.AllShipmentLogArrData[ShippingIDEle].Status,
                "CurrentStatus": this.AllShipmentLogArrData[ShippingIDEle].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[ShippingIDEle].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[ShippingIDEle].OrderType
              }
            });
          }
          i++;
        }
      } else {
        this.OtherShipmentShippingIDCheckedArr = [];
        for (ShippingIDEle in this.AllShipmentLogArrData) {

          this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == ShippingIDEle), 1);

        }
      }
    },

    select: function (selectedObj, index, event) {

      let checkedCounter = 0;
      let isChecked;
      let oneShipmentCheckbox;

      this.AllShipmentLogArrData.forEach(element => {
        oneShipmentCheckbox = document.getElementById(element.ShippingID);
        isChecked = oneShipmentCheckbox.checked;
        if (isChecked == true) {
          checkedCounter = checkedCounter + 1;
        }
      });
      if (this.AllShipmentLogArrData.length === checkedCounter && event.target.checked) {
        this.allSelected = true;
        this.selectAll($event);
      } else {
        this.allSelected = false;
      }
      if (event.target.checked) {

        this.ticketShipmentData.push({
          'index': index,
          'shippingData': {
            'ShippingID': selectedObj.ShippingID,
            'CurrentHubID': selectedObj.CurrentHubID,
            "TotalAttemptCount": selectedObj.TotalAttemptCount,
            "UserProcess": selectedObj.UserProcess,
            "NotificationType": selectedObj.NotificationType,
            "NotificationStatus": selectedObj.NotificationStatus,
            "ClientName": selectedObj.ClientName,
            'BusinessFlow': selectedObj.BusinessFlow,
            "Status": selectedObj.Status,
            "CurrentStatus": selectedObj.CurrentStatus,
            "CreatedDate": selectedObj.CreatedDate,
            "OrderType": selectedObj.OrderType
          }
        });
      } else {
        this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
      }
    },

    check: function (e) {
      if (e.target.checked) {

      }
    },

    selectedOptionObj: function (selectedObj) {

      this.resetForm();
      this.ticketShipmentData = [];
      this.AllShipmentLogArrData = [];

      let arrShipStatus = [];

      this.categoryOptionObj.text = this.categoryOptionObj.value = selectedObj.text;

      if ('Unidentified' == selectedObj.text && undefined != this.UnCategorizedArrData) {
        this.AllShipmentLogArrData = this.UnCategorizedArrData;

      } else {
        //this.UnCategorizedArrData= [];
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

          for (let i = 0; i < this.category.Forward.length; i++) {
            if (this.category.Forward[i].name == selectedObj.value) {
              arrShipStatus.push(this.category.Forward[i]);
            }
          }
        }
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

          for (let i = 0; i < this.category.Reverse.length; i++) {

            if (this.category.Reverse[i].name == selectedObj.value) {
              arrShipStatus.push(this.category.Reverse[i]);
            }
          }
        }

        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

          for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

            let status = this.OtherShipmentLogArr[i].Status;

            let shipmentStatus = this.OtherShipmentLogArr[i].CurrentStatus;

            for (let j = 0; j < arrShipStatus.length; j++) {

              let otherStatus = arrShipStatus[j].Status;

              let otherShipmentStatus = arrShipStatus[j].ShipmentStatus;

              if (status.toLowerCase() === otherStatus.toLowerCase() && shipmentStatus.toLowerCase() == otherShipmentStatus.toLowerCase()) {
                this.AllShipmentLogArrData.push(this.OtherShipmentLogArr[i]);
              }
            }
          }
        }

        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

          for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

            for (let j = 0; j < arrShipStatus.length; j++) {

              if (this.OtherShipmentLogArr[i].Status.toLowerCase() == arrShipStatus[j].Status.toLowerCase() &&
                this.OtherShipmentLogArr[i].CurrentStatus.toLowerCase() == arrShipStatus[j].ShipmentStatus.toLowerCase()) {

                this.AllShipmentLogArrData.push(this.OtherShipmentLogArr[i]);
              }
            }
          }
        }
      }

      if (this.AllShipmentLogArrData.length == 0 && 'Unidentified' == selectedObj.text && this.UnCategorizedArrData.length > 0) {

        this.AllShipmentLogArrData = this.UnCategorizedArrData;
      }
      let shipmentIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID == this.ShippingID);

      if (-1 !== shipmentIndex && -1 === this.ticketShipmentData.findIndex(o => o.ShippingID == this.ShippingID)) {
        this.ticketShipmentData.push({
          'index': shipmentIndex,
          'shippingData': {
            'ShippingID': this.AllShipmentLogArrData[shipmentIndex].ShippingID,
            'CurrentHubID': this.AllShipmentLogArrData[shipmentIndex].CurrentHubID,
            "TotalAttemptCount": this.AllShipmentLogArrData[shipmentIndex].TotalAttemptCount,
            "UserProcess": this.AllShipmentLogArrData[shipmentIndex].UserProcess,
            "NotificationType": this.AllShipmentLogArrData[shipmentIndex].NotificationType,
            "NotificationStatus": this.AllShipmentLogArrData[shipmentIndex].NotificationStatus,
            "ClientName": this.AllShipmentLogArrData[shipmentIndex].ClientName,
            'BusinessFlow': this.AllShipmentLogArrData[shipmentIndex].BusinessFlow,
            "Status": this.AllShipmentLogArrData[shipmentIndex].Status,
            "CurrentStatus": this.AllShipmentLogArrData[shipmentIndex].CurrentStatus,
            "CreatedDate": this.AllShipmentLogArrData[shipmentIndex].CreatedDate,
            "OrderType": this.AllShipmentLogArrData[shipmentIndex].OrderType
          }
        });

        let eleRemoved = this.AllShipmentLogArrData.splice(shipmentIndex, 1);
        this.AllShipmentLogArrData.unshift(eleRemoved[0]);
        this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
      }


      this.ShowRaiseTicketDiv();
    },

    selectedOptionObjAll() {
      this.ticketShipmentData = [];
      this.AllShipmentLogArrData1 = [];
      let arrShipStatus = [];
      //this.UnCategorizedArrData= [];
      // if ('Unidentified' == selectedObj.text && undefined != this.UnCategorizedArrData) {
      //   this.AllShipmentLogArrData = this.UnCategorizedArrData;
      // }
      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
        for (let i = 0; i < this.categoryAll.Forward.length; i++) {
          if (this.categoryAll.Forward[i].name == 'All') {
            arrShipStatus.push(this.categoryAll.Forward[i]);
          }
        }
      }
      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

        for (let i = 0; i < this.categoryAll.Reverse.length; i++) {

          if (this.categoryAll.Reverse[i].name == 'All') {
            arrShipStatus.push(this.categoryAll.Reverse[i]);
          }
        }
      }

      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

        for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

          let status = this.OtherShipmentLogArr[i].Status;

          let shipmentStatus = this.OtherShipmentLogArr[i].CurrentStatus;

          for (let j = 0; j < arrShipStatus.length; j++) {

            let otherStatus = arrShipStatus[j].Status;

            let otherShipmentStatus = arrShipStatus[j].ShipmentStatus;

            if (status.toLowerCase() === otherStatus.toLowerCase() && shipmentStatus.toLowerCase() == otherShipmentStatus.toLowerCase()) {
              this.AllShipmentLogArrData1.push(this.OtherShipmentLogArr[i]);
            }
          }
        }
      }

      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

        for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

          for (let j = 0; j < arrShipStatus.length; j++) {

            if (this.OtherShipmentLogArr[i].Status.toLowerCase() == arrShipStatus[j].Status.toLowerCase() &&
              this.OtherShipmentLogArr[i].CurrentStatus.toLowerCase() == arrShipStatus[j].ShipmentStatus.toLowerCase()) {

              this.AllShipmentLogArrData1.push(this.OtherShipmentLogArr[i]);
            }
          }
        }
      }
      // }

      if (this.AllShipmentLogArrData1.length == 0 && 'Unidentified' == selectedObj.text && this.UnCategorizedArrData.length > 0) {

        this.AllShipmentLogArrData1 = this.UnCategorizedArrData;
      }
      let shipmentIndex = this.AllShipmentLogArrData1.findIndex(o => o.ShippingID == this.ShippingID);

      if (-1 !== shipmentIndex && -1 === this.ticketShipmentData.findIndex(o => o.ShippingID == this.ShippingID)) {
        this.ticketShipmentData.push({
          'index': shipmentIndex,
          'shippingData': {
            'ShippingID': this.AllShipmentLogArrData1[shipmentIndex].ShippingID,
            'CurrentHubID': this.AllShipmentLogArrData1[shipmentIndex].CurrentHubID,
            "TotalAttemptCount": this.AllShipmentLogArrData1[shipmentIndex].TotalAttemptCount,
            "UserProcess": this.AllShipmentLogArrData1[shipmentIndex].UserProcess,
            "NotificationType": this.AllShipmentLogArrData1[shipmentIndex].NotificationType,
            "NotificationStatus": this.AllShipmentLogArrData1[shipmentIndex].NotificationStatus,
            "ClientName": this.AllShipmentLogArrData1[shipmentIndex].ClientName,
            'BusinessFlow': this.AllShipmentLogArrData1[shipmentIndex].BusinessFlow,
            "Status": this.AllShipmentLogArrData1[shipmentIndex].Status,
            "CurrentStatus": this.AllShipmentLogArrData1[shipmentIndex].CurrentStatus,
            "CreatedDate": this.AllShipmentLogArrData1[shipmentIndex].CreatedDate,
            "OrderType": this.AllShipmentLogArrData1[shipmentIndex].OrderType
          }
        });


        console.log("this.AllShipmentLogArrData1::::::::::::::::", this.AllShipmentLogArrData1);

        let eleRemoved = this.AllShipmentLogArrData1.splice(shipmentIndex, 1);
        this.AllShipmentLogArrData1.unshift(eleRemoved[0]);
        this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
      }

    },

    getTrackShipmentSummeryDetails() {
      try {
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.chartData.data = {};
        this.OtherShipmentLogArr = [];
        this.OtherShipmentShippingIDCheckedArr = [];

        // Hide all main Div
        this.BagNumberTypeMainDiv = false;
        this.ShippingIDTypeMainDiv = false;
        this.MobileNumberTypeMainDiv = false;
        this.ClientOrderIDAWBModal = false;
        this.RaiseTicketDiv = false;
        this.POIDTypeMainDiv = false;
        
        this.ShippingID = this.ShippingID.trim();
        //#ip_track getTrackShipmentSummeryDetails
        /*Start IP Tracking */
        if(constantVariable.IP_Tracking_Enabled === 'Y'){
           
           let userTrackerObj = {};
           userTrackerObj.shippingId = this.ShippingID;
           userTrackerObj.userid = this.userid;
           userTrackerObj.username = this.username;
           userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
           userTrackerObj.projectname = apiUrl.project_name;
           userTrackerObj.trackurl = this.$route.path;
           //track_security_7627
           userTrackerObj.eventTrack = `Track Activity - ${this.SelectTypeOptionObj.text}`;
           userTrackerObj.shippingIds = this.ShippingID;
           userTrackerObj.searchReason = this.SelectReasonOptionObj.value || 'CustomerTicket';
           userTrackerObj.searchType = this.SelectTypeOptionObj.value;
           userTrackerObj.searchPurpose = this.SearchPurpose || '';
           if (this.SelectTypeOptionObj.value === 'ClientOrderID' && this.ClientOrderIDObj.value) {
             userTrackerObj.Client = this.ClientOrderIDObj.text;
           }
            authFunction.userTrackerSearchActivity(userTrackerObj);
           
        }

        /*End IP Tracking */
        if (this.SelectTypeOptionObj.value === 'MobileNumber') {
          this.getAllShipmentsByPhoneNo();
          return false;
        }
        // getAllShipmentsByPOID
        else if (this.SelectTypeOptionObj.value === 'POID') {
          this.getAllShipmentsByPOID();
          return false;
        }
        // getBagDetailsForCLTCRM
        else if (this.SelectTypeOptionObj.value === 'BagNumber') {
          this.getBagDetailsForCLTCRM();
          return false;
        }
        //get shipment details by ticket id
        else if (this.SelectTypeOptionObj.value === 'TicketID') {
          this.getShippingIdDetailsByTicketId();
          return false;
        }
        //get shipment details by Order ID
        else if (this.SelectTypeOptionObj.value === 'ClientOrderID') {
          this.getAllShipmentsByClientOrderID();
          return false;
        }
        //get shipment details by Shipping ID
        else if (this.SelectTypeOptionObj.value === 'ShippingID') {
          // === Shipment Validation -- Shipment should be greater than 8 && less than 20 && not alpha numeric 
          if (!commonFunction.validateShippingID(this.ShippingID)) {
            this.$alertify.error('Please enter valid Shipping ID.');
            return;
          }
          this.BagNoObj.TransitStatusModal = false;
          this.displayCurrentLocation = '';
          this.deliveryUserID = '';
        }

        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          'ShippingID': this.ShippingID
        })
        this.isLoading = true;
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'getTrackShipmentSummeryDetails',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                // call GetTrackLogs
                this.GetTrackLogs();
                let resultDataFinal = resultData.ShipmentDetails;
                //  Manual Delivery flag from UF 
                this.IsManualDelivery= resultDataFinal.IsManualDelivery;
                this.RTOAttemptCount= resultDataFinal.RTOAttemptCount;
                this.DTOAttemptCount= resultDataFinal.DTOAttemptCount;

                this.PrexoType= resultDataFinal.ExchangeType;
                this.PrexoShipment= resultDataFinal.ReferenceShipment;

                /*Start #escalation_tag  */
                this.ShipmentType =resultDataFinal.ShipmentType;
                this.EscalationType = 
                resultDataFinal.EscalationType === constantVariable.Escalation 
                ? `${this.ShipmentType} Escalation` 
                : resultDataFinal.EscalationType === constantVariable.SuperEscalation 
                ? `${this.ShipmentType} SuperEscalation` 
                : null;
                /*End #escalation_tag  */
                this.SalesDemo = resultDataFinal.ShipmentDetails;
                this.SalesDemo.EscalationType = resultDataFinal.EscalationType; //#escalation_tag
                this.SalesDemo.ShippingID = resultDataFinal.ShippingID;
                this.SalesDemo.EDD = (resultData.ShipmentDetails.ShipmentDetails && resultData.ShipmentDetails.ShipmentDetails.EDD && resultData.ShipmentDetails.ShipmentDetails.EDD != "null") ? resultData.ShipmentDetails.ShipmentDetails.EDD : null;
                this.SalesDemo.PDD = (resultData.ShipmentDetails.ShipmentDetails && resultData.ShipmentDetails.ShipmentDetails.PDD && resultData.ShipmentDetails.ShipmentDetails.PDD != "null") ? resultData.ShipmentDetails.ShipmentDetails.PDD : null;


                // Currently We are fetching EDD and PDD from Old system
                // this.SalesDemo.EDD = null;
                // this.SalesDemo.PDD = null;
                // this.getEDDPDD();


                // primary and Secondary in one
                let CustomerDetails;
                if ((this.SalesDemo.IsRedirect || this.SalesDemo.IsRedirectToBank) && this.SalesDemo.RedirectToAddress === 'Secondary') {
                  CustomerDetails = resultDataFinal.CustomerAlternateAddress;
                } else {
                  CustomerDetails = resultDataFinal.CustomerPrimaryAddress;
                }

                // Secondary Address for Banking Client
                this.CustomerAlternateAddress = resultDataFinal.CustomerAlternateAddress;

                this.CustomerDetails = CustomerDetails;
                this.CustomerDetails.CustomerName = CustomerDetails.Name;
                // === Decrypt CRM mobile number for secure transmission ===
                //  === Commented out code for stage env to test encdec lib ===
                this.CustomerDetails.PhoneNo = resultDataFinal.PrimaryPhone.PhoneNo;
                // if (resultDataFinal.PrimaryPhone && resultDataFinal.PrimaryPhone.PhoneNo) {
                // // this.CustomerDetails.PhoneNo = AES.decrypt(
                // //     resultDataFinal.PrimaryPhone.PhoneNo.replace(/_/g, "="),
                // //     constantVariable.enckey
                // //   ).toString(enc.Utf8);
                // this.CustomerDetails.PhoneNo= resultDataFinal.PrimaryPhone.PhoneNo;
                //   this.CustomerDetails.PhoneNoDisplay = this.displayPhoneNoPattern(this.CustomerDetails.PhoneNo);
                // } else {
                //   this.CustomerDetails.PhoneNo = null;
                //   this.CustomerDetails.PhoneNoDisplay = null;
                // }
                  if (resultDataFinal.PrimaryPhone && resultDataFinal.PrimaryPhone.PhoneNo) {
                    this.CustomerDetails.PhoneNoDisplay = resultDataFinal.PrimaryPhone.PhoneNo;
                  } else {
                    this.CustomerDetails.PhoneNoDisplay = null;
                  }
                if (resultDataFinal.SecondaryPhone && resultDataFinal.SecondaryPhone.PhoneNo) {
                  // this.CustomerDetails.PhoneNoAlt = AES.decrypt(
                  //   resultDataFinal.SecondaryPhone.PhoneNo.replace(/_/g, "="),
                  //   constantVariable.enckey
                  // ).toString(enc.Utf8);
                  this.CustomerDetails.PhoneNoAlt = resultDataFinal.SecondaryPhone.PhoneNo;
                  this.CustomerDetails.PhoneNoAltDisplay = this.CustomerDetails.PhoneNoAlt ;
                } else {
                  this.CustomerDetails.PhoneNoAlt = null;
                  this.CustomerDetails.PhoneNoAltDisplay = null;
                }
                // === Decrypt CRM mobile number for secure transmission ===

                // For RTO Details
                let RTODetails;
                if (resultDataFinal.ShipmentDetails.BusinessFlow === 'Reverse') {
                  RTODetails = resultDataFinal.DTOAddress.Addresses[0];


                } else {
                  RTODetails = resultDataFinal.RTODetailsAddresses.Addresses[0];
                }

                this.RTODetails = RTODetails;
                let AddressStrRTO;
                if (RTODetails.Address === null && RTODetails.City === null) {
                  AddressStrRTO = null;
                } else {
                  AddressStrRTO = RTODetails.Address + ", " + RTODetails.City + "-" + RTODetails.PinCode + ", " + RTODetails.State;
                }
                this.RTODetails.CustomerName = RTODetails.Name;
                this.RTODetails.AddressStr = AddressStrRTO;
                this.RTODetails.Address = RTODetails.Address;
                this.RTODetails.PinCode = RTODetails.PinCode;
                this.RTODetails.EmailID = RTODetails.EmailID;

                let RTODetailsContactDetails;
                if (resultDataFinal.ShipmentDetails.BusinessFlow === 'Reverse') {
                  RTODetailsContactDetails = resultDataFinal.DTOAddress.ContactDetails;

                  //MultipleProductInfo Assignment
                  this.MultipleProductInfo.MultipleProductInfoArr = [];
                  if (resultDataFinal.OrderDetails.ReverseProductDetails) {
                    this.MultipleProductInfo.MultipleProductInfoArr = resultDataFinal.OrderDetails.ReverseProductDetails;
                  } else {
                    this.MultipleProductInfo.MultipleProductInfoArr = [];
                  }

                } else {
                  RTODetailsContactDetails = resultDataFinal.RTODetailsAddresses.ContactDetails;
                }
                this.RTODetails.PhoneNo = RTODetailsContactDetails[0].PhoneNo;
                this.RTODetails.PhoneNoDisplay = this.displayPhoneNoPattern(this.RTODetails.PhoneNo);
                if (RTODetailsContactDetails.length > 1) {
                  this.RTODetails.PhoneNoAlt = RTODetailsContactDetails[1].PhoneNo;
                  this.RTODetails.PhoneNoAltDisplay = this.displayPhoneNoPattern(this.RTODetails.PhoneNoAlt);
                } else {
                  this.RTODetails.PhoneNoAlt = null;
                }


                // OFD OR OFP CHecking
                if (this.SalesDemo.BusinessFlow === 'Forward' && (this.SalesDemo.ProcessCode === 'P035' || (this.SalesDemo.Status === 'RTO' && this.SalesDemo.ProcessCode === 'P054' && this.SalesDemo.ReasonCode === 'XBU00302'))) {
                  this.SalesDemo.IsLatestOFD = true;
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && (this.SalesDemo.ProcessCode === 'P034' || ((this.SalesDemo.Status === 'DTO' || this.SalesDemo.Status === 'Shipped') && this.SalesDemo.ProcessCode === 'P035'))) {
                  this.SalesDemo.IsLatestOFD = true;
                } else {
                  this.SalesDemo.IsLatestOFD = false;
                }
              // Seller Escalation 7449 -- Added function fetch escalation tage value if shipping id status is pending -- start
              if(this.SalesDemo.Status === "Pending"){
                this.getEscalatedShipmentStatus(this.SalesDemo.ShippingID);
              }
              // Seller Escalation 7449 -- end

                // OTP Assignment
                this.OTPDetails.OTPDiv = false;
                this.OTPDetails.ShowOTPNo = false;
                this.OTPDetails.OTP = null;
                if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.IsLatestOFD) {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.DropSecurityCode; // OTP Assignment Forward
                } else if (this.SalesDemo.IsLatestOFD && this.SalesDemo.BusinessFlow === 'Reverse') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.PickupSecurityCode; // OTP Assignment Reverse
                } else if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.ReasonCode === 'XBU00358') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.DropSecurityCode; // OTP Assignment Forward
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && this.SalesDemo.ReasonCode === 'XBU00359') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.PickupSecurityCode; // OTP Assignment Reverse
                } else {
                  this.OTPDetails.OTPDiv = false;
                  this.OTPDetails.ShowOTPNo = false;
                }


                // showDeliveryOTP Assignment
                this.OTPDetails.DeliveryOTPDiv = false;
                this.OTPDetails.showDeliveryOTPNo = false;
                this.OTPDetails.DelivereyOTP = null;
                if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.IsLatestOFD) {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Forward
                } else if (this.SalesDemo.IsLatestOFD && this.SalesDemo.BusinessFlow === 'Reverse') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Reverse
                } else if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.ReasonCode === 'XBU00358') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Forward
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && this.SalesDemo.ReasonCode === 'XBU00359') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Reverse
                } else {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.showDeliveryOTPNo = true;
                }

                // For Sales Demo
                this.ShipmentTransactionLogSummary.OriginHubID = resultDataFinal.ShipmentDetails.OriginHubID;
                this.ShipmentTransactionLogSummary.CurrentHubID = resultDataFinal.ShipmentDetails.CurrentHubID;
                this.ShipmentTransactionLogSummary.FinalDestinationID = resultDataFinal.ShipmentDetails.FinalDestinationID;
                this.ShipmentTransactionLogSummary.BusinessFlow = resultDataFinal.ShipmentDetails.BusinessFlow;
                this.ShipmentTransactionLogSummary.IsHeavies = resultDataFinal.ShipmentDetails.IsHeavies;
                this.TotalMPSCollectibleAmount= resultDataFinal.TotalMPSCollectibleAmount;


                this.ShipmentTransactionLogSummary.ClientID = resultDataFinal.ShipmentDetails.ClientID;

                // For getting Client Name Id
                if (resultDataFinal.ShipmentDetails.ClientID > 0) {
                  // this.getClientDetailsById(resultDataFinal.ShipmentDetails.ClientID);
                }
                this.SalesDemo.ClientName = resultDataFinal.ShipmentDetails.BusinessAccountName;

                // For OrderDetails
                this.OrderDetails = resultDataFinal.OrderDetails;
                // For handeling ProductID null in Reverse DTO case
                if (resultDataFinal.ShipmentDetails.BusinessFlow === 'Reverse' && this.MultipleProductInfo.MultipleProductInfoArr.length) {
                  this.OrderDetails.ProductID = this.OrderDetails.ProductID ? this.OrderDetails.ProductID : this.MultipleProductInfo.MultipleProductInfoArr[0].ProductID;
                  this.OrderDetails.ProductName = this.OrderDetails.ProductName ? this.OrderDetails.ProductName : this.MultipleProductInfo.MultipleProductInfoArr[0].ProductName;
                }
                this.ShippingIDTypeMainDiv = true;

                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

                  for (let i = 0; i < this.category.Forward.length; i++) {

                    if (this.category.Forward[i].Status.toLowerCase() == resultDataFinal.ShipmentDetails.Status.toLowerCase() && this.category.Forward[i].ShipmentStatus.toLowerCase() == resultDataFinal.ShipmentDetails.ShipmentStatus.toLowerCase()) {

                      this.categoryOptionObj.text = this.category.Forward[i].name;
                      this.categoryOptionObj.value = this.category.Forward[i].name;
                    }
                  }
                }
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

                  for (let i = 0; i < this.category.Reverse.length; i++) {

                    if (this.category.Reverse[i].Status.toLowerCase() == resultDataFinal.ShipmentDetails.Status.toLowerCase() && this.category.Reverse[i].ShipmentStatus.toLowerCase() == resultDataFinal.ShipmentDetails.ShipmentStatus.toLowerCase()) {

                      this.categoryOptionObj.text = this.category.Reverse[i].name;
                      this.categoryOptionObj.value = this.category.Reverse[i].name;
                    }

                  }
                }
                if (this.categoryOptionObj.text == '') {
                  this.categoryOptionObj.text = 'Unidentified';
                  this.categoryOptionObj.value = 'Unidentified';
                }

                //IsCSAW Logic
                if (['ClientInstructionAwaiting', 'Pending', 'Hold'].includes(this.OrderDetails.NotificationStatus)) {
                  this.SalesDemo.IsCSAW = "Yes";
                } else {
                  this.SalesDemo.IsCSAW = "No";
                }
                if (resultDataFinal.ShipmentDetails.IsHeavies == true) {
                  this.getAllShipmentsByMPSGroupID();
                }
                // not calling api getAllShipmentsByPhoneNo  for banking  "PhoneNo":"9999999999"
                else if (this.CustomerDetails.PhoneNo && this.CustomerDetails.PhoneNo != '9999999999') {
                  // call phone no api from shipmentupdate
                // === For Security Purpose Restricting getAllShipmentsByPhoneNo API //
                  // this.getAllShipmentsByPhoneNo();
                  this.getAllShipmentsWithoutPhoneNo();
                // === For Security Purpose Restricting getAllShipmentsByPhoneNo API //
                } else {
                  this.getAllShipmentsWithoutPhoneNo();
                }
                if (this.DepartmentID === constantVariable.RTO_DTO_Verfication){
                  this.setUApayloadFlag();
                }

              } else {
                this.isLoading = false;
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              this.isLoading = false;
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
      } catch (error) {

        this.isLoading = false;
        let msg = error + " - getTrackShipmentSummeryDetails";
        this.$alertify.error(msg);
      }
    },

    showOTP() {
      try {
        if (!this.OTPDetails.OTP) {
          this.$alertify.error('NDR Code not available.');
          return false;
        }
        this.isLoading = true;
        this.input = ({
          "otp": this.OTPDetails.OTP.toString(),
          "userid": (this.userid) ? this.userid : 0,
          "email": (this.email) ? this.email : "",
          "username": (this.username) ? this.username : "",
          "firstname": (this.firstname) ? this.firstname : "",
          "lastname": (this.lastname) ? this.lastname : "",
        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'insertOTPLog',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              this.OTPDetails.ShowOTPNo = true;
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            // console.log("error ===>" + JSON.stringify(error));
            this.isLoading = false;
            //let msg = error;
            let msg = "API Server is down for - Show NDR Code";
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - showOTP";
        this.$alertify.error(msg);
      }
    },


    showDeliveryOTP() {
      try {
        if (!this.OTPDetails.DelivereyOTP) {
          this.$alertify.error('Delivery Code not available.');
          return false;
        }
        this.isLoading = true;
        this.input = ({

          "otp": this.OTPDetails.DelivereyOTP.toString(),
          "userid": (this.userid) ? this.userid : 0,
          "email": (this.email) ? this.email : "",
          "username": (this.username) ? this.username : "",
          "firstname": (this.firstname) ? this.firstname : "",
          "lastname": (this.lastname) ? this.lastname : "",
          "otptype": "Delivery",
          // "otptype": (this.otptype) ? this.otptype : "",

        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'insertOTPLog',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            //  console.log(OTP);
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              this.OTPDetails.showDeliveryOTPNo = true;
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            // console.log("error ===>" + JSON.stringify(error));
            this.isLoading = false;
            //let msg = error;
            let msg = "API Server is down for - Show NDR Code";
            this.$alertify.error(msg);
          })
      } catch (error) {
        console.log(error);
        let msg = error + " - showDeliveryOTP";
        this.$alertify.error(msg);
      }
    },

    getAllShipmentsWithoutPhoneNo() {
      try {
        this.ticketIDLoader = true;
        this.OtherShipments.showChart = false;
        let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0];
        } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          this.OtherShipments.chartData.labels = ["Pick Done", "Not Picked", "DTO", "Cancelled", "DTO Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "orange", "blue", "red", "gray"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0, 0, 0];
        }
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.DTOCnt = 0;
        this.OtherShipments.NotPickedCnt = 0;
        this.OtherShipments.PickDoneCnt = 0;
        this.OtherShipments.CancelledCnt = 0;
        this.OtherShipments.DTOUndeliveredCnt = 0;
        this.isLoading = false;
        this.OtherShipmentLogArr = [];

        this.arrayofobj = [];
        this.categoryCatalogue = [];
        this.ticketIDLoader = false;
        let resultData = {};

        resultData.Shipments = [{
          "ShippingID": this.ShippingID,
          "Status": this.SalesDemo.Status,
          "CurrentStatus": this.SalesDemo.ShipmentStatus,
          "ClientID": this.SalesDemo.ClientID,
          "CreatedDate": this.SalesDemo.CreatedDate,
          "TotalAttemptCount": this.SalesDemo.TotalAttemptCount,
          "BusinessAccountName": this.SalesDemo.BusinessAccountName,
          "BusinessFlow": this.SalesDemo.BusinessFlow,
          "CurrentHubID": this.SalesDemo.CurrentHubID,
          "OriginHubID": this.SalesDemo.OriginHubID,
          "FinalDestinationID": this.SalesDemo.FinalDestinationID,
          "OrderType": this.OrderDetails.OrderType,
          "CollectibleAmount": this.OrderDetails.CollectibleAmount,
          "BusinessType": this.SalesDemo.BusinessType
        }];
        let flag = false;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          for (let i = 0; i < resultData.Shipments.length; i++) {
            let indexStatus = this.category.Forward.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

            if (-1 !== indexStatus && undefined !== this.category.Forward[indexStatus]) {
              if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Forward[indexStatus].name)) {
                this.arrayofobj.push({
                  text: this.category.Forward[indexStatus].name,
                  value: this.category.Forward[indexStatus].name
                });
              }
            } else {
              flag = true;

              if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                this.UnCategorizedArrData.push(resultData.Shipments[i]);
              }

            }
          }
        }
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          for (let i = 0; i < resultData.Shipments.length; i++) {
            let indexStatus = this.category.Reverse.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

            if (-1 !== indexStatus && undefined !== this.category.Reverse[indexStatus]) {
              if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Reverse[indexStatus].name)) {
                this.arrayofobj.push({
                  text: this.category.Reverse[indexStatus].name,
                  value: this.category.Reverse[indexStatus].name
                });
              }

            } else {
              flag = true;
              if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                this.UnCategorizedArrData.push(resultData.Shipments[i]);
              }
            }
          }
        }

        if (flag == true) {
          this.arrayofobj.push({
            text: 'Unidentified',
            value: 'Unidentified'
          });
        }

        let OtherShipmentLog = resultData.Shipments;
        let OtherShipmentLogCnt = OtherShipmentLog.length;
        this.OtherShipmentLogCnt = OtherShipmentLogCnt;
        if (OtherShipmentLogCnt > 0) {
          this.OtherShipmentLogArr = [];

          this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
          this.OtherShipments.ClientName = "";

          //Start DoughnutChart Logic
          let i;
          for (i = 0; i < OtherShipmentLogCnt; i++) {
            //  OtherShipmentLog[i].ClientName = "";
            OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;

            this.OtherShipmentLogArr.push(OtherShipmentLog[i]);

            if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
              if (OtherShipmentLog[i].Status === "Delivered") {
                this.OtherShipments.DeliveredCnt++;
              }
              if (OtherShipmentLog[i].Status === "RTO") {
                this.OtherShipments.RTOCnt++;
              }
            } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {


              if (OtherShipmentLog[i].Status === "DTO" && OtherShipmentLog[i].CurrentStatus === "WHHandover") {
                this.OtherShipments.DTOCnt++;
              }
              if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "Pending" || OtherShipmentLog[i].CurrentStatus === "OutForPickup" || OtherShipmentLog[i].CurrentStatus === "PickupAssinged" || OtherShipmentLog[i].CurrentStatus === "PickupNotDone" || OtherShipmentLog[i].CurrentStatus === "ReinitiatedPickups")) {
                this.OtherShipments.NotPickedCnt++;
              }

              if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "PickupDone" || OtherShipmentLog[i].CurrentStatus === "PickupDoneBySR")) {
                this.OtherShipments.PickDoneCnt++;
              }

              if (OtherShipmentLog[i].Status === "RPCancel" && OtherShipmentLog[i].CurrentStatus === "RPCancel") {
                this.OtherShipments.CancelledCnt++;
              }

              if (OtherShipmentLog[i].Status === "Shipped" && (OtherShipmentLog[i].CurrentStatus === "InScan" || OtherShipmentLog[i].CurrentStatus === "Inscan")) {
                this.OtherShipments.DTOUndeliveredCnt++;
              }
            }

            // get ClientName by ID
            if (OtherShipmentLog[i].ClientID > 0) {
              // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
            }

            //console.log( 'OtherShipmentLog data Graph: '+JSON.stringify(OtherShipmentLog[i] ));

          }

          this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
          this.showStats();
          this.selectedOptionObj(this.categoryOptionObj);
          //End DoughnutChart Logic

        } else {
          this.OtherShipmentLogArr = [];
        }

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getAllShipmentsWithoutPhoneNo";
        // console.log("msg==" + msg);
        this.$alertify.error(msg);
      }
    },

    getAllShipmentsWithoutPhoneNo_old() {
      this.ticketIDLoader = true;
      this.OtherShipments.showChart = false;
      let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;
      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
        this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
        this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
      } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
        this.OtherShipments.chartData.labels = ["Pick Done", "Not Picked", "DTO", "Cancelled", "DTO Undelivered"];
        this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "orange", "blue", "red", "gray"];
      }
      this.OtherShipments.DeliveredCnt = 0;
      this.OtherShipments.RTOCnt = 0;
      this.OtherShipments.UndeliverdCnt = 0;
      this.OtherShipments.ClientName = "";

      this.OtherShipments.DTOCnt = 0;
      this.OtherShipments.NotPickedCnt = 0;
      this.OtherShipments.PickDoneCnt = 0;
      this.OtherShipments.CancelledCnt = 0;
      this.OtherShipments.DTOUndeliveredCnt = 0;

      this.OtherShipmentLogArr = [];
      let PhoneNo;

      let OtherShipmentLog = [{
        "ShippingID": this.ShippingID,
        "Status": this.SalesDemo.Status,
        "CurrentStatus": this.SalesDemo.ShipmentStatus,
        "ClientID": this.SalesDemo.ClientID,
        "CreatedDate": this.SalesDemo.CreatedDate,
        "TotalAttemptCount": this.OrderDetails.TotalAttemptCount,
        "BusinessAccountName": this.SalesDemo.BusinessAccountName,
        "BusinessFlow": this.SalesDemo.BusinessFlow,
        "CurrentHubID": this.SalesDemo.CurrentHubID,
        "OriginHubID": this.SalesDemo.OriginHubID,
        "FinalDestinationID": this.SalesDemo.FinalDestinationID,
        "OrderType": this.OrderDetails.OrderType,
        "CollectibleAmount": this.OrderDetails.CollectibleAmount,
        "BusinessType": this.SalesDemo.BusinessType
      }];
      let OtherShipmentLogCnt = OtherShipmentLog.length;
      this.OtherShipmentLogCnt = OtherShipmentLogCnt;
      if (OtherShipmentLogCnt > 0) {
        this.OtherShipmentLogArr = [];
        this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);

        //Start DoughnutChart Logic

        let i;
        for (i = 0; i < OtherShipmentLogCnt; i++) {
          //  OtherShipmentLog[i].ClientName = "";
          OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;
          this.OtherShipmentLogArr.push(OtherShipmentLog[i]);
          if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
            if (OtherShipmentLog[i].Status === "Delivered") {
              this.OtherShipments.DeliveredCnt++;
            }
            if (OtherShipmentLog[i].Status === "RTO") {
              this.OtherShipments.RTOCnt++;
            }
          } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

            if (OtherShipmentLog[i].Status === "DTO" && OtherShipmentLog[i].CurrentStatus === "WHHandover") {
              this.OtherShipments.DTOCnt++;
            }
            if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "Pending" || OtherShipmentLog[i].CurrentStatus === "OutForPickup" || OtherShipmentLog[i].CurrentStatus === "PickupAssinged" || OtherShipmentLog[i].CurrentStatus === "PickupNotDone" || OtherShipmentLog[i].CurrentStatus === "ReinitiatedPickups")) {
              this.OtherShipments.NotPickedCnt++;
            }

            if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "PickupDone" || OtherShipmentLog[i].CurrentStatus === "PickupDoneBySR")) {
              this.OtherShipments.PickDoneCnt++;
            }

            if (OtherShipmentLog[i].Status === "RPCancel" && OtherShipmentLog[i].CurrentStatus === "RPCancel") {
              this.OtherShipments.CancelledCnt++;
            }

            if (OtherShipmentLog[i].Status === "Shipped" && (OtherShipmentLog[i].CurrentStatus === "InScan" || OtherShipmentLog[i].CurrentStatus === "Inscan")) {
              this.OtherShipments.DTOUndeliveredCnt++;
            }
          }

          // get ClientName by ID
          if (OtherShipmentLog[i].ClientID > 0) {
            // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
          }

          //  console.log('OtherShipmentLog data Graph: ' + JSON.stringify(OtherShipmentLog[i]));

        }
        //    console.log('OtherShipmentLog data: ' + JSON.stringify(this.OtherShipmentLogArr));
        this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
        this.showStats();
        this.selectedOptionObj(this.categoryOptionObj);
        //End DoughnutChart Logic

      } else {
        this.OtherShipmentLogArr = [];
      }
      this.ticketIDLoader = false;
    },

    displayPhoneNoPattern(PhoneNo) {
      try {
        let PhoneNoDisplay = null;
        if (PhoneNo) {
          PhoneNoDisplay = new Array(PhoneNo.length - 3).join('X') + PhoneNo.substr(PhoneNo.length - 4, 4);
        }
        return PhoneNoDisplay;
      } catch (error) {
        let msg = error + " Something went wrong in Display Phone No Pattern.";
        this.$alertify.error(msg);
      }
    },


    // GetTrackLogs
    GetTrackLogs() {
      try {
        this.ShipmentTransactionLogSummary = {};
        this.SalesDemo.DeliveryDateTime = null;
        // this.MobileNumberTypeMainDiv = false;
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Shipping ID.');
          return false;
        }

        //  this.isLoading = true;
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          ShippingID: this.ShippingID
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetTrackLogs',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode == 100) {
                let ShipmentTransactionLogSummary = resultData.ShipmentDetails;

                this.SalesDemo.DeliveryDateTime = ShipmentTransactionLogSummary.DeliveryDateTime;

                this.ShipmentTransactionLogSummary.lastNDRUserProcess = ShipmentTransactionLogSummary.lastNDRUserProcess;
                this.ShipmentTransactionLogSummary.LastNDRDate = ShipmentTransactionLogSummary.LastNDRDate;
                this.ShipmentTransactionLogSummary.lastCSAWUserProcess = ShipmentTransactionLogSummary.lastCSAWUserProcess;
                this.ShipmentTransactionLogSummary.LastCSAWDate = ShipmentTransactionLogSummary.LastCSAWDate;

                // For Map Logic
                this.deliveryUserID = ShipmentTransactionLogSummary.DeliveryUserID
                if (this.deliveryUserID > 0) {
                  //  this.deliveryUserID = 1584;
                  if ((this.SalesDemo.BusinessFlow === 'Forward' && (this.SalesDemo.ProcessCode === 'P035' || this.SalesDemo.ProcessCode === 'P054')) || (this.SalesDemo.BusinessFlow === 'Reverse' && (this.SalesDemo.ProcessCode === 'P035' || this.SalesDemo.ProcessCode === 'P034'))) {
                    this.fetchSrUserDetailsData(this.deliveryUserID);
                    this.fetchSrLocationDetailsData(this.deliveryUserID);
                  }
                }

                if (ShipmentTransactionLogSummary.ManifestDataReceived) {
                  this.ShipmentTransactionLogSummary.ManifestDate = ShipmentTransactionLogSummary.ManifestDataReceived;
                  this.ShipmentTransactionLogSummary.DataReceived = "Manifest Data Received via " + this.SalesDemo.SourceType + " " + ShipmentTransactionLogSummary.ManifestDataReceived;
                  //  this.ShipmentTransactionLogSummary.DataReceived = "Manifest Data Received " + ShipmentTransactionLogSummary.ManifestDataReceived;
                } else {
                  this.ShipmentTransactionLogSummary.DataReceived = null;
                  this.ShipmentTransactionLogSummary.ManifestDate = null;
                }

                if (ShipmentTransactionLogSummary.OriginHubInScan) {
                  this.ShipmentTransactionLogSummary.OriginHubData = "Origin InScan " + ShipmentTransactionLogSummary.OriginHubInScan;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.OriginHubID, "O");
                } else {
                  // this.ShipmentTransactionLogSummary.OriginHubData = null;
                  this.ShipmentTransactionLogSummary.OriginHubData = "Origin InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.OriginHubID, "O");
                }


                // IF OriginHubID is equal to FinalDestinationID then hide OriginHubData Div
                if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  this.short_short_connecting_line = true;
                  this.short_short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = false;

                } else if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.CurrentHubID || this.ShipmentTransactionLogSummary.CurrentHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  // IF CurrentHubID is equal to FinalDestinationID then hide currentHubData Div
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = true;
                  this.short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                } else {
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = false;
                  this.short_glyphprogress = false;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                }

                // IF OriginHubID is equal to FinalDestinationID then hide OriginHubData Div
                if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  this.short_short_connecting_line = true;
                  this.short_short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = false;

                } else if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.CurrentHubID || this.ShipmentTransactionLogSummary.CurrentHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  // IF CurrentHubID is equal to FinalDestinationID then hide currentHubData Div
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = true;
                  this.short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                } else {
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = false;
                  this.short_glyphprogress = false;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                }

                if (ShipmentTransactionLogSummary.CurrentHubInscanDate) {
                  this.ShipmentTransactionLogSummary.currentHubData = "Transit InScan " + ShipmentTransactionLogSummary.CurrentHubInscanDate;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.CurrentHubID, "C");
                } else {
                  this.ShipmentTransactionLogSummary.currentHubData = "Transit InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.CurrentHubID, "C");
                }

                if (ShipmentTransactionLogSummary.DestinationHubInscanDate) {
                  this.ShipmentTransactionLogSummary.DestinationHubData = "Destination InScan " + ShipmentTransactionLogSummary.DestinationHubInscanDate;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.FinalDestinationID, "D");
                } else {
                  //this.ShipmentTransactionLogSummary.DestinationHubData = null;
                  this.ShipmentTransactionLogSummary.DestinationHubData = "Destination InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.FinalDestinationID, "D");
                }


                //old Lgic//   if (ShipmentTransactionLogSummary.DeliveryDateTime) {
                //Lastest Stage Blinking logic
                if (ShipmentTransactionLogSummary.DeliveryDateTime && (this.SalesDemo.Status === 'Delivered' || this.SalesDemo.ShipmentStatus === 'WHHandover')) {
                  this.ShipmentTransactionLogSummary.IsLatestDeliveryDateTime = true;
                } else if (this.SalesDemo.IsLatestOFD) {
                  this.ShipmentTransactionLogSummary.IsLatestOFD = true;
                } else if (ShipmentTransactionLogSummary.DestinationHubInscanDate) {
                  this.ShipmentTransactionLogSummary.IsLatestDestinationHubInscanDate = true;
                } else if (ShipmentTransactionLogSummary.CurrentHubInscanDate && this.ShipmentTransactionLogSummary.OriginHubID != this.ShipmentTransactionLogSummary.CurrentHubID && this.ShipmentTransactionLogSummary.FinalDestinationID != this.ShipmentTransactionLogSummary.CurrentHubID) {
                  this.ShipmentTransactionLogSummary.IsLatestCurrentHubInscanDate = true;
                } else if (ShipmentTransactionLogSummary.OriginHubInScan) {
                  this.ShipmentTransactionLogSummary.IsLatestOriginHubInScan = true;
                } else if (ShipmentTransactionLogSummary.ManifestDataReceived) {
                  this.ShipmentTransactionLogSummary.IsLatestManifestDataReceived = true;
                }

                // To Display hub Name Logic
                setTimeout(() => {
                  this.ShippingID = null;
                  this.ShippingID = this.SalesDemo.ShippingID;
                  this.$refs.RefShippingID.focus();
                }, 2000);

              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - GetTrackLogs";
        this.$alertify.error(msg);
      }
    },

    // getBagDetailsForCLTCRM
    getBagDetailsForCLTCRM() {
      // Hide all main Div
      this.BagNoObj.TransitStatusModal = false
      this.BagNumberTypeMainDiv = false;
      if (this.ShippingID === '') {
        this.$alertify.error('Please enter Bag Number.');
        return false;
      }

      this.isLoading = true;
      // var token = window.localStorage.getItem('userToken')
      // var versionNumber = window.localStorage.getItem('versionNumber')
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      let versionNumber = 'v1';
      this.input = ({
        ShippingID: this.ShippingID
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getBagDetailsForCLTCRM',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          this.isLoading = false;

          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.ResultCode === 100) {
              let resultDataFinal = resultData.ResponseData;
              // For Bag Details
              this.BagNoObj.BagDetails = resultDataFinal.BagDetails[0];
              this.BagNoObj.AuditLogArr = [];
              this.BagNoObj.AuditLogArr = resultDataFinal.AuditLog;
              this.BagNumberTypeMainDiv = true;
            } else {
              let msg = resultData.ReturnMessage;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {}, error => {}, error => {
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        })
    },

    getClientDetailsById(id, i = -1) {
      this.input = ({
        id: id
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientDetailsById',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let response = resultDataCrm.data;
            if (response.code === 200) {

              if (i >= 0) {
                this.OtherShipmentLogArr[i].ClientName = response.data[0].CompanyName;
              } else {
                this.SalesDemo.ClientName = response.data[0].CompanyName;
              }

            } else {
              let msg = response.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
    },

    getHubDetailById(HubId, HubSource) {
      try {
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(HubId.toString(), secretKey).toString();
        let ecHubId = encryptedData.replace(/[=]/g, '_');
        this.input = ({
          id: ecHubId
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getHubDetailById',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let response = resultDataCrm.data;
              let HubNameStr = '';
              let ProcessLocation = '';
              if (response.code === 200) {
                HubNameStr = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
                if (HubSource === "O") {
                  this.ShipmentTransactionLogSummary.OriginHubData = this.ShipmentTransactionLogSummary.OriginHubData + " " + HubNameStr;
                }
                if (HubSource === "C") {
                  this.ShipmentTransactionLogSummary.currentHubData = this.ShipmentTransactionLogSummary.currentHubData + " " + HubNameStr;
                  this.OrderDetails.EmailServiceCenter = response.data[0].HubEmailId;
                }
                if (HubSource === "D") {
                  this.ShipmentTransactionLogSummary.DestinationHubData = this.ShipmentTransactionLogSummary.DestinationHubData + " " + HubNameStr;
                } else if (HubSource >= 0) {
                  HubNameStr = response.data[0].HubName;
                  // For ShipmentLog ProcessLocation
                  ProcessLocation = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].ProcessLocation = ProcessLocation;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].HubName = HubNameStr;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].CurrentHubName = HubNameStr;
                }
              } else {
                let msg = response.message;
                this.$alertify.error(msg);
              }

            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - getHubDetailById";
        this.$alertify.error(msg);
      }
    },

    // Mobile Number TimeOut
    getAllShipmentsByPhoneNo() {
      try {
        this.ticketIDLoader = true;
        this.OtherShipments.showChart = false;
        let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0];
        } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          this.OtherShipments.chartData.labels = ["Pick Done", "Not Picked", "DTO", "Cancelled", "DTO Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "orange", "blue", "red", "gray"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0, 0, 0];
        }
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.DTOCnt = 0;
        this.OtherShipments.NotPickedCnt = 0;
        this.OtherShipments.PickDoneCnt = 0;
        this.OtherShipments.CancelledCnt = 0;
        this.OtherShipments.DTOUndeliveredCnt = 0;
        this.isLoading = true;
        this.OtherShipmentLogArr = [];
        let PhoneNo;
        if (this.SelectTypeOptionObj.value === 'MobileNumber') {
          businessFlow = "All";
          PhoneNo = this.ShippingID;
          this.ShippingIDTypeMainDiv = false;
          this.MobileNumberTypeMainDiv = false;
        } else {

          PhoneNo = this.CustomerDetails.PhoneNo;
        }

        if (PhoneNo === '') {
          this.$alertify.error('Please enter Phone No.');
          return false;
        }

        let SelectedShippingID = this.ShippingID;
        if (this.SelectTypeOptionObj.value === 'MobileNumber') {

          this.isLoading = true;
          SelectedShippingID = null;
        } else {

          this.OtherShipments.isLoading = true;
        }
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(PhoneNo, secretKey).toString();
        let ecPhoneNo = encryptedData.replace(/[=]/g, '_');
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          PhoneNo: ecPhoneNo,
          Type: businessFlow,
          ShippingId: SelectedShippingID,
        })
        axios({
            'timeout': 40000, // TimeOut Forcefully
            'method': 'POST',
            'url': apiUrl.api_url + 'getAllShipmentsByPhoneNo',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.arrayofobj = [];
            this.categoryCatalogue = [];
            if (this.SelectTypeOptionObj.value === 'MobileNumber') {
              this.isLoading = false;
            } else {
              this.OtherShipments.isLoading = false;
            }
            this.ticketIDLoader = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {

                let flag = false;
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                  for (let i = 0; i < resultData.Shipments.length; i++) {
                    let indexStatus = this.category.Forward.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

                    if (-1 !== indexStatus && undefined !== this.category.Forward[indexStatus]) {
                      if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Forward[indexStatus].name)) {
                        this.arrayofobj.push({
                          text: this.category.Forward[indexStatus].name,
                          value: this.category.Forward[indexStatus].name
                        });
                      }
                    } else {
                      flag = true;

                      if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                        this.UnCategorizedArrData.push(resultData.Shipments[i]);
                      }

                    }
                  }
                }
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
                  for (let i = 0; i < resultData.Shipments.length; i++) {
                    let indexStatus = this.category.Reverse.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

                    if (-1 !== indexStatus && undefined !== this.category.Reverse[indexStatus]) {
                      if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Reverse[indexStatus].name)) {
                        this.arrayofobj.push({
                          text: this.category.Reverse[indexStatus].name,
                          value: this.category.Reverse[indexStatus].name
                        });
                      }

                    } else {
                      flag = true;
                      if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                        this.UnCategorizedArrData.push(resultData.Shipments[i]);
                      }
                    }
                  }
                }

                if (flag == true) {
                  this.arrayofobj.push({
                    text: 'Unidentified',
                    value: 'Unidentified'
                  });
                }
                let OtherShipmentLog = resultData.Shipments;
                let OtherShipmentLogCnt = OtherShipmentLog.length;
                this.OtherShipmentLogCnt = OtherShipmentLogCnt;
                if (OtherShipmentLogCnt > 0) {
                  this.OtherShipmentLogArr = [];

                  this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
                  this.OtherShipments.ClientName = "";

                  //Start DoughnutChart Logic
                  let i;
                  for (i = 0; i < OtherShipmentLogCnt; i++) {
                    //  OtherShipmentLog[i].ClientName = "";
                    OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;

                    this.OtherShipmentLogArr.push(OtherShipmentLog[i]);

                    if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                      if (OtherShipmentLog[i].Status === "Delivered") {
                        this.OtherShipments.DeliveredCnt++;
                      }
                      if (OtherShipmentLog[i].Status === "RTO") {
                        this.OtherShipments.RTOCnt++;
                      }
                    } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {


                      if (OtherShipmentLog[i].Status === "DTO" && OtherShipmentLog[i].CurrentStatus === "WHHandover") {
                        this.OtherShipments.DTOCnt++;
                      }
                      if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "Pending" || OtherShipmentLog[i].CurrentStatus === "OutForPickup" || OtherShipmentLog[i].CurrentStatus === "PickupAssinged" || OtherShipmentLog[i].CurrentStatus === "PickupNotDone" || OtherShipmentLog[i].CurrentStatus === "ReinitiatedPickups")) {
                        this.OtherShipments.NotPickedCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "PickupDone" || OtherShipmentLog[i].CurrentStatus === "PickupDoneBySR")) {
                        this.OtherShipments.PickDoneCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "RPCancel" && OtherShipmentLog[i].CurrentStatus === "RPCancel") {
                        this.OtherShipments.CancelledCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "Shipped" && (OtherShipmentLog[i].CurrentStatus === "InScan" || OtherShipmentLog[i].CurrentStatus === "Inscan")) {
                        this.OtherShipments.DTOUndeliveredCnt++;
                      }
                    }

                    // get ClientName by ID
                    if (OtherShipmentLog[i].ClientID > 0) {
                      // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
                    }

                    //console.log( 'OtherShipmentLog data Graph: '+JSON.stringify(OtherShipmentLog[i] ));

                  }

                  this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
                  this.showStats();
                  this.selectedOptionObj(this.categoryOptionObj);
                  //End DoughnutChart Logic

                } else {
                  this.OtherShipmentLogArr = [];
                }
                if (this.SelectTypeOptionObj.value === 'MobileNumber') {
                  this.ShippingIDTypeMainDiv = false;
                  this.MobileNumberTypeMainDiv = true;
                } else {
                  // else condition
                }
              } else {
                // let msg = resultData.ReturnMessage;
                // this.$alertify.error(msg);
                this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
              }
            } else {
              // let msg = resultDataCrm.msg;
              // this.$alertify.error(msg);
              this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
            }
          }, error => {

            if (this.SelectTypeOptionObj.value === 'MobileNumber') {
              this.isLoading = false;
            } else {
              this.OtherShipments.isLoading = false;
            }

            //  var commonVariable = commonFunction.showNetworkError(error);
            //   this.$alertify.error(commonVariable);
            this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
          })
      } catch (error) {
        if (this.SelectTypeOptionObj.value === 'MobileNumber') {
          this.isLoading = false;
        } else {
          this.OtherShipments.isLoading = false;
        }
        let msg = error + " - getAllShipmentsByPhoneNo";
        // console.log("msg==" + msg);
        // this.$alertify.error(msg);
        this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
      }
    },

    getAllShipmentsByPOID() {
      try {

        this.isLoading = true;
        this.poIdShipmentArr = [];
        let poId;
        let businessFlow;
        if (this.SelectTypeOptionObj.value === 'POID') {
          businessFlow = "All";
          poId = this.ShippingID;
          // this.ShippingIDTypeMainDiv = false;
          this.POIDTypeMainDiv = false;
        }

        if (poId === '') {
          this.$alertify.error('Please enter Client Order ID.');
          return false;
        }

        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          POID: poId
        })
        axios({
            'timeout': 40000, // TimeOut Forcefully
            'method': 'POST',
            'url': apiUrl.api_url + 'getAllShipmentsByPOID',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.poIdShipmentArr = [];
                this.poIdShipmentArr = resultData.Shipments;
                this.POIDTypeMainDiv = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getAllShipmentsByPOID";
        this.$alertify.error(msg);
      }
    },

    showStats() {
      // this.$alertify.error("this.OtherShipments "+JSON.stringify(this.OtherShipments));
      this.OtherShipments.showChart = true;
      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
        this.OtherShipments.chartData.datasets[0].data = [this.OtherShipments.DeliveredCnt, this.OtherShipments.RTOCnt, this.OtherShipments.UndeliveredCnt];
      } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
        this.OtherShipments.chartData.datasets[0].data = [this.OtherShipments.PickDoneCnt, this.OtherShipments.NotPickedCnt, this.OtherShipments.DTOCnt, this.OtherShipments.CancelledCnt, this.OtherShipments.DTOUndeliveredCnt];
      }
    },

    //  showShipmentLogModal From legacy system
    showShipmentLogModal_old() {
      try {
        this.isLoadingCurrentStatusDiv = true;
        this.ShipmentLog.ShipmentLogBarArr = [];
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        let xbkey = 'xbkey2';
        this.input = ({
          ShippingID: this.ShippingID,
          ManifestDate: this.ShipmentTransactionLogSummary.ManifestDate
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetTrackShipmentLogDetailsLegacy',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(async result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
                this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
                if (this.ShipmentLog.ShipmentLogCnt && this.ShipmentLog.ShipmentLogCnt > 0) {

                  for (let i = 0; i < this.ShipmentLog.ShipmentLogCnt; i++) {
                    this.ShipmentLog.ShipmentLogBarArr[i].UserName = this.ShipmentLog.ShipmentLogBarArr[i].CreatedBy;
                    this.ShipmentLog.ShipmentLogBarArr[i].UserProcess = this.ShipmentLog.ShipmentLogBarArr[i].Process;
                    this.ShipmentLog.ShipmentLogBarArr[i].Comments = this.ShipmentLog.ShipmentLogBarArr[i].Comment;
                    this.ShipmentLog.ShipmentLogBarArr[i].ProcessLocation = this.ShipmentLog.ShipmentLogBarArr[i].CurrentLocation + " (" + this.ShipmentLog.ShipmentLogBarArr[i].ProcessLocation + ")";
                  }

                } else {
                  let msg = resultData.ReturnMessage;
                  this.$alertify.error(msg);
                }
                // Merge recording data
                if (this.IVRCallRecording.IVRCallRecordingBtn) {
                  // Currently commented
                  // await this.getIVRCallRecordingData();
                } else {
                  // dont merge data
                }


                this.ShipmentLogModal = true
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        this.ShipmentLogModal = false;
        let msg = error + " - showShipmentLogModal";
        this.$alertify.error(msg);
      }
    },


    //  showShipmentLogModal old from shipment update new framework
    showShipmentLogModal() {
      try {
        this.isLoadingCurrentStatusDiv = true;
        this.ShipmentLog.ShipmentLogBarArr = [];
        this.rtoNotificationLogArr = [];
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        let xbkey = 'xbkey2';
        this.input = ({
          ShippingID: this.ShippingID,
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetTrackShipmentLogDetails',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(async result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                for (let i = 0; i < resultData.Result.length; i++) {
                  if (resultData.Result[i].CurrentHubName > 0) {
                    this.getHubDetailById(resultData.Result[i].CurrentHubName, i);
                  }
                }
                this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
                this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
                // Merge recording data
                if (this.IVRCallRecording.IVRCallRecordingBtn) {
                  // Currently commented
                  // await this.getIVRCallRecordingData();
                } else {
                  // dont merge data
                }
                this.ShipmentLogModal = true
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        this.ShipmentLogModal = false;
        let msg = error + " - showShipmentLogModal";
        this.$alertify.error(msg);
      }
    },

    //Start For Map Display
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    },

    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.infoContent = marker.full_name;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
    //End For Map Display

    ShowRaiseTicketDiv() {
      try {
        this.resetForm();
        this.ticketTaggingDisplay = true;
        this.ticketLabel = 'Raise Ticket';
        this.checkAllSelected = false;
        this.tableShipment = false;
        this.RaiseTicketDiv = true;

        window.scrollTo(0, document.body.scrollHeight);

        this.getSearchtags(this.ShipmentTransactionLogSummary.BusinessFlow);
        this.getTrackingSource();

        this.OtherShipmentShippingIDCheckedArr = [];

        if (this.AllShipmentLogArrData.length > 0) {
          let shipmentIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID == this.ShippingID);
       
          if (-1 !== shipmentIndex && -1 === this.ticketShipmentData.findIndex(o => o.ShippingID == this.ShippingID)) {
            this.ticketShipmentData.push({
              'index': shipmentIndex,
              'shippingData': {
                'ShippingID': this.AllShipmentLogArrData[shipmentIndex].ShippingID,
                'CurrentHubID': this.AllShipmentLogArrData[shipmentIndex].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[shipmentIndex].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[shipmentIndex].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[shipmentIndex].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[shipmentIndex].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[shipmentIndex].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[shipmentIndex].BusinessFlow,
                "Status": this.AllShipmentLogArrData[shipmentIndex].Status,
                "CurrentStatus": this.AllShipmentLogArrData[shipmentIndex].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[shipmentIndex].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[shipmentIndex].OrderType
              }
            });

            let eleRemoved = this.AllShipmentLogArrData.splice(shipmentIndex, 1);
            this.AllShipmentLogArrData.unshift(eleRemoved[0]);
            this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
            // this.getPaginationData()

            // Scroll Down everytime functionality
            setTimeout(function () {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1000);

          }
        }

      } catch (error) {
        this.RaiseTicketDiv = false;
        let msg = error + " - ShowRaiseTicketDiv";
        this.$alertify.error(msg);
      }

    },

    getDepartmentNameFromId() {
      //this.OrderDetails.srUserData.FirstName = '';
      let token = constantVariable.DEPARTMENT_ID_TOKEN;
      this.input = ({
        'DepartmentID': this.DepartmentID,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getDepartmentNameFromId',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.code === 200) {
          this.DepartmentName = result.data.data.data.data.DepartmentName;
        } else {
          let msg = result.data.data.data.error;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    fetchSrUserDetailsData(userid) {
      //this.OrderDetails.srUserData.FirstName = '';
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(userid, secretKey).toString();
      let ecuserid = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        'userid': ecuserid,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'fetchSrUserDetails',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {

        if (result.data.data.data.code === 200) {
          this.OrderDetails.srUserData = result.data.data.data.userdetails;
          this.displayCurrentLocation = this.OrderDetails.srUserData.FirstName;
        } else {
          let msg = result.data.data.data.error;
          this.$alertify.error(msg);
        }

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },
    fetchSrLocationDetailsData(srid) {
      this.OrderDetails.srLocationDetails = {};
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      this.input = ({
        'srid': srid,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'fetchSrLocationDetails',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.ResultCode === 100) {
          this.OrderDetails.srLocationDetails = result.data.data.data.data;
        } else {
          this.OrderDetails.srLocationDetails.srid = 0;
          let msg = result.data.data.data.ReturnMessage;
          //  this.$alertify.error(msg);  // Error message not required here
        }

      }, error => {
        this.OrderDetails.srLocationDetails.srid = 0;
        let msg = error;
        // this.$alertify.error(msg);  // Error message not required here
      })
    },
    openModal() {
      this.Testmodal = true;
    },
    retryCreateTicket() {
      // Set retry flag to true
      this.isRetry = true;
      // Call saveTicketData with same payload
      this.saveTicketData();
    },

    resetForm() {

      var self = this; //you need this because *this* will refer to Object.keys below`

      this.sourceId = '';
      this.selectedSourceObj = {
        value: '',
        text: ''
      };
      this.NDRCategory = '';
      this.LMAllowedCodes = [];
      this.ticketTypeId = '';
      this.selectedTicketObj = {
        value: '',
        text: ''
      };

      this.reasonId = '';
      this.selectedReasonObj = {
        value: '',
        text: ''
      };

      this.subReasonId = '';
      this.selectedSubReasonObj = {
        value: '',
        text: ''
      };

      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      this.ticketStatusId = '';
      this.selectedTicketStatusObj = {
        value: '',
        text: ''
      };

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };
      this.reAttemptDate = '';
      this.location = '';
      this.address = '';
      this.pincode = '';
      this.orderType = [{
        value: 'cod/prepaid',
        text: 'COD <> Prepaid'
      }];
      this.netPayment = '';
      this.orderTypeId = '';
      this.selectedOrderTypeObj = {
        value: '',
        text: ''
      };
      this.alternateContactNo = '';
      this.primaryContactNo = '';   //  #rto_dto_varification
      this.mobileNo = '';
      this.comments = '';
      this.ticketShipmentData = [];
      this.ticket = {};
      this.emailAddress = '';

      this.OtherShipmentShippingIDCheckedArr = [];

      for (let i = 0; i < this.AllShipmentLogArrData.length; i++) {

        if (document.getElementById(this.AllShipmentLogArrData[i].ShippingID) != null && document.getElementById(this.AllShipmentLogArrData[i].ShippingID).disabled == true) {
          document.getElementById(this.AllShipmentLogArrData[i].ShippingID).disabled = false;
        }
      }
      this.allSelected = false;
      this.disPayment = false;
      this.disPaymentMethod = false;
              // #alernateproof

      this.proofstatus='';
      this.IsWebLink=''
              // #alernateproof
      
      // SRID addition
      this.SRIDsId = '';
      this.SRIDs = [];
      this.SRNameId = '';
      this.SRNames = [];
      this.selectedSRIDnObj = {
        value : '',
        text : ''
      };
      this.selectedSRNamenObj = {
        value : '',
        text : ''
      }
      //#7419
      this.searchOptionsNDRList= [];
      // ==== NDR valiadtion === // --- reseting fields which are storing ndrs ub reason nad  flag for showing reattempt date 
      this.childSubReasonList=[], // to store child subreason list for dropdown
      this.ValidateEmailsubNdrId= ""     ,        
      this.selectedNDRSubReasonObj= {  
        value: '',        
        text: ''      
      },
      this.ndrReattemptDateflag =false,  
      this.subReasonNDRList= [];
      this.processCode='',
      // ==== NDR valiadtion === // //#7419
      this.selectedNDRReasonObj= {
        value: '',
        text: '',
        id: '',
        AssociatedNDR: '',  //#prexo_flow
        AssociatedNDRTitle: ''  //#prexo_flow
      };
         
    },

    closeBModalCommonFunction(string) {
      [this.filter, this.Ticketmodal, this.SendSMS.SendSMSModal, this.locationMapModal, this.BagNoObj.BagShipmentDetailsModal, this.BagNoObj.TransitStatusModal, this.ShipmentLogModal, this.Callpatching.CallPatchingModal, this.ticketResultModal, this.MultipleProductInfo.MultipleProductInfoModal, this.TicketLogModal, this.IVRCallRecording.IVRCallRecordingModal, string] = commonFunction.closeBModalCommonFunction(string);
    },

    editTicket(ticket) {
      try {
        // console.log('ticket : ' + JSON.stringify(ticket));
        this.resetForm();
        this.ticketLabel = "Edit Ticket";
        this.Ticketmodal = false;
        this.RaiseTicketDiv = true;
        this.ticketTaggingDisplay = false;

        this.tableShipment = true;

        this.source = [];
        this.selectedSourceObj.text = ticket.source;
        this.selectedSourceObj.value = this.sourceId = ticket.sourceid;

        this.ticketType = [];
        this.selectedTicketObj.text = ticket.maintype;
        this.selectedTicketObj.value = this.ticketTypeId = ticket.tickettypeid;
        this.reason = [];
        this.subReason = [];

        let enableSubReason = false;

        if (ticket.businessflow == 'Forward') {

          if (-1 !== this.arrDisplaySubTypes[0].subtypes.findIndex(o => o.id == ticket.subreasonid)) {

            this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
            enableSubReason = true;
          }

        } else {

          if (-1 !== this.arrDisplaySubTypes[1].subtypes.findIndex(o => o.id == ticket.subreasonid)) {
            this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
            enableSubReason = true;

          }
        }

        this.selectedReasonObj.text = ticket.subtype;
        this.selectedReasonObj.value = this.reasonId = ticket.reasonid;

        if (enableSubReason == true) {
          this.getTrackingType(this.reasonId, ticket.businessflow, 'Edit', ticket.subreasonid);
        }
        this.selectedSubReasonObj.text = ticket.typename;
        this.selectedSubReasonObj.value = this.subReasonId = ticket.subreasonid;


        this.reAttemptDate = ticket.reattemptdate;
        this.address = ticket.address;
        this.pincode = ticket.pincode;
        this.location = ticket.name;
        this.ticketId = ticket.ticketid;
        this.mobileNo = (ticket.mobilenumber != null && ticket.mobilenumber != '') ? ticket.mobilenumber : null;
        this.alternateContactNo = (ticket.alternatecontactnumber != null && ticket.alternatecontactnumber != '') ? ticket.alternatecontactnumber : null;
        this.emailAddress = (ticket.emailaddress != null && ticket.emailaddress != '') ? ticket.emailaddress : null;
        this.orderTypeId = ticket.ordertype;
        this.netPayment = ticket.netpayment;
        this.validated = false;
        this.ticket = ticket;
        // #alternaeproof
        this.IsWebLink=ticket.web_link;
                // #alternaeproof



        if (this.subReasonId == 44) {
          var method = {
            value: '',
            text: ''
          };
          if (ticket.ordertype == 'PrePaid') {
            method = {
              value: 2,
              text: 'Prepaid'
            };
            this.selectedMethod(method);
          } else {
            method = {
              value: 1,
              text: 'COD'
            };
            this.selectedMethod(method);
          }
        }
        this.disPayment = true;
        this.disPaymentMethod = true;


        // Scroll Down everytime functionality
        setTimeout(function () {
          window.scrollTo(0, document.body.scrollHeight);
        }, 1000);

        this.getTicketAction(ticket.subreasonid, 'Edit');

      } catch (error) {
        this.Ticketmodal = false;
        let msg = error + " - editTicket";
        this.$alertify.error(msg);
      }
    },

    openTicketModal() {

      this.Ticketmodal = true;
      this.getShipmentTickets(this.ShippingID);
    },

    async getPaginationData(pageNum) {
      try {
        this.pageno = pageNum - 1;     //#common_fixes pageno set for dynamic offset
        await this.getShipmentTickets(this.ShippingID);
      } catch (error) {
        let msg = error + " - getPaginationData";
        this.$alertify.error(msg);
      }
    },

    async OnFilterClick(event) {
      try {
        this.pageno = 0;
        await this.getShipmentTickets(this.ShippingID);
        if (this.pagecount > 1) {
          this.$refs.paginate.selected = 0;
        }
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - OnFilterClick";
        this.$alertify.error(msg);
      }
    },

    getShipmentTickets(shipmentId, TickID = 0) {
      try {
        this.isModelLoading = true;
        let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
        let accessToken;
        //#common_fixes dynamically handle offset and limit 
        let limit = 10;
        let offset = this.pageno * limit;
       
        let token = 'edw3r323432472748923';
        // shipmentId = '1231070';
        this.input = ({
          'shipmentid': shipmentId,
          'offset': offset,  //#common_fixes offset to get shipping data from index
          'limit': limit,   //#common_fixes limit to get shipping data to index
          'searchData': this.filter
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getShipmentTickets',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {

          if (true == result.data.data.status) {
            if (TickID > 0) {
              var shipTicketsData = result.data.data.data;
              let shipTicketsLength = shipTicketsData.length;
              for (let i = 0; i < shipTicketsLength; i++) {
                if (TickID == shipTicketsData[i].ticketid) {
                  this.shipmentTickets = [];
                  this.shipmentTickets[0] = shipTicketsData[i];
                }
              }
              this.counter++;
            } else {
              this.counter = 0;
              this.shipmentTickets = result.data.data.data;

              if (this.shipmentTickets.length > 0) {
                var totalRows = this.shipmentTickets[0].full_count;
                if (totalRows < 10) {
                  this.pagecount = 1;
                  this.pageno = 0;
                } else {
                  this.pagecount = Math.ceil(totalRows / 10)
                }
              } else {
                this.pagecount = 0;
              }
            }
          }
                  // #alternaeproof

          this.IsWebLink =(this.shipmentTickets && this.shipmentTickets[0].web_link)?this.IsWebLink:'';
        // #alternaeproof
          
          this.isModelLoading = false;

        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);

        })
      } catch (error) {
        this.isModelLoading = false;
        this.Ticketmodal = false;
        let msg = error + " - getShipmentTickets";
        this.$alertify.error(msg);
      }
    },

    getTrackingSource() {
      let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': '1',
        'usertype': 'Agent'
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSource',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.source = result.data.data.data;
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    selectedSource(sourceData) {
      this.selectedSourceObj = sourceData;
      this.sourceId = sourceData.value;
      this.getTrackingMainType();
    },

    selectedTicket(ticketData) {

      this.selectedTicketObj = ticketData;
      this.ticketTypeId = ticketData.value.toString();
      this.selectedReasonObj = {};
      this.selectedSubReasonObj = {};
      this.subReason = [];
      this.selectedActionObj = {};

      this.getTrackingSubType(this.ticketTypeId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add');
    },

    selectedMethod(method) {
      this.selectedMethodObj = method;
      this.methodId = method.value;
      if (this.subReasonId == 44) {
        if (this.methodId == 1) {
          this.orderTypeId = "CashOnDelivery";
        }
         else {
          this.orderTypeId = "PrePaid";
        }
      }
    },
    //#7419

// ==== NDR valiadtion === // --- function to handle ndr reason selection and fetch subreason list if available
  selectedNDRReasonValue(selectedndr) {
    this.ndrReattemptDateflag= false;
    this.selectedNDRReasonObj = selectedndr;
    this.selectedNDRReasonObj.AssociatedNDR = selectedndr.AssociatedNDR || '';
    this.selectedNDRReasonObj.AssociatedNDRTitle = selectedndr.AssociatedNDRTitle || '';
    this.ndrId = selectedndr.value;
    const parent = this.subReasonNDRList.find(item =>{
      if(item.uniquecode === this.ndrId)
        { 
          this.processCode = item.processcode;
          if(item.IsFutureDate == true || item.IsFutureDate == '1'){
            this.ndrReattemptDateflag = true;
          }
          return item;
        }
   } );
    this.childSubReasonList = [];

    if (parent && parent.hasSubStatus) {
      const key = parent.substatusKey;   
      const subList = parent[key] || [];
      this.childSubReasonList = subList.map(sub => ({
        text: sub.title,
        value: sub.uniquecode
      }));
      this.selectedNDRSubReasonValue(this.childSubReasonList[0])
    }
  }
,
  selectedNDRSubReasonValue(selectedsubreasonndr) {
    this.selectedNDRSubReasonObj = selectedsubreasonndr;
    this.subNdrId = selectedsubreasonndr.value;
  },
// ==== NDR valiadtion === //
    selectedReason(reasonData) {
      let ShippingIDEle;

      if ('Raise Ticket' == this.ticketLabel) {
        if (reasonData.text == "Address change") {

          if (this.ticketShipmentData.length === 0) {
            this.$alertify.error('Please select shipment.');
            return false;
          }
          if (this.ticketShipmentData.length > 1) {
            this.$alertify.error('Please select only one shipment to modify address.');
            return false;
          }

          if (this.ShippingID != this.ticketShipmentData[0].shippingData.ShippingID) {
            this.$alertify.error('Please select searched shipping ID to Change Address.');
            return false;
          }
          let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ShippingID);

          if (-1 !== shippingDataIndex) {
            this.OtherShipmentShippingIDCheckedArr = [];
            this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
            // this.allSelected = false;

            this.ticketShipmentData = [];
            this.ticketShipmentData.push({
              'index': shippingDataIndex,
              'shippingData': {
                "ShippingID": this.AllShipmentLogArrData[shippingDataIndex].ShippingID,
                'CurrentHubID': this.AllShipmentLogArrData[shippingDataIndex].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[shippingDataIndex].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[shippingDataIndex].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[shippingDataIndex].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[shippingDataIndex].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[shippingDataIndex].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[shippingDataIndex].BusinessFlow,
                "Status": this.AllShipmentLogArrData[shippingDataIndex].Status,
                "CurrentStatus": this.AllShipmentLogArrData[shippingDataIndex].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[shippingDataIndex].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[shippingDataIndex].OrderType
              }
            });
          }
          for (ShippingIDEle in this.AllShipmentLogArrData) {

            if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
              document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
            }
          }
          this.checkAllSelected = true;
          if (this.allSelected) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }

        } else {

          for (ShippingIDEle in this.AllShipmentLogArrData) {

            if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
              document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;

            }
          }
          this.checkAllSelected = false;
          if (this.allSelected) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }
        }
      }
      this.selectedReasonObj = reasonData;
      this.reasonId = reasonData.value.toString();
      this.selectedSubReasonObj = {};
      this.selectedActionObj = {};
      this.selectedTicketStatusObj = {};
      this.ticketStatusId = '';

      if ('Raise Ticket' == this.ticketLabel) {
        this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add', null);
      } else {
        if (this.ShipmentTransactionLogSummary.BusinessFlows == 'Forward' && this.ticket.subreasonid === constantVariable.URGENT_DELIVERY) {
          this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Edit', this.ticket.subreasonid);
        } else {
          // this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add', null );
          this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Edit', this.ticket.subreasonid);
        }

      }
    },

    selectedSubReason(subReasonData) {

      try {

        let ShippingIDEle;
        this.reAttemptDate = '';

        if ('Raise Ticket' == this.ticketLabel) {

          if (subReasonData.text == "Change payment mode / amount" ||
            subReasonData.text == "" || subReasonData.text == "Update Alternate Contact No" || subReasonData.text == "Update Email Address") {

            if (this.ticketShipmentData.length === 0) {
              this.$alertify.error('Please select shipment.');
              return false;
            }
            // if (this.ticketShipmentData.length > 1) {
            //   this.$alertify.error('Please select only one shipment to ' + subReasonData.text);
            //   return false;
            // }

            let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ticketShipmentData[0].shippingData.ShippingID);

            for (ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ticketShipmentData[0].shippingData.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
              }
            }

            this.checkAllSelected = true;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }

          } else {

            if (this.selectedReasonObj.text != "Address change") {

              for (ShippingIDEle in this.AllShipmentLogArrData) {

                if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                  document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;
                }
              }
              this.checkAllSelected = false;
              if (this.allSelected) {
                this.allSelected = true;
              } else {
                this.allSelected = false;
              }
            }
          }
        }

        this.selectedSubReasonObj = subReasonData;

        this.subReasonId = subReasonData.value.toString();
        this.selectedActionObj = {};
        this.selectedTicketStatusObj = {};
        this.ticketStatusId = '';
        this.escalation = subReasonData.isescalation;

        if ('Raise Ticket' == this.ticketLabel) {
          this.getTicketAction(this.subReasonId, 'Add');
        } else {
          this.getTicketAction(this.subReasonId, 'Edit');
        }
        //#7419
        if(this.subReasonId == constantVariable.verified_ndr || this.subReasonId == constantVariable.Verified_NPR || this.subReasonId == constantVariable.Verified_RTO_DTO_Reason)
        {
          this.loadNDRReasonLists();
        }
        if (this.subReasonId == 44) {
          var method = {
            value: '',
            text: ''
          };
          if (this.OrderDetails.OrderType == 'Prepaid') {
            method = {
              value: 2,
              text: 'Prepaid'
            };
            this.selectedMethod(method);
          } else {
            method = {
              value: 1,
              text: 'COD'
            };
            this.selectedMethod(method);
          }
        }

      } catch (error) {
        let msg = error + " - selectedSubReason";
        this.$alertify.error(msg);
      }
    },

  getIsCallFromIVR() {
  const payload = { shippingid: this.SalesDemo.ShippingID };

  this.isLoading = true;

  axios({
    method: "POST",
    url: apiUrl.api_url + "getIsCallFromIVR",
    data: payload,
    headers: commonFunction.getusertoken(),
  })
    .then(result => {
      this.isLoading = false;

      const dataLayer = result && result.data && result.data.data;
      const responseData = dataLayer && dataLayer.data ? dataLayer.data : null;

      // Default
      this.isCallFromIVR = null;
      this.isCallFromIVRMsg = "";

      if (!responseData) {
        this.isCallFromIVRMsg = "No rider helpline record found";
        return;
      }

      if (!responseData.IsCallFrom) {
        this.isCallFromIVRMsg = "IsCallFrom is not present for this shipment";
        return;
      }

      // Success case
      this.isCallFromIVR = responseData.IsCallFrom;
      //#gated_pickup_enforce_7881
      if ( responseData.SrProgressionBlock === 1){
        this.SrProgressionBlock = true;
      }else if(responseData.SrProgressionBlock === 0){
        this.SrProgressionBlock = false;
      }

      this.isCallFromIVRMsg = "Success";
    })
    .catch(error => {
      this.isLoading = false;
      this.isCallFromIVR = null;
      this.isCallFromIVRMsg = "";
      console.error("Error in getIsCallFromIVR:", error);
      this.$alertify.error(
        "Something went wrong while fetching IVR call details."
      );
    });
},
    getNDRReasonListLM() {
      const input = {
        ShippingID: this.ShippingID,
      };
  
      axios.post(apiUrl.api_url + "getNDRReasonListLM", input, {
        headers: commonFunction.getusertoken()
      })
      .then(result => {
         console.log(result,"result");
         const ndrData = result.data.data.data; 
         
         if (!ndrData || ndrData.code === 204 || !ndrData.allowedNDRReasonsCodes) {
          // const msg = ndrData.message || "No valid allowed NDR reasons available.";
          // this.$alertify.error(msg);
          // this.ndrReasonListLM = [];
          // return;
          // ==== Commneted above lines to fetch NDR from UA directly if no allowed codes from LM === //
          return  this.getNDRReasonOfUA();
        }
        const allowedCodes =
             ndrData.allowedNDRReasonsCodes
            .split(",")
            .map(c => c.trim()) || [];
  
        this.LMAllowedCodes = allowedCodes;
        // console.log("Allowed Codes from LM:", allowedCodes);
        // Call Masters API with allowed codes
        return this.getNDRReasonOfUA();
      })
      .catch(error => {
        console.error(" Error in getNDRReasonListLM:", error);
        this.$alertify.error("Failed to fetch NDRReasonListLM");
      });
    },
  
    // Use allowed codes in Masters API request
    getNDRReasonListMasters(allowedCodes) {
      const input = {
        UniqueCodes: allowedCodes, //  send codes to backend
      };
  
      axios.post(apiUrl.api_url + "getNDRReasonListMasters", input, {
        headers: commonFunction.getusertoken()
      })
      .then(result => {
        this.subReasonNDRList = [];
        console.log(result,"result==");
        
        // API response format you mentioned
        const reasonStatuses = result.data.data.data.ReasonStatuses || [];
        console.log("ReasonStatuses from Masters:", reasonStatuses);
        this.subReasonNDRList = reasonStatuses;
        //  Combine into searchOptionsNDRList
        this.searchOptionsNDRList = [
          {
            text: "CC not able to decide NDR reason",
            value: "0"
          },
          //#7419
          ...reasonStatuses.map(item => ({
            text: `${item.userprocess}`,
            value: item.uniquecode,
            id: item.userprocessmappingid 
          }))
        ];
    

        console.log("Final searchOptionsNDRList:", this.searchOptionsNDRList);
      })
      .catch(error => {
        console.error("Error in getNDRReasonListMasters:", error);
        this.$alertify.error("Failed to fetch NDRReasonListMasters");
      });
    },
getNDRCategory() {
  // #prexo_flow - Check if shipment is Prexo type (PrexoType must be 'PFEX' or 'PREP')
  const isPrexo = (this.PrexoType === 'PFEX' || this.PrexoType === 'PREP') && this.PrexoShipment;

  if(this.SalesDemo.BusinessFlow === 'Reverse'){
     this.NDRCategory = isPrexo 
      ? (this.isCallFromIVR === 1 ? constantVariable.PREXO_RVP_NDR : constantVariable.PREXO_RP_NDR_STATUS_CODE)
      : (this.isCallFromIVR === 1 ? constantVariable.RVP_NDR : constantVariable.RVP_NDR_STATUS_CODE);
  }else{
  if (
    this.SalesDemo.BusinessType &&
    this.SalesDemo.BusinessType.toLowerCase() === 'bfsi'
  ) {
    // BFSI shipment
    if (
      this.SalesDemo.deliveryType === this.TYPE_ADDRESS_SPECIFIC ||
      this.SalesDemo.deliveryType === this.TYPE_PERSON_SPECIFIC
    ) {
      this.NDRCategory = isPrexo ? constantVariable.PREXO_BFSI_NDR : 'bfsi_NDR';
    }
  } else {
    // E-Comm shipment
    if (this.SalesDemo.deliveryType === this.TYPE_ADDRESS_SPECIFIC) {
      if (this.OrderDetails && this.OrderDetails.OrderType && this.OrderDetails.OrderType.toLowerCase() === 'cod') {
        this.NDRCategory = isPrexo ? constantVariable.PREXO_ECOMM_NDR_COD : 'eComm_NDR_COD';
      } else {
        this.NDRCategory = isPrexo ? constantVariable.PREXO_ECOMM_NDR_PREPAID : 'eCmm_NDR_PrePaid';
      }
    } else if (this.SalesDemo.deliveryType === this.TYPE_PERSON_SPECIFIC) {
      this.NDRCategory = isPrexo ? constantVariable.PREXO_BFSI_NDR : 'bfsi_NDR';
    }
  }
}
},
    getNDRReasonOfUA(){
      this.getNDRCategory();
      let baseOption = null;
      const input = {
        NDRCategoryInput : this.NDRCategory,
        allowedCodes: this.LMAllowedCodes // send allowed codes from LM if any
      };
  
      axios.post(apiUrl.api_url + "getNDRReasonListUA", input, {
        headers: commonFunction.getusertoken()
      })
      .then(result => {

        if (result.data && result.data.status === false && result.data.message) {
          this.$alertify.error(result.data.message);
          this.searchOptionsNDRList = []; 
          this.subReasonNDRList = []; // === NDR valiadtion === // --- NDR subreason list reset
          return;
        }
        let ndrList = result.data.data.data;
         //#gated_pickup_enforce_7881
        let ndrReasons = [];
       
        if (
          this.SrProgressionBlock === true &&
          this.SalesDemo &&
          this.SalesDemo.BusinessFlow === 'Reverse' &&
          (
            this.NDRCategory === constantVariable.RVP_NDR ||
            this.NDRCategory === constantVariable.RVP_NDR_STATUS_CODE
          )
        ) {
        
          ndrReasons = ndrList.reduce((arr, item) => {
        
            if (
              item[1] &&
              item[1].ConfigSetting &&
              item[1].ConfigSetting.isOtpInitiationEnableForReasonCRM === true
            ) {
              arr.push(item[0]);
            }
        
            return arr;
          }, []);
        
        } else {
          ndrReasons = ndrList.map(item => item[0]);
        }
        
        // const ndrReasons = ndrList.map(item => item[0]);  // === NDR valiadtion === // --- mapping ndr reasons for dropdown
        this.subReasonNDRList = ndrList.map(item => item[1]);  // === NDR valiadtion === // --- mapping ndr subreasons for dropdown
        // === changes to add default option at top === //
         // === NDR valiadtion === // --- Combine into searchOptionsNDRList

// const baseOption =
//   this.SalesDemo.TotalAttemptCount === 0
//     ? {
//         text: 'Deliver the shipment',
//         value: '0'
//       }
//     : {
//         text: 'Pickup the shipment',
//         value: '0'
//       };
          //#rvp_verification_7541
          if( this.SalesDemo.BusinessFlow === 'Forward'){
            baseOption = {
              text: 'Deliver the shipment',
              value: '0'
            }
          }else if (this.SalesDemo.BusinessFlow === 'Reverse'){
            baseOption = {
              text: 'Pickup the shipment',
              value: '0'
            };
          }

    this.searchOptionsNDRList = baseOption
  ? [baseOption, ...ndrReasons]   // add only if exists
  : [...ndrReasons];              // otherwise don't add


      })
      .catch(error => {
        console.error("Error in getNDRReasonListMasters:", error);
        this.$alertify.error("Failed to fetch NDRReasonListMasters");
      });
         
    },
   getNDRReasonoDTORTOfUA(){
      let baseOption = null;
      const input = {
        NDRCategoryInput : this.NDRCategory,
        allowedCodes: this.LMAllowedCodes // send allowed codes from LM if any
      };
  
      axios.post(apiUrl.api_url + "getNDRReasonListUA", input, {
        headers: commonFunction.getusertoken()
      })
      .then(result => {

        if (result.data && result.data.status === false && result.data.message) {
          this.$alertify.error(result.data.message);
          this.searchOptionsNDRList = []; 
          this.subReasonNDRList = []; // === NDR valiadtion === // --- NDR subreason list reset
          return;
        }
        let ndrList = result.data.data.data;
        const ndrReasons = ndrList.map(item => item[0]);  // === NDR valiadtion === // --- mapping ndr reasons for dropdown
        this.subReasonNDRList = ndrList.map(item => item[1]);  // === NDR valiadtion === // --- mapping ndr subreasons for dropdown

          // if( this.SalesDemo.TotalAttemptCount === 0 && this.SalesDemo.BusinessFlow === 'Forward'){
          //   baseOption = {
          //     text: 'Deliver the shipment',
          //     value: '0'
          //   }
          // }else if ( this.SalesDemo.TotalAttemptCount === 0 && this.SalesDemo.BusinessFlow === 'Reverse'){
          //   baseOption = {
          //     text: 'Pickup the shipment',
          //     value: '0'
          //   };
          // }

    this.searchOptionsNDRList = baseOption
  ? [baseOption, ...ndrReasons]   // add only if exists
  : [...ndrReasons];              // otherwise don't add

      })
      .catch(error => {
        console.error("Error in getNDRReasonoDTORTOfUA:", error);
        this.$alertify.error("Failed to fetch getNDRReasonoDTORTOfUA");
      });
         
    },
  //#7419
    // Initialize flow
    loadNDRReasonLists() {
      this.LMAllowedCodes = [];
      this.NDRCategory = '';
      this.searchOptionsNDRList = [];
      if(this.UAPayload.shipmentType === 'DTO' || this.UAPayload.shipmentType === 'RTO'){
        if (this.UAPayload.shipmentType === 'DTO') {
           this.NDRCategory = 'dto_ndr_status_code';
        } else if (this.UAPayload.shipmentType === 'RTO') {
           this.NDRCategory = 'RTO_NDR';
        }
        if(this.UAPayload.eventType === 'partialNdr'){
        //   if(this.UAPayload.shipmentType === 'DTO'){
        //     this.NDRCategory = 'DTO_Partial_NDR'; 
        // }else if (this.UAPayload.shipmentType === 'RTO'){
        //     this.NDRCategory = 'RTO_Partial_NDR';
        // }
        this.$alertify.error('Partial NDR is not allowed for RTO or DTO shipments.');
        return false;
      }
         this.getNDRReasonoDTORTOfUA();
      }
     else{
      if(this.SalesDemo.BusinessFlow === 'Reverse'){
        this.getIsCallFromIVR();
      }

      if (this.SalesDemo.TotalAttemptCount === 0) {
        this.getNDRReasonOfUA();
      } else {
        this.getNDRReasonListLM();
      }
    }
    },

    //#7419 end======
    selectedAction(actionData) {

      try {

        if ('Raise Ticket' == this.ticketLabel) {
          if (this.selectedReasonObj.text == "Address change" || this.selectedSubReasonObj.text == "Change payment mode / amount" ||
            this.selectedSubReasonObj.text == "" || this.selectedSubReasonObj.text == "Update Alternate Contact No" || this.selectedSubReasonObj.text == "Update Email Address") {

            if (this.ticketShipmentData.length === 0) {
              this.$alertify.error('Please select shipment.');
              return false;
            }

            // if (this.ticketShipmentData.length > 10) {
            //   this.$alertify.error('Please select only one shipment to ' + this.selectedSubReasonObj.text);
            //   return false;
            // }

            if (this.ShippingID != this.ticketShipmentData[0].shippingData.ShippingID) {
              this.$alertify.error('Please select searched shipping ID to ' + this.selectedSubReasonObj.text);
              return false;
            }
            let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ShippingID);

            if (-1 !== shippingDataIndex) {
              this.OtherShipmentShippingIDCheckedArr = [];
              this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
              // this.allSelected = false;
              this.ticketShipmentData = [];
              this.ticketShipmentData.push({
                'index': shippingDataIndex,
                'shippingData': {
                  'ShippingID': this.AllShipmentLogArrData[shippingDataIndex].ShippingID,
                  'CurrentHubID': this.AllShipmentLogArrData[shippingDataIndex].CurrentHubID,
                  "TotalAttemptCount": this.AllShipmentLogArrData[shippingDataIndex].TotalAttemptCount,
                  "UserProcess": this.AllShipmentLogArrData[shippingDataIndex].UserProcess,
                  "NotificationType": this.AllShipmentLogArrData[shippingDataIndex].NotificationType,
                  "NotificationStatus": this.AllShipmentLogArrData[shippingDataIndex].NotificationStatus,
                  "ClientName": this.AllShipmentLogArrData[shippingDataIndex].ClientName,
                  'BusinessFlow': this.AllShipmentLogArrData[shippingDataIndex].BusinessFlow,
                  "Status": this.AllShipmentLogArrData[shippingDataIndex].Status,
                  "CurrentStatus": this.AllShipmentLogArrData[shippingDataIndex].CurrentStatus,
                  "CreatedDate": this.AllShipmentLogArrData[shippingDataIndex].CreatedDate,
                  "OrderType": this.AllShipmentLogArrData[shippingDataIndex].OrderType
                }
              });
            }

            for (let ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
              }
            }
            // this.allSelected = false;
            this.checkAllSelected = true;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }

          } else {

            for (let ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;

              }
            }
            // this.allSelected = false;
            this.checkAllSelected = false;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }
          }
        }
        if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' &&
          this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
          this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service' && this.selectedSubReasonObj.text !== 'Delay in connection') {
           //#bulk_enhancement old reattempt date add
            // === NDR valiadtion === // --- added condition for ndr reattempt
          if (this.selectedSubReasonObj.text == 'Change Reattempt Date'|| this.selectedSubReasonObj.text == "Change Pickup Date" ||  this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Change DTO address' ||   (this.selectedReasonObj.value === constantVariable.ndr_validation &&
               this.selectedSubReasonObj.value === constantVariable.verified_ndr) || (this.selectedReasonObj.value === constantVariable.NPR_Validation &&
               this.selectedSubReasonObj.value === constantVariable.Verified_NPR)
              || (this.selectedReasonObj.value === constantVariable.RTO_DTO_Validation &&
               this.selectedSubReasonObj.value === constantVariable.Verified_RTO_DTO_Reason)) {
            if (this.SalesDemo.ReattemptDate != null) {
              this.oldReAttemptDate = commonFunction.changeDateFormat(this.SalesDemo.ReattemptDate);
            }
            if (this.SalesDemo.ReattemptDate != null) {
              this.reAttemptDate = commonFunction.formatDateString(this.SalesDemo.ReattemptDate);
            }
            this.startDate = new Date();
            let dateDisabled3 = new Date();
            dateDisabled3.setDate(dateDisabled3.getDate() + 6);
            this.endDate = dateDisabled3;
          } else if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.emailAddress = (this.CustomerDetails.EmailID != null && this.CustomerDetails.EmailID != '' && this.CustomerDetails.EmailID != 'undefined') ? this.CustomerDetails.EmailID : '';

          } else {
            this.endDate = null;
            if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed') {
              let tomorrow = new Date();
              if (this.startDate.getHours() < 20) {
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.startDate = tomorrow;
              } else {
                tomorrow.setDate(tomorrow.getDate() + 2);
                this.startDate = tomorrow;
              }
              let dateDisabled = new Date();
              dateDisabled.setDate(dateDisabled.getDate() + 7);
              this.endDate = dateDisabled;
            }
          }
        } else {
          this.startDate = new Date();
          let dateDisabled2 = new Date();
          dateDisabled2.setDate(dateDisabled2.getDate() + 6);
          this.endDate = dateDisabled2;
        }//selectedMethod

        if (this.selectedSubReasonObj.text == 'ReAttempt') {
          this.startDate = new Date();
          let dateDisabled3 = new Date();
          dateDisabled3.setDate(dateDisabled3.getDate() + 6);
          this.endDate = dateDisabled3;
          console.log("ReAttempt========");
        }

        if ('Raise Ticket' == this.ticketLabel) {
          if (this.ticketShipmentData.length > 0 && this.ticketShipmentData[0].shippingData.OrderType !== null) {
            var method = {
              value: '',
              text: ''
            };
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'cod') {
              // this.orderTypeId = "PrePaid";
              this.orderTypeId = "CashOnDelivery";
              method = {
                value: 1,
                text: 'COD'
              };
              this.selectedMethod(method);
            }
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'prepaid') {
              // this.orderTypeId = "CashOnDelivery";
              this.orderTypeId = "PrePaid";
              method = {
                value: 2,
                text: 'Prepaid'
              };
              this.selectedMethod(method);
            }
          }
        }

        //  console.log("this.orderTypeId "+this.orderTypeId);
        // this.ticketLabel = "Edit Ticket"
        if (this.ticketLabel == 'Edit Ticket') {
          this.disPayment = true;
        }


        this.selectedActionObj = actionData;
        this.actionId = actionData.value.toString();
        this.alternateContactNo = ''; // Clear alternate contact number on action change
        this.primaryContactNo = '';   //  #rto_dto_varification
        this.getTicketActionStatus(actionData.value);
      } catch (error) {
        let msg = error + " - selectedAction";
        this.$alertify.error(msg);
      }
    },

    updateSelectedAction(actionData) {

      try {

        if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
          this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
          this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service' && this.selectedSubReasonObj.text !== 'Delay in connection') {

          this.endDate = null;
          if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed' ||
            this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR || this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

            let tomorrow = new Date();
            if (this.startDate.getHours() < 20) {
              tomorrow.setDate(tomorrow.getDate() + 1);
              this.startDate = tomorrow;
            } else {
              tomorrow.setDate(tomorrow.getDate() + 2);
              this.startDate = tomorrow;
            }
            let dateDisabled = new Date();
            dateDisabled.setDate(dateDisabled.getDate() + 7);
            this.endDate = dateDisabled;
          }

        } else {
          this.startDate = new Date();
          let dateDisabled2 = new Date();
          dateDisabled2.setDate(dateDisabled2.getDate() + 6);
          this.endDate = dateDisabled2;
        }


        this.selectedActionObj = actionData;
        this.actionId = actionData.value.toString();
        this.alternateContactNo = ''; // Clear alternate contact number on action change
        this.primaryContactNo = '';   //  #rto_dto_varification
        this.tableShipment = true;
        this.getTicketActionStatus(actionData.value);

        this.disPayment = true;

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedAction";
        this.$alertify.error(msg);
      }
    },

    selectedTicketStatus(ticketStatusData) {

      this.selectedTicketStatusObj = ticketStatusData;
      this.ticketStatusId = ticketStatusData.value;
    },

    selectedSearchTag(SelectedTagData) {

      this.selectedSearchObj = SelectedTagData;
      this.searchId = SelectedTagData.value;
          //#7419
  if (
  (SelectedTagData.value === constantVariable.ndr_validation ||
    SelectedTagData.value === constantVariable.verified_ndr ||
    SelectedTagData.value === constantVariable.NPR_Validation ||
    SelectedTagData.value === constantVariable.Verified_NPR)
) {
  // FORWARD flow
  if (
    this.SalesDemo && this.SalesDemo.BusinessFlow && this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.BusinessFlow !== 'Reverse' &&
    this.SalesDemo && this.SalesDemo.UserProcess && this.SalesDemo.UserProcess.toLowerCase() !== 'out for delivery' &&  this.SalesDemo.UserProcess.toLowerCase() !== "(hd)out for delivery"
  ) {
    this.$alertify.error('Shipment should be Out for Delivery');
    return false;
  }

  // REVERSE flow
  if (
    this.SalesDemo && this.SalesDemo.BusinessFlow && this.SalesDemo.BusinessFlow === 'Reverse'  && this.SalesDemo.BusinessFlow !== 'Forward' &&
     this.SalesDemo.ShipmentStatus && this.SalesDemo.ShipmentStatus.toLowerCase() !== 'outforpickup'
  ) {
    this.$alertify.error('Shipment should be Out for Pickup');
    return false;
  }
}
  if (
  SelectedTagData.value === constantVariable.RTO_DTO_Validation||
    SelectedTagData.value === constantVariable.Verified_RTO_DTO_Reason 
) { 
          if(!this.UAPayload.shipmentType) {
          this.$alertify.error('No rider helper record found');
          return;
        }

   if (
    this.SalesDemo && this.SalesDemo.UserProcess && this.SalesDemo.UserProcess.toLowerCase() !== 'out for delivery' &&  this.SalesDemo.UserProcess.toLowerCase() !== "(hd)out for delivery"
   && this.UAPayload.shipmentType !== 'RTO' && this.UAPayload.shipmentType !== 'DTO'

  ) {
    this.$alertify.error('Shipment should be Out for Delivery');
    return false;
  }
}
      this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.ShipmentTransactionLogSummary.BusinessFlow);
    },

    getTrackingMainType() {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      if (this.categoryOptionObj.text == 'QC fail - Terminal' && this.DepartmentID != 1 && this.DepartmentID != 2 && this.DepartmentID != 3) {
        this.isLoading = false;
        let msg = constantVariable.UNAUTORISED_USER_MSG;
        this.$alertify.error(msg);
        return false;
      }
      this.input = ({
        'departmentid': '1',
        'page': this.page
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingMainType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.ticketType = result.data.data.data;

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingSubType(mainTypeId, businessFlow, type, subReasonId) {

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      let category = this.categoryOptionObj.text;
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        'departmentid': ecDepartmentID,
        'maintypeid': mainTypeId,
        'businessFlow': businessFlow,
        'page': this.page,
        'category': (type == 'Add') ? category : '',
        'type': type,
        'subReasonId': subReasonId,
        "isLatestOfd": this.SalesDemo.IsLatestOFD,
        "notificationType": this.SalesDemo.NotificationType,
        'notificationStatus': this.SalesDemo.NotificationStatus
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSubType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.reason = result.data.data.data;
        if (this.reason) {

        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingType(subTypeId, businessFlow, type, subReasonId) {
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      let category = this.categoryOptionObj.text;

      this.input = ({
        'departmentid': this.DepartmentID,
        'subtypeid': subTypeId,
        'businessFlow': businessFlow,
        'page': this.page,
        'category': (type == 'Add') ? category : '',
        'type': type,
        'subReasonId': subReasonId,
        "notificationType": this.SalesDemo.NotificationType,
        'notificationStatus': this.SalesDemo.NotificationStatus,
        'status': this.SalesDemo.Status
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.subReason = result.data.data.data;

        if (this.subReason) {
          if (this.selectedTicketObj.text == 'Request' && this.selectedReasonObj.text == 'Address change') {

            if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) || this.SalesDemo.BusinessType.toLowerCase() == 'ecom') {

              var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexRedirectBank, 1);
              }
              var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexSecondaryBank, 1);
              }

              var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexPrimaryBank, 1);
              }

            } else {
              // console.log('else subReason : ' + JSON.stringify(this.subReason));
              var indexDeliveryAddress = this.subReason.findIndex(o => o.text == 'Change delivery address');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexDeliveryAddress, 1);
              }
            }

          } else {

            if ((this.SalesDemo.NotificationStatus === null) || (this.SalesDemo.NotificationStatus != 'Reattempt' &&
                this.SalesDemo.NotificationStatus != 'Escalation' && this.SalesDemo.NotificationStatus != 'SuperEscalation')) {
              var indexReattemptDate = this.subReason.findIndex(o => o.text == 'Change Reattempt Date');
              if (-1 !== indexReattemptDate) {
                this.subReason.splice(indexReattemptDate, 1);
              }
            }
          }
        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTicketAction(subReasonId, status) {
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';


      // getallemailcasebyshippingid
      if (status && status === "Edit") {
        this.getEmailCasesForUpdate(this.ShippingID);
      }

      this.input = ({
        subReasonId: subReasonId,
        status: status,
        'page': this.page,
        departmentId: this.DepartmentID,
        role: this.Role.rolename
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketAction',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {

        this.isLoading = false;
        this.action = result.data.data.data;
        if(constantVariable.SrSubReasonIdArr.includes(Number(subReasonId))){
          this.getSRID();
        } else {
          this.shouldShowLabel = false;
        }
        if (this.action) {

          let flag = false;
          let rvpflag = false;

          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

          if (-1 !== indexCsTeam) {
            if (this.SalesDemo.BusinessFlow == 'Forward') {
              this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
            } else {
              this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
            }
          }

          if (this.subDepartmentList) {
            for (var i = 0; i < this.subDepartmentList.length; i++) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Edit') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
            }
            for (var i = 0; i < this.subDepartmentList.length; i++) {

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                  rvpflag = true;
                  break;
                }
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Edit') {
                if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                  rvpflag = true;
                  break;
                }
              }
            }
          }

          if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
            if (flag == false) {
              let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
              if (-1 !== indexOpsTeam) {
                //this.action.splice(indexOpsTeam, 1);
              } else {

                // MSD Reattempt Handling
                if ('Reattempt Executive' !== this.userRole) {
                  this.action.push('Assigned to Fwd Client Support Team');
                }

              }
            } else {
              let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
              if (-1 !== indexFwdCsTeam) {
                this.action.splice(indexFwdCsTeam, 1);
              }
            }
          }
          if ('Admin' !== this.userRole && flag == false) {
            //  console.log("flag : " +flag);
            var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
            if (-1 !== indexRTONotify) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                this.action.splice(indexRTONotify, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexRTONotify, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse') {
                this.action.splice(indexRTONotify, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexStatusChanged = this.action.findIndex(o => o.text == 'Status Changed');

            if (-1 !== indexStatusChanged) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexStatusChanged, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexStatusChanged, 1);
              }
            }
          }
          if ('Admin' !== this.userRole) {

            //Remove Address updated tagging for non admin user.
            var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');
            if (-1 !== indexAddressUpdated) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexAddressUpdated, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexAddressUpdated, 1);
              }
            }
          }
          if ('Admin' !== this.userRole) {
            var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
            if (-1 !== indexContactUpdated) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexContactUpdated, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexContactUpdated, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

            if (-1 !== indexPickupCancelled) {

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexPickupCancelled, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && -1 !== indexCsTeam && rvpflag == false && status == 'Edit') {
                this.action.splice(indexPickupCancelled, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward') {
                this.action.splice(indexPickupCancelled, 1);
              }

            }
          }

          if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.location = this.RTODetails.CustomerName;
            if ('edit' == status) {
              this.address = this.RTODetails.Address;
              this.pincode = this.RTODetails.PinCode;
            }
          }

          if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {

            this.location = this.CustomerDetails.CustomerName;

            if ('edit' == status) {
              this.address = this.CustomerDetails.Address;
              this.pincode = this.CustomerDetails.Pincode;
            }
          }
          //restriction - Information given for manager only case delivered to inscan
          // Delivered to InScan = 72
          if (this.selectedSubReasonObj.text == 'Delivered to InScan') {
            var indexInformationgiven = this.action.findIndex(o => o.text == 'Information given');

            if (-1 !== indexInformationgiven) {
              if (this.userRole == 'Forward CST Agent' || this.userRole == 'Team Leader') {
                this.action.splice(indexInformationgiven, 1);
              }
            }
          }

          /*  //Special code : restriction - Assign to SLPV
           var indexAssigntoSLPV = this.action.findIndex(o => o.text == 'Assign to SLPV');
 
           if(-1 !== indexAssigntoSLPV){
             if(this.SalesDemo.BusinessFlow == 'Forward' && this.DepartmentID !== 6 && this.DepartmentID == 7){
               this.action.splice(indexAssigntoSLPV, 1);
               }
               if(this.SalesDemo.BusinessFlow == 'Reverse' && this.DepartmentID !== 7 && this.DepartmentID == 6){
                 this.action.splice(indexAssigntoSLPV, 1);
               }
               if(this.DepartmentID == 12){
                 this.action.splice(indexAssigntoSLPV, 1);
               }
             } */

        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTicketActionStatus(actionId) {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      status = (true == this.tableShipment) ? 'Edit' : 'Add';

      this.reAttemptDate = (status == 'Edit' && this.ticket.reattemptdate != null) ? this.ticket.reattemptdate : '';
      this.input = ({
        actionId: actionId,
        status: status
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketActionStatus',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        if (result.data.data.status == true) {
          let arrStatus = [];
          this.ticketStatus = [];
          arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

          for (let i = 0; i < arrStatus.length; i++) {
            this.ticketStatus.push({
              'value': arrStatus[i],
              'text': arrStatus[i]
            });
          }

          if (this.ticket.clientid !== null && this.ticket.ticketstatus == 'Closed') {
            this.selectedTicketStatusObj = this.ticketStatus[1];
            this.ticketStatusId = this.selectedTicketStatusObj.value;

          } else {
            this.selectedTicketStatusObj = this.ticketStatus[0];
            this.ticketStatusId = this.selectedTicketStatusObj.value;
          }
          // Alternate contact number is sourced from ticket as this API does not return it.   ------------ #master_live_ivr_alt_num  start -------
          this.alternateContactNo =
          (this.ticket &&
          this.ticket.alternatecontactnumber != null &&
          this.ticket.alternatecontactnumber !== '')
            ? this.ticket.alternatecontactnumber
            : this.alternateContactNo;   
          // ------------ #master_live_ivr_alt_num   end  -------
        }

      }, error => {

        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getSearchtags(businessFlow) {
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        "departmentid": ecDepartmentID,
        'businessFlow': businessFlow,
        "page": this.page,
        "category": this.categoryOptionObj.text,
        "isLatestOfd": this.SalesDemo.IsLatestOFD
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchOption',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.shouldShowLabel = false;
        if ( this.categoryOptionObj.text == 'QC fail - Terminal' && this.DepartmentID != 1 && this.DepartmentID != 2 && this.DepartmentID != 3) {
          this.isLoading = false;
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          //this.$alertify.error(msg);
          return false;
        }
        this.searchOptions = result.data.data.data;


        Object.entries(this.searchOptions).forEach(entry => {

          entry[1].value = entry[1].id;
          entry[1].text = entry[1].name;

        });

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getSearchResult(id, type, businessFlow) {
      let accessToken;
      this.isLoading = true;
      let token = 'edw3r323432472748923';
    //  console.log("inside getsearch result ",id,type ,businessFlow);
        //#7419
        if((id == constantVariable.verified_ndr || id == constantVariable.Verified_NPR || id == constantVariable.Verified_RTO_DTO_Reason) && (this.DepartmentID == constantVariable.ndr_validation_departmentid || this.DepartmentID == constantVariable.RTO_DTO_Verfication))
          {
            this.loadNDRReasonLists();
          }else if(id == constantVariable.ndr_validation || id == constantVariable.NPR_Validation || id == constantVariable.RTO_DTO_Validation){
              this.selectedActionObj = {};
              this.ticketStatusId = '',
              this.selectedTicketStatusObj = {};
          }
      this.input = ({
        "id": id,
        "type": type,
        "businessFlow": businessFlow,
        "page": this.page,
        "category": this.categoryOptionObj.text,
        "departmentId": this.DepartmentID,
        "role": this.Role.rolename
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchResult',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        let flag = false;
        let rvpflag = false;
        // console.log(this.DepartmentID,"this.source============");
        //#7419
        if(this.DepartmentID== constantVariable.ndr_validation_departmentid || constantVariable.rto_dto_verification)                 //#rto_dto_verification 
        if(this.DepartmentID== constantVariable.ndr_validation_departmentid || constantVariable.rto_dto_verification)                 //#rto_dto_verification 
        {
          this.selectedSourceObj = this.source.find(o => o.text == 'SR');
          this.sourceId = (this.selectedSourceObj.value != '') ? this.selectedSourceObj.value: '';
           
        }else{
          this.selectedSourceObj = this.source.find(o => o.text == 'Customer');
          this.sourceId = (this.selectedSourceObj.value != '') ? 1 : '';
        }
        
      

        this.sourceId = (this.selectedSourceObj.value != '') ? 1 : '';
        if (undefined !== result.data.data.data.main_data) {
          this.ticketType = result.data.data.data.main_data;
          this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
          this.ticketTypeId = this.selectedTicketObj.value;
        }

        if (undefined !== result.data.data.data.sub_data) {
          this.reason = result.data.data.data.sub_data;
          this.selectedReasonObj = this.reason.find(o => o.selected == 1);
        }
        if (undefined !== result.data.data.data.type_data) {
          this.subReason = result.data.data.data.type_data;
          this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);
          this.escalation = (undefined != this.selectedSubReasonObj) ? this.selectedSubReasonObj.isescalation : 0;

          if (this.subReason && this.subReason.length !=0 && (constantVariable.SrSubReasonIdArr.includes(Number(this.subReason[0].value)))) {
            this.getSRID();
          } else {
            this.shouldShowLabel = false;
          }

          if (this.selectedTicketObj.text == 'Request' && this.selectedReasonObj.text == 'Address change' && this.page == 'trackshipment') {

            if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) || this.SalesDemo.BusinessType.toLowerCase() == 'ecom') {

              var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexRedirectBank, 1);
              }
              var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexSecondaryBank, 1);
              }

              var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexPrimaryBank, 1);
              }
            } else {
              var indexDeliveryAddress = this.subReason.findIndex(o => o.text == 'Change delivery address');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexDeliveryAddress, 1);
              }
            }
          } else {

            if ((this.SalesDemo.NotificationStatus === null) || (this.SalesDemo.NotificationStatus != 'Reattempt' &&
                this.SalesDemo.NotificationStatus != 'Escalation' && this.SalesDemo.NotificationStatus != 'SuperEscalation')) {

              var indexReattemptDate = this.subReason.findIndex(o => o.text == 'Change Reattempt Date');
              if (-1 !== indexReattemptDate) {
                this.subReason.splice(indexReattemptDate, 1);
              }
            }
          }
        }
        if (undefined !== result.data.data.data.action_data) {

          this.action = result.data.data.data.action_data;
          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support ');

          if (-1 !== indexCsTeam) {
            if (businessFlow == 'Forward') {
              this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
            } else {
              this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
            }
          }
          if (this.subDepartmentList) {
            for (var i = 0; i < this.subDepartmentList.length; i++) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
            }
            for (var i = 0; i < this.subDepartmentList.length; i++) {

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                  rvpflag = true;
                  break;
                }
              }
            }
          }

          if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
            if (flag == false) {
              let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
              if (-1 !== indexOpsTeam) {
                this.action.splice(indexOpsTeam, 1);
              } else {
                // MSD Reattempt Handling
                if ('Reattempt Executive' !== this.userRole) {
                  this.action.push('Assigned to Fwd Client Support Team');
                }

              }
            } else {
              let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
              if (-1 !== indexFwdCsTeam) {
                this.action.splice(indexFwdCsTeam, 1);
              }
            }
          }

          if ('Admin' !== this.userRole && flag == false) {
            var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
            if (-1 !== indexRTONotify) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                this.action.splice(indexRTONotify, 1);
              }

            }
          }

          if ('Admin' !== this.userRole) {
            var indexStatusChanged = this.action.findIndex(o => o.text == 'Status Changed');

            if (-1 !== indexStatusChanged) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexStatusChanged, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {

            var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');
            if (-1 !== indexAddressUpdated) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
            }

            var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
            if (-1 !== indexContactUpdated) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexContactUpdated, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

            if (-1 !== indexPickupCancelled) {

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexPickupCancelled, 1);
              }

            }
          }
          // #alternateproof
          //Disabling of Validate the Proof shared'
          if(this.input.departmentId==constantVariable.POD){
            var validateProof = this.action.findIndex(o => o.text == 'Validate the Proof shared');
            this.action.splice(validateProof, 1);
          }
          // #alternateproof

          this.selectedActionObj = {};
          if( id === constantVariable.verified_ndr || id === constantVariable.Verified_NPR ){
          this.selectedActionObj = {
                "value": constantVariable.INFORMATION_GIVEN,
                "text": constantVariable.Information_given_resolution
            };
         // === NDR valiadtion === // --- calling selectedAction to date valiadtion on date input change
        this.selectedAction( this.selectedActionObj);
        this.actionId = constantVariable.INFORMATION_GIVEN;
          }
        
        }

        if (undefined !== this.selectedReasonObj) {
          this.reasonId = this.selectedReasonObj.value;
        } else {
          this.reasonId = '';
          this.selectedReasonObj = {};
        }
        if (undefined !== this.selectedSubReasonObj) {
          this.subReasonId = this.selectedSubReasonObj.value;

          if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.location = this.RTODetails.CustomerName;
            // this.address = this.RTODetails.Address;
            // this.pincode = this.RTODetails.PinCode;

          }

          if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {

            this.location = this.CustomerDetails.CustomerName;
            // this.address = this.CustomerDetails.Address;
            // this.pincode = this.CustomerDetails.Pincode;
          }
        } else {
          this.subReasonId = '';
          this.selectedSubReasonObj = {};
        }
        this.ticketStatus = [],
          this.ticketStatusId = '',
          this.selectedTicketStatusObj = {};
          if( id === constantVariable.verified_ndr || id === constantVariable.Verified_NPR ){
          this.selectedTicketStatusObj=  {
                "value": constantVariable.ticketStatusId,
                "text": constantVariable.ticketStatusId
            };
         this.ticketStatusId = constantVariable.ticketStatusId;
          }
          

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    async saveTicketData_s(e) {
      if (this.ShipmentTransactionLogSummary.IsHeavies == true) {
        this.confirmMessage = `Are you sure to process this MPS/AWB number ?`
        this.$alertify.confirmWithTitle(' Raise ticket : ', this.confirmMessage, () => this.saveTicketData(e),
          () => this.$alertify.error("cancel"))
      } else {
        this.saveTicketData(e);
      }
    },

    saveTicketData(e) {
      try {
        this.ticketResultMsg = '';
        //  #rto_dto_varification 
        if (!this.primaryContactNo) {
          this.primaryContactNo = this.primaryContactNoComputed;
        }
        //  #rto_dto_varification 
        if (!this.primaryContactNo) {
          this.primaryContactNo = this.primaryContactNoComputed;
        }

        if (this.tableShipment === false && this.ticketShipmentData.length == 0) {
          this.$alertify.error('Please select shipments for creating ticket.');
          return false;
        }
        var userToken = window.localStorage.getItem('userToken');
        let token = 'edw3r323432472748923';
        var myStr = userToken.replace(/"/g, '');

        if (this.sourceId === '') {
          this.$alertify.error('Please select source.');
          return false;
        }

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select tiket type.');
          return false;
        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select subreason.');
          return false;
        }

        if (this.actionId === '') {
          this.$alertify.error('Please select action.');
          return false;
        }
        if (this.comments === '') {
          this.$alertify.error('Please enter comments.');
          return false;
        }
        // this should be auto enabled if the subreasonId matches only else no
        if (this.srid === '' && this.shouldShowLabel === true) {
          this.$alertify.error('Please select SR ID.');
          return false;
        }
        if (this.srname === '' && this.shouldShowLabel === true) {
          this.$alertify.error('Please select SR Name.');
          return false;
        }
        this.fakeNdrStatus = 0;
        if ((this.ShipmentTransactionLogSummary.BusinessFlow == 'Forward' && this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update') ||
          (this.selectedReasonObj.text == 'Cancellation Request' && this.selectedSubReasonObj.text == 'Fake update')) {
          this.fakeNdrStatus = 1;
        }

        let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';

        if (attempDate.length != 10 && attempDate !== '') {
          //   attempDate = moment((attempDate)).format('YYYY-MM-DD');
          attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
        }
        // console.log("this.netPayment===>",this.netPayment);
        // console.log("this.orderTypeId===>",this.orderTypeId);
        // if (this.netPayment == '' && this.orderTypeId == 'CashOnDelivery') {
        //   this.$alertify.error('Please enter net amount.');
        //   return false;
        // }


        let address = (this.address != '') ? this.address : '';
        let pincode = (this.pincode != '') ? this.pincode : '';
        let comments = (this.comments != '') ? this.comments : '';
        let orderTypeId = (this.orderTypeId != '') ? this.orderTypeId : '';
        let netPayment = (this.netPayment != '') ? this.netPayment : '';
        let location = (this.location != '') ? this.location : '';
        let oldReAttemptDate = (this.oldReAttemptDate != '') ? this.oldReAttemptDate : '';
        let alternateContactNo = (this.alternateContactNo != '') ? this.alternateContactNo : '';
        let primaryContactNo = (this.primaryContactNo != '') ? this.primaryContactNo : '';         //  #rto_dto_varification
        let emailAddress = (this.emailAddress != '') ? this.emailAddress :  (this.CustomerDetails.EmailID != '' ? this.CustomerDetails.EmailID : '');
        let mobileNo = (this.mobileNo != '') ? this.mobileNo : '';

        //let ServiceName = (this.SalesDemo.ServiceType != null && this.SalesDemo.ServiceType != '') ? this.SalesDemo.ServiceType : '';
        let ServiceName = '';

        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Redirect to Bank') &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (address === '') {
            this.$alertify.error('Please enter address details.');
            return false;
          }
        }

        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
            this.selectedSubReasonObj.value == constantVariable.CHANGE_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE ||
            this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE) &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (pincode == '') {
            this.$alertify.error('Please enter pincode.');
            return false;
          }
        }
        if (this.selectedSubReasonObj.text == 'Change payment mode / amount' && (this.selectedActionObj.text == constantVariable.ASSIGNED_CS_TEAM ||
            this.selectedActionObj.text == constantVariable.STATUS_CHANGED || this.selectedActionObj.value == constantVariable.PAYMENT_DETAILS_CHANGE_REQUESTED)) {

          if (netPayment == '' && orderTypeId == 'CashOnDelivery') {
            this.$alertify.error('Please enter net amount.');
            return false;
          }
        }

        if ((this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery' ||
            this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON ||
            this.selectedSubReasonObj.text == "Change Reattempt Date" || this.selectedSubReasonObj.text == "ReAttempt" ||
            this.selectedSubReasonObj.value == constantVariable.FAKE_NPR || this.selectedSubReasonObj.value == constantVariable.FAKE_PICKUP ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR ||
            this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        // Change Reattempt Validations
        if ((this.selectedSubReasonObj.text == "Change Reattempt Date") && this.selectedActionObj.text == 'Reattempt date changed') {
          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }


        if ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') ||
          (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in connection' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team')) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }
        if (this.selectedReasonObj.text == 'Arrange pickup') {

          if ((this.selectedSubReasonObj.text == 'Future pickup' || this.selectedSubReasonObj.text == 'Urgent pickup' ||
              this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup') &&
            this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }
        }
        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No' &&
          (this.selectedActionObj.text == 'Contact details updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (alternateContactNo == '') {
            this.$alertify.error('Please enter alternate contact number.');
            return false;
          }
        }
          //  #rto_dto_varification  start ------
          if (this.selectedReasonObj.value == constantVariable.OTP_REQUEST &&
            this.selectedSubReasonObj.value == constantVariable.GENERATE_OTP &&
            this.selectedActionObj.value == constantVariable.SEND_OTP ) {
      
          if (this.primaryContactNo == '') {
            this.$alertify.error('Please enter primary contact number to generate OTP.');
            return false;
          }
        }
        //  #rto_dto_varification  end ------
    
          //  #rto_dto_varification  start ------
          if (this.selectedReasonObj.value == constantVariable.OTP_REQUEST &&
            this.selectedSubReasonObj.value == constantVariable.GENERATE_OTP &&
            this.selectedActionObj.value == constantVariable.SEND_OTP ) {
      
          if (this.primaryContactNo == '') {
            this.$alertify.error('Please enter primary contact number to generate OTP.');
            return false;
          }
        }
        //  #rto_dto_varification  end ------
    
        if (this.ticketTaggingDisplay == false && mobileNo == '' && (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Redirect to Bank') && (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (mobileNo == '') {
            this.$alertify.error('Please enter primary contact number.');
            return false;
          }
        }
        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address' &&
          (this.selectedActionObj.text == 'Contact details updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (emailAddress == '') {
            this.$alertify.error('Please enter email address.');
            return false;
          }
          if (emailAddress != '') {
            if (this.ValidateEmail(emailAddress) == false) {
              this.$alertify.error('Please enter valid email address.');
              return false;
            }
          }
        }

        let businessFlow;
        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE) && (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'RTO';
          businessFlow = 'Reverse';
        }

        if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
          this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_DELIVERY_PINCODE &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'Delivery';
        }
        if ((this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE) && (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          businessFlow = 'Reverse';
        }
        if ((this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
            (this.selectedSubReasonObj.value == constantVariable.CHANGE_DELIVERY_PINCODE && this.SalesDemo.BusinessFlow.toLowerCase() == 'forward')) &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          businessFlow = 'Forward';
        }

        if ((this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode' ||
            (this.selectedSubReasonObj.value == constantVariable.CHANGE_PICKUP_PINCODE && this.SalesDemo.BusinessFlow.toLowerCase() == 'reverse')) &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'Pickup';
          businessFlow = 'Reverse';
        }
           //#7419
        if((this.selectedReasonObj.value === constantVariable.ndr_validation && this.selectedSubReasonObj.value ===  constantVariable.verified_ndr)||
           (this.selectedReasonObj.value === constantVariable.Verified_NPR && this.selectedSubReasonObj.value ===  constantVariable.Verified_NPR)){
            
  // FORWARD flow
  if (
    this.SalesDemo && this.SalesDemo.BusinessFlow && this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.BusinessFlow !== 'Reverse' &&
    this.SalesDemo && this.SalesDemo.UserProcess && this.SalesDemo.UserProcess.toLowerCase() !== 'out for delivery' && this.SalesDemo.UserProcess.toLowerCase() !== "(hd)out for delivery"
  ) {
    this.$alertify.error('Shipment should be Out for Delivery');
    return false;
  }

  // REVERSE flow
  if (
    this.SalesDemo && this.SalesDemo.BusinessFlow && this.SalesDemo.BusinessFlow === 'Reverse' && this.SalesDemo.BusinessFlow !== 'Forward' &&
     this.SalesDemo.ShipmentStatus && this.SalesDemo.ShipmentStatus.toLowerCase() !== 'outforpickup'
  ) {
    this.$alertify.error('Shipment should be Out for Pickup');
    return false;
  }



              if(this.selectedNDRReasonObj.value === ''){
                this.$alertify.error('Please select NDR reason.');
                return false;
              }
               if (attempDate == "" && this.ndrReattemptDateflag == true) {
                this.$alertify.error("Please enter reattempt date.");
                return false;
              }
}
    if (
  this.selectedReasonObj.value === constantVariable.RTO_DTO_Validation||
    this.selectedSubReasonObj.value === constantVariable.Verified_RTO_DTO_Reason 
) { 
          if(!this.UAPayload.shipmentType) {
          this.$alertify.error('No rider helper record found');
          return;
        }

   if (
    this.SalesDemo && this.SalesDemo.UserProcess && this.SalesDemo.UserProcess.toLowerCase() !== 'out for delivery' &&  this.SalesDemo.UserProcess.toLowerCase() !== "(hd)out for delivery"
   && this.UAPayload.shipmentType !== 'RTO' && this.UAPayload.shipmentType !== 'DTO'

  ) {
    this.$alertify.error('Shipment should be Out for Delivery');
    return false;
  }

              if(this.selectedNDRReasonObj.value === ''){
                this.$alertify.error('Please select NDR reason.');
                return false;
              }
              
              if (attempDate == "" && this.ndrReattemptDateflag == true) {
                this.$alertify.error("Please enter reattempt date.");
                return false;
              }
}  
        if (this.comments === '') {
          this.$alertify.error('Please enter comments.');
          return false;
        }



        this.input = ({
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          UAPayload: this.UAPayload,                 
          ticketStatusId: this.ticketStatusId.toString(),
          userId: this.userid.toString(),
          username: this.username,
          flag: this.tableShipment.toString(),
          shippingData: this.ticketShipmentData,
          deptid: this.DepartmentID.toString(),
          businessunit: this.SalesDemo.BusinessType,
          businessflow: this.SalesDemo.BusinessFlow,
          pincodebusinessflow: businessFlow,
          businessservice: ServiceName,
          routemode: "surface",
          IsFakeNDRStatus: this.fakeNdrStatus,
          userType: this.userTypeForTicket,
          escalation: this.escalation,
          subReason: this.selectedSubReasonObj.text,
          clientID : this.SalesDemo.ClientID,
          prexoType : this.PrexoType,
          prexoShipment : this.PrexoShipment, 
          //#7419
          selectedNDRUniquecode : this.selectedNDRReasonObj.value, 
          selectedNDRTitle : this.selectedNDRReasonObj.text,
          processCode:this.processCode,
       //   disputeStatusCode: (this.childSubReasonList && this.childSubReasonList.length  > 0 ) ? true : false,
          disputeStatusCode:this.selectedNDRSubReasonObj.value,
          selectedSubNDRUniquecode : (this.childSubReasonList && this.childSubReasonList.length  > 0 ) ? this.selectedNDRSubReasonObj.value : "",
          selectedNDRID : this.selectedNDRReasonObj.id, //#7419
          AssociatedNDR : this.selectedNDRReasonObj.AssociatedNDR || '',  //#prexo_flow
          AssociatedNDRTitle : this.selectedNDRReasonObj.AssociatedNDRTitle || ''  //#prexo_flow
          // === NDR Valaiadtion === // --- sending ndr process code && dispute staus code  in api

        });
        if (constantVariable.SrSubReasonIdArr.includes(Number(this.subReasonId))) {
          this.input.srid = this.srid,
          this.input.srname = this.srname
        }

 // Intracity chages
        if (this.SalesDemo.ServiceType && this.SalesDemo.ServiceType == 'IntraSDD') {
           this.input.businessunit = 'Intracity';
         }


        if (attempDate !== '' && attempDate != null) {
          this.input.reAttemptDate = attempDate;
        }
        if (address !== '' && address !== null) {
          this.input.address = address;
        }

        if (pincode !== '' && pincode != null) {
          this.input.pincode = pincode;
        }
        if (location !== '' && location != null) {
          this.input.location = location;
        }
          // === NDR Valiadtion changes === -- Appending ndr reason in comment 
          if (comments !== "" && comments != null) {
          if (
            this.selectedSubReasonObj.value === constantVariable.verified_ndr
          ) {
            this.input.comments =
              this.selectedNDRReasonObj.text + " - " + this.comments;
          } else if(this.selectedReasonObj.value === constantVariable.NON_BEHAVIORAL &&
            (this.selectedSubReasonObj.value === constantVariable.VENDOR_DELAY_PICKUP || this.selectedSubReasonObj.value === constantVariable.VENDOR_FAKE_NPR)){
              this.input.comments = this.selectedSubReasonObj.text + " - " + this.comments;
          }
          else {
            this.input.comments = comments;
          }
        }
        // === NDR Valiadtion changes === -- Appending ndr reason in comment 
        if (this.tableShipment.toString() == 'true') {
          this.input.ticketId = this.ticketId.toString();
          this.input.ticketData = this.ticket;
        }
        if (this.tableShipment === true || this.ticketShipmentData.length == 1) {

          this.input.isLatestOfd = this.SalesDemo.IsLatestOFD;

          if (this.SalesDemo.UserProcess !== '' && this.SalesDemo.UserProcess != null) {
            this.input.userProcess = this.SalesDemo.UserProcess;
          }
          if (this.SalesDemo.NotificationType !== '' && this.SalesDemo.NotificationType != null) {
            this.input.notificationType = this.SalesDemo.NotificationType;
          }
          if (this.SalesDemo.NotificationStatus !== '' && this.SalesDemo.NotificationStatus != null) {
            this.input.notificationStatus = this.SalesDemo.NotificationStatus;
          }
        }

        if (orderTypeId !== '' && orderTypeId !== null) {
          this.input.orderTypeId = orderTypeId;
        }
        if (netPayment !== '' && netPayment !== null) {
          this.input.netPayment = netPayment;
        }
        if (oldReAttemptDate !== '' && oldReAttemptDate !== null) {
          this.input.oldReAttemptDate = oldReAttemptDate;
        }

        if (alternateContactNo != '' && alternateContactNo != null) {
          this.input.alternateContactNo = alternateContactNo;
        }
        //  #rto_dto_varification  start -----
        if (primaryContactNo!= '' && primaryContactNo != null) {
          this.input.primaryContactNo = primaryContactNo;
        }
        // #rto_dto_varification end -------
        //  #rto_dto_varification  start -----
        if (primaryContactNo!= '' && primaryContactNo != null) {
          this.input.primaryContactNo = primaryContactNo;
        }
        // #rto_dto_varification end -------
        if (emailAddress != '' && emailAddress != null) {
          console.log("emailAddress is :::",emailAddress);
          this.input.emailAddress = emailAddress;
        }
        if (mobileNo != '' && mobileNo !== null) {
          this.input.mobileNo = mobileNo;
        }

        this.input.emailCasesArrayForUpdate = this.emailCasesArrayForUpdate;




        //Start sendSMSForDeliveryOTP 
        if (this.selectedActionObj.text == 'Send OTP') {

          if (this.OrderDetails && this.OrderDetails.srUserData) {
            this.input.SrID = this.OrderDetails.srUserData.userid;
            this.input.SrFirstName = this.OrderDetails.srUserData.FirstName;
            this.input.SrMobileNumber = this.OrderDetails.srUserData.MobileNumber;
          }

          //  this.input.DelivereyOTP = "1234567"; // test 
          this.input.DelivereyOTP = this.SalesDemo.DelivereyOTP;
          this.input.ClientName = this.SalesDemo.ClientName;
          this.input.DeliveryCustomerPhoneNo = this.CustomerDetails.PhoneNo;

          if (this.input.DelivereyOTP === '') {
            this.$alertify.error('Delivery OTP is not available in system, please try later.');
            return false;
          }

          if (this.input.SrID === '') {
            this.$alertify.error('SR details are not available in system, please try later.');
            return false;
          }
          this.input.comments = this.input.comments + " (Delivery OTP:" + this.input.DelivereyOTP + ")";

        }
        //End sendSMSForDeliveryOTP
        // #alernateproof
        if(this.DepartmentID==constantVariable.POD){
          if(this.input.ticketStatusId!='Open'){
            if(this.proofstatus==''){
              this.$alertify.error('Please mark proof of delivery as valid or invalid.');
              return false;
            }
            else{
              this.input.proofstatus=this.proofstatus;
            }
            
            //No need to update weblink in case of close
            if(this.input && this.input.ticketData && this.input.ticketData.web_link){
              delete this.input.ticketData.web_link;
            }
          }
        }
        // #alernateproof

        //hub_escalation
        this.input.SourceName= this.selectedSourceObj.text
        //hub_escalation
          // Appending payment order details in comment
          if (comments !== "" && comments != null) {
              if (this.selectedSubReasonObj.text === "Change payment mode / amount") {
                const amountDetails =
                  `(Old Amount:${this.OrderDetails.CollectibleAmount}, New Amount:${this.netPayment})`;
                const orderTypeDetails =
                  `(Old OrderType:${this.OrderDetails.OrderType}, New OrderType:${this.selectedMethodObj.text})`;
                const extraDetails = `${amountDetails} ${orderTypeDetails}`;              
                this.input.comments = this.comments + " - " + extraDetails;
              } else {
            this.input.comments = comments;
          }
          }
        this.isLoading = true;
          // Save payload only first time
if (!this.isRetry) {
  this.lastPayload = JSON.parse(JSON.stringify(this.input));
}
          const finalPayload =
            this.UAPayload.isRetry && this.lastPayload
              ? this.lastPayload
              : this.input;
          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'createTicket',
            'data': finalPayload,
            'min': 1,
            'idle': 10000,
            'acquire': 10000,
            'evict': 60000,
            'handleDisconnects': true,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {

            this.isLoading = false;

            if (result.data.data.status == true) {

              /*Start IP Tracking */
              let userTrackerObj = {};
              // console.log(" this.input", this.input);
              userTrackerObj.subReason = this.input.subReason;
              userTrackerObj.userid = this.userid;
              userTrackerObj.username = this.username;
              userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
              if (this.input.flag == 'false') {
                userTrackerObj.shippingData = this.input.shippingData;
              } else {
                userTrackerObj.shippingData = this.input.ticketData.shippingid;
              }
              userTrackerObj.flag = this.input.flag;
              userTrackerObj.ticketid = result.data.data.ticketid;
              this.userTracker(userTrackerObj);
              /*End IP Tracking */

              this.getTrackShipmentSummeryDetails();
              this.ticketResultMsg = result.data.data.msg;
              // console.log("result.data.data.data ",result.data.data.data);
              if (
                this.ticketResultMsg &&
                this.ticketResultMsg.toLowerCase().includes("vendorgroup")
              ) {
                this.UAPayload.isRetry = true;
                this.UAPayload.vendorGroupIds = [
                ...new Set(
                  (msg.match(/VendorGroup\s+([A-Z0-9]+)/gi) || [])
                    .map(item => item.split(" ")[1])
                )
              ];
              }
              this.ticketResultModal = true;
              if (this.tableShipment.toString() == 'false') {
                this.resetForm();
                this.ticketTaggingDisplay = true;
              } else {
                this.ShowRaiseTicketDiv();
                this.ticketTaggingDisplay = true;
              }
            } else {
              this.ticketResultMsg = result.data.data.msg;
              if (result.data.data.data != '') {
                this.ticket = result.data.data.data.data;

              }
              this.ticketResultModal = true;
            }

          }, error => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkErrorCreateTicket(error);
            this.$alertify.error(commonVariable);
            console.error(error);
          })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - saveTicketData";
        this.$alertify.error(msg);
      }
    },


    async userTrackerBulkEdit(userTrackerObj) {
      //console.log("userTrackerObj ",JSON.stringify(userTrackerObj));
      var trackurl = this.$route.path;
      var projectname = apiUrl.project_name;

      if (userTrackerObj.ticketData && userTrackerObj.ticketData.length) {

        for (var i = 0; i < userTrackerObj.ticketData.length; i++) {

          let shippingid = userTrackerObj.ticketData[i].shippingData.shippingid;
          let eventTrack = "TicketUpdation " + userTrackerObj.subReason;
          let inputDataReq = {
            "projectname": projectname,
            "type": "web",
            "userid": userTrackerObj.userid,
            "username": userTrackerObj.username,
            "olduserid": userTrackerObj.olduserid,
            "routeurl": trackurl,
            "meta": {
              "event": eventTrack,
              "shippingid": shippingid
            }
          };
          authFunction.userTracker(inputDataReq);
        }
      }
    },


    async userTracker(userTrackerObj) {
      var trackurl = this.$route.path;
      var projectname = apiUrl.project_name;

      if (userTrackerObj.flag == 'false') {

        if (userTrackerObj.shippingData && userTrackerObj.shippingData.length) {

          userTrackerObj.shippingData.forEach(async function (arrElement) {
            let shippingid = arrElement.shippingData.ShippingID
            let eventTrack = "TicketCreation " + userTrackerObj.subReason;
            let meta = {
              "event": eventTrack,
              "shippingid": shippingid
            };
            if (userTrackerObj.ticketid) {
              meta.ticketid = userTrackerObj.ticketid;
            }
            let inputDataReq = {
              "projectname": projectname,
              "type": "web",
              "userid": userTrackerObj.userid,
              "username": userTrackerObj.username,
              "olduserid": userTrackerObj.olduserid,
              "routeurl": trackurl,
              "meta": meta
            };
            authFunction.userTracker(inputDataReq);
          });
        }
      } else {
        let shippingidUpd = userTrackerObj.shippingData;
        let eventTrackUpd = "TicketUpdation " + userTrackerObj.subReason;
        let inputDataReqUpd = {
          "projectname": projectname,
          "type": "web",
          "userid": userTrackerObj.userid,
          "username": userTrackerObj.username,
          "olduserid": userTrackerObj.olduserid,
          "routeurl": trackurl,
          "meta": {
            "event": eventTrackUpd,
            "shippingid": shippingidUpd
          }
        };
        authFunction.userTracker(inputDataReqUpd);
      }
    },

    ValidateEmail(inputtext) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputtext)) {
        return true;
      }
      return false;
    },
    // checkPin CodeServiceable
    checkPinCodeServiceable() {
      let ServiceName = '';
      let businessFlow = '';
      let pincode = (this.pincode != null && this.pincode != '') ? this.pincode.trim() : '';
      if (pincode == '') {
        this.$alertify.error('Please enter pincode.');
        return false;
      }

      if (this.selectedSubReasonObj.text == 'Change RTO address' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'RTO';
        businessFlow = 'Reverse';
      }

      if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'Delivery';
      }
      if (this.selectedSubReasonObj.text == 'Change DTO address' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        businessFlow = 'Reverse';
      }
      if ((this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank') && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        businessFlow = 'Forward';
      }

      if ((this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode') && (this.SalesDemo.BusinessType == 'Ecomm' ||
          this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'Pickup';
        businessFlow = 'Reverse';
      }

      this.isLoading = true;

      this.input = ({
        "businessunit": this.SalesDemo.BusinessType,
        "businessflow": businessFlow,
        "businessservice": ServiceName, //"Delivery",
        "pincode": this.pincode,
        "routemode": "surface",
      })

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'checkPinCodeServiceable',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          this.isLoading = false;

          let resultDataCrm = result.data.data;

          if (resultDataCrm.status == true) {
            this.$alertify.success(resultDataCrm.msg);
          } else {
            this.$alertify.error(resultDataCrm.msg);
          }

        }, error => {
          this.isLoading = false;
          this.$alertify.error(error);
        })
    },

    getShippingIdDetailsByTicketId() {
      var TickID = this.ShippingID;
      this.input = ({
        "TicketID": this.ShippingID
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getShippingIdDetailsByTicketId',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        var resultShip = result.data.data;
        if (resultShip.status == true) {
          this.ShippingID = resultShip.data.shippingid;
          this.getShipmentTickets(this.ShippingID, TickID);
          this.Ticketmodal = true;
          let dataObj = {
            "value": "ShippingID",
            "text": "Shipping ID"
          };
          this.selectTypeOption(dataObj);
          this.selectReasonOption(dataObj);                            //track_security_7627
          this.getTrackShipmentSummeryDetails();
        } else {
          let msg = resultShip.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    getTicketHistory(ticket) {
      this.shouldShowSRLabel = false;
      this.ticketIDLog = ticket.ticketid
      this.input = ({
        "ticketid": this.ticketIDLog
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketHistory',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        var resultTickets = result.data.data;
        if (resultTickets.status == true) {
          this.resultTicket = result.data.data.data;
          if (this.resultTicket && this.resultTicket.length > 0) {
            for (let ticket of this.resultTicket) {
              let adlinfo = ticket.adlinfo;
              if (adlinfo && Object.keys(adlinfo).length !== 0) {
                if (Object.keys(adlinfo).includes('SrID') || Object.keys(adlinfo).includes('SrName')) {
                  this.shouldShowSRLabel = true;
                  break;
                }
              }
            }
          }
          this.TicketLogModal = true;
        } else {
          let msg = this.resultTicket.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    accessRestrictor() {
      var desider = 0;
      var n = window.location.href.search('#');
      var link = window.location.href.substr(n + 1);
      var linkToo = window.location.href.substr(n + 2);
      for (let i = 0; i < this.permissiondata.length; i++) {
        if (link == this.permissiondata[i].url) {
          desider++;
        }
      }
      if (desider == 0) {
        this.$router.push('/dashboard');
        this.$alertify.error("Access Denied for " + linkToo + " Module.");
      }
    },

    saveBulkEditShipment() {
      try {

        let token = 'edw3r323432472748923';

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select Tiket Type.');
          return false;
        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select Reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select Sub Reason.');
          return false;
        }

        if (this.actionId === '') {
          this.$alertify.error('Please select Action.');
          return false;
        }

        if (this.srid === '' && this.shouldShowLabel === true) {
          this.$alertify.error('Please select SR ID.');
          return false;
        }
        if (this.srname === '' && this.shouldShowLabel === true) {
          this.$alertify.error('Please select SR Name.');
          return false;
        }

        let attempDate = (this.newReAttemptDate != null && this.newReAttemptDate != '') ? this.newReAttemptDate : '';

        if (attempDate.length != 10 && attempDate !== '') {
          // attempDate = moment((attempDate)).format('YYYY-MM-DD');
          attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
        }

        if (this.ticketExistedData.length == 1 && (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup') && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if ((this.ticketExistedData.length == 1 && ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||

            (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team')) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
          this.fakeNdrStatus = 1;
        }

        this.input = ({
          ticketIds: this.ticketIDS.toString(),
          ticketData: this.ticketExistedData,
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          ticketStatusId: this.ticketStatusId.toString(),
          reAttemptDate: attempDate,
          deptid: this.DepartmentID.toString(),
          userId: this.userid.toString(),
          username: this.username,
          filename: this.excelFileUploadPath,
          comments: this.comments,
          userType: this.userTypeForTicket,
          IsFakeNDRStatus: this.fakeNdrStatus,
          businessflow: this.ticketExistedData[0].shippingData.businessflow,
          escalation: this.escalation,
          editHoldTicket: this.editHoldTicket
        });
        if (constantVariable.SrSubReasonIdArr.includes(Number(this.subReasonId))) {
          this.input.srid = this.srid;
          this.input.srname = this.srname;
        }
         // === NDR Valiadtion changes === -- Appending ndr reason in comment 
        if (this.comments !== "" && this.comments != null) {
          if(this.selectedReasonObj.value === constantVariable.NON_BEHAVIORAL &&
            (this.selectedSubReasonObj.value === constantVariable.VENDOR_DELAY_PICKUP || this.selectedSubReasonObj.value === constantVariable.VENDOR_FAKE_NPR)){
              this.input.comments = this.selectedSubReasonObj.text + " - " + this.comments;
          }
        }
        this.isModelLoading = true;

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'createBulkEditTickets',
          'data': this.input,
          'min': 1,
          'idle': 10000,
          'acquire': 10000,
          'evict': 60000,
          'handleDisconnects': true,
          headers: commonFunction.getusertoken(),
        })
          .then(result => {


            /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.selectedSubReasonObj.text;
            userTrackerObj.ticketData = this.input.ticketData;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            this.userTrackerBulkEdit(userTrackerObj);
            /*End IP Tracking */

            this.isModelLoading = false;
            this.ticketResultMsg = '';
            this.ticketResultMsg = result.data.data.msg;
            if (this.tableShipment.toString() == 'false') {
              this.resetForm();
              this.ticketTaggingDisplay = true;
            } else {
              this.ShowRaiseTicketDiv();
              this.ticketTaggingDisplay = true;
            }
            this.ticketResultModal = true;
            // this.allSelected = false;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }
            this.ticket = [];
            this.ticketIDS = [];
            this.ticketExistedData = []
            this.selectAllRecord = false;
            this.listExisitngTicketModal = false;
            this.updateExistingBulkTicket = false;
            this.showBulkTicketDiv = false;

            if (result.data.data.status == true) {
              this.getTrackShipmentSummeryDetails();
            }

          }, error => {
            this.isLoading = false;
          })
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - saveBulkShipment";
        this.$alertify.error(msg);
      }

    },

    // Get All Shipments by MPS Group ID
    getAllShipmentsByMPSGroupID() {
      try {
        this.ticketIDLoader = true;
        this.OtherShipments.showChart = false;
        let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0];
        } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          this.OtherShipments.chartData.labels = ["Pick Done", "Not Picked", "DTO", "Cancelled", "DTO Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "orange", "blue", "red", "gray"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0, 0, 0];
        }
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.DTOCnt = 0;
        this.OtherShipments.NotPickedCnt = 0;
        this.OtherShipments.PickDoneCnt = 0;
        this.OtherShipments.CancelledCnt = 0;
        this.OtherShipments.DTOUndeliveredCnt = 0;
        this.isLoading = true;
        this.OtherShipmentLogArr = [];
        let PhoneNo;
        PhoneNo = this.CustomerDetails.PhoneNo;

        let SelectedShippingID = this.ShippingID;
        let allMPSGroupID = this.SalesDemo.MPSGroupId;
        let getClientID = this.SalesDemo.ClientID;
        this.OtherShipments.isLoading = true;

        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          MPSGroupID: allMPSGroupID,
          ClientID: getClientID
        })
        axios({
            'timeout': 40000, // TimeOut Forcefully
            'method': 'POST',
            'url': apiUrl.api_url + 'getAllShipmentsByMPSGroupID',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.arrayofobj = [];
            this.categoryCatalogue = [];
            this.OtherShipments.isLoading = false;
            this.ticketIDLoader = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {

                let flag = false;
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                  for (let i = 0; i < resultData.Shipments.length; i++) {
                    let indexStatus = this.category.Forward.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

                    if (-1 !== indexStatus && undefined !== this.category.Forward[indexStatus]) {
                      if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Forward[indexStatus].name)) {
                        this.arrayofobj.push({
                          text: this.category.Forward[indexStatus].name,
                          value: this.category.Forward[indexStatus].name
                        });
                      }
                    } else {
                      flag = true;

                      if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                        this.UnCategorizedArrData.push(resultData.Shipments[i]);
                      }

                    }
                  }
                }
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
                  for (let i = 0; i < resultData.Shipments.length; i++) {
                    let indexStatus = this.category.Reverse.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

                    if (-1 !== indexStatus && undefined !== this.category.Reverse[indexStatus]) {
                      if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Reverse[indexStatus].name)) {
                        this.arrayofobj.push({
                          text: this.category.Reverse[indexStatus].name,
                          value: this.category.Reverse[indexStatus].name
                        });
                      }

                    } else {
                      flag = true;
                      if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                        this.UnCategorizedArrData.push(resultData.Shipments[i]);
                      }
                    }
                  }
                }

                if (flag == true) {
                  this.arrayofobj.push({
                    text: 'Unidentified',
                    value: 'Unidentified'
                  });
                }

                let OtherShipmentLog = resultData.Shipments;
                let OtherShipmentLogCnt = OtherShipmentLog.length;
                this.OtherShipmentLogCnt = OtherShipmentLogCnt;
                if (OtherShipmentLogCnt > 0) {
                  this.OtherShipmentLogArr = [];

                  this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
                  this.OtherShipments.ClientName = "";

                  //Start DoughnutChart Logic
                  let i;
                  for (i = 0; i < OtherShipmentLogCnt; i++) {
                    //  OtherShipmentLog[i].ClientName = "";
                    OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;

                    this.OtherShipmentLogArr.push(OtherShipmentLog[i]);

                    if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                      if (OtherShipmentLog[i].Status === "Delivered") {
                        this.OtherShipments.DeliveredCnt++;
                      }
                      if (OtherShipmentLog[i].Status === "RTO") {
                        this.OtherShipments.RTOCnt++;
                      }
                    } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {


                      if (OtherShipmentLog[i].Status === "DTO" && OtherShipmentLog[i].CurrentStatus === "WHHandover") {
                        this.OtherShipments.DTOCnt++;
                      }
                      if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "Pending" || OtherShipmentLog[i].CurrentStatus === "OutForPickup" || OtherShipmentLog[i].CurrentStatus === "PickupAssinged" || OtherShipmentLog[i].CurrentStatus === "PickupNotDone" || OtherShipmentLog[i].CurrentStatus === "ReinitiatedPickups")) {
                        this.OtherShipments.NotPickedCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "PickupDone" || OtherShipmentLog[i].CurrentStatus === "PickupDoneBySR")) {
                        this.OtherShipments.PickDoneCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "RPCancel" && OtherShipmentLog[i].CurrentStatus === "RPCancel") {
                        this.OtherShipments.CancelledCnt++;
                      }

                      if (OtherShipmentLog[i].Status === "Shipped" && (OtherShipmentLog[i].CurrentStatus === "InScan" || OtherShipmentLog[i].CurrentStatus === "Inscan")) {
                        this.OtherShipments.DTOUndeliveredCnt++;
                      }
                    }
                    // get ClientName by ID
                    if (OtherShipmentLog[i].ClientID > 0) {
                      // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
                    }
                  }

                  this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
                  this.showStats();
                  this.selectedOptionObj(this.categoryOptionObj);
                  //End DoughnutChart Logic

                } else {
                  this.OtherShipmentLogArr = [];
                }
              } else {
                let msg = resultData.ReturnMessage;
                // this.$alertify.error(msg);
                this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
              }
            } else {
              let msg = resultDataCrm.msg;
              // this.$alertify.error(msg);
              this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
            }
          }, error => {
            this.OtherShipments.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            // this.$alertify.error(commonVariable);
            this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
          })
      } catch (error) {
        this.OtherShipments.isLoading = false;

        let msg = error + " - getAllShipmentsByMPSGroupID";
        // console.log("msg==" + msg);
        // this.$alertify.error(msg);
        this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
      }
    },

    // #alernateproof
    validateDocumentProof(id){
      let errormsg='Please mark document as Valid/Invalid'
      let errorcb=()=>{
        this.proofstatus='';
        this.$alertify.error(errormsg)
      }
      if(id=='valid'){
        this.confirmMessage = `Are you sure the proofs submitted is valid and shipment can be updated to delivery ?`
        this.$alertify.confirmWithTitle('Alert', this.confirmMessage, () => {
          this.proofstatus='Approved';
          this.$alertify.success("Document Verification Successful")
        },errorcb)
      }
      if(id=='invalid'){
        this.confirmMessage = `Are you sure the proofs submitted is Invalid?`
        this.$alertify.confirmWithTitle('Alert', this.confirmMessage, () => {
          this.proofstatus='Rejected';
          this.$alertify.success("Document marked as Invalid")
        },errorcb)
      }
    },


    // #Alternateproof
    async viewSalesLink(url,ticket) {
      try {        
        url = (url === '') ? ticket.web_link : url;
        this.isLoading=true;
        let data={
          url:url
        }
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getpresignedurl',
          'data': data,
          'min': 1,
          'idle': 10000,
          'acquire': 10000,
          'evict': 60000,
          'handleDisconnects': true,
          headers: commonFunction.getusertoken(),
        })
        .then(objresult => {
          setTimeout(() => {
            let result = objresult.data.data.data;
            this.displayImageInBox=result;
            this.previewImageModel = true
            this.isLoading = false 
          }, 1000)
        }, error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkErrorCreateTicket(error);
          this.$alertify.error(commonVariable);
          console.error(error);
        })
            
      } catch (error) {
        this.isLoading = false 
        this.$alertify.error(error);
      }
    },
    closeModelPreviewImage() {
      this.previewImageModel = false
      this.displayImageInBox = ''
    },
    // #Alternateproof

     // SRID addition
     selectedSRID(selectedOption) {
      this.selectedSRIDnObj = selectedOption;
      this.srid = (this.selectedSRIDnObj.text) ? this.selectedSRIDnObj.text : this.selectedSRIDnObj;
      this.getSRName(this.selectedSRIDnObj);
    },
    getSRID() {
      this.isLoading = true;
      this.SRIDsId = '';
      this.SRNameId = '';
      this.srid = '';
      this.srname = '';
      this.selectedSRIDnObj = {};
      this.selectedSRNamenObj = {};
      this.shouldShowLabel = true;
      let payload = ({
        shippingid : this.SalesDemo.ShippingID
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSrIdByShipment',
        'data': payload,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.SRIDs = result.data.data ? result.data.data : [];
        if (this.SRIDs && this.SRIDs.length === 1) {
          this.SRIDsId = this.SRIDs[0];
          this.srid = this.SRIDsId;
          if (this.srid && this.srid.includes('SR details are not being fetched at the moment')) {
            this.shouldShowLabel = false;
            this.$alertify.error('SR details are not being fetched at the moment.');
            return;
          }
          this.selectedSRIDnObj = { value: this.SRIDs[0], text: this.SRIDs[0] };
          this.getSRName(this.SRIDs[0]);
        } else {
          this.SRIDs = this.SRIDs.map(item => ({
            value: '',
            text: item
          }));
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      }).catch((error) => {
        this.isLoading = false;
        this.$alertify.error(error);
      });
    },
    selectedSRName(selectedOption) {
      this.selectedSRNamenObj = selectedOption;
      this.srname = (this.selectedSRNamenObj.text) ? this.selectedSRNamenObj.text : this.selectedSRNamenObj
    },
    getSRName(selectedSRIDnObj){
        this.isLoading = true;
        this.SRNameId = '';
        this.selectedSRNamenObj = {};
        let payload = ({
          shippingid : this.SalesDemo.ShippingID,
          srid : (selectedSRIDnObj.text) ? selectedSRIDnObj.text : selectedSRIDnObj
        })
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSRNameById',
          'data': payload,
          headers: commonFunction.getusertoken(),
        }).then(result => {
            this.isLoading = false;
            this.SRNames = result.data.data ? result.data.data : [];
            if (this.SRNames && this.SRNames.length === 1) {
              this.SRNameId = this.SRNames[0].srid;
              this.srname = this.SRNames[0].srname;
              if (this.srname && this.srname.includes('SR details are not being fetched at the moment')) {
                this.shouldShowLabel = false;
                this.$alertify.error('SR details are not being fetched at the moment.');
                return;
              }
              this.selectedSRNamenObj = { value: this.SRNames[0].srid, text: this.SRNames[0].srname};
            } else {
              this.SRNames = this.SRNames.map(item => ({
                value: item.srid,
                text: item.srname
              }));
            }
        },  error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        }).catch((error) => {
          this.isLoading = false; 
          this.$alertify.error(error);
        });
    },
    handleModalClose () {
      this.emailTrackingModal = false;
      if (this.$refs.trackingemailtracking) {
        this.$refs.trackingemailtracking.isPreview = false;
        // View Email Case Log Visibilty in Trackshipment summary
        this.$refs.trackingemailtracking.isEmailCaseLog = false;            // #common_fixes
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/trackshipmentsummary/trackshipmentsummary.component.js